/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcquirePrinterLockDto,
  AcquirePrinterLockResponseDto,
  AddExamsSalesInvoiceDto,
  AttachmentFileContent,
  CalculatePositionsResultDto,
  CalculateResultsDto,
  CancelJudgmentDto,
  CertificateResponseDto,
  ClientToken,
  CreateCertificateDto,
  CreateDeleteAttachmentsDto,
  CreateExamBlockDto,
  CreateForExamSynevoDto,
  CreatePrinterJpkDocumentDto,
  CreateUpdateAppointmentChannelDto,
  CreateUpdateArticleDto,
  CreateUpdateAttachmentDto,
  CreateUpdateBatteryDto,
  CreateUpdateCardDto,
  CreateUpdateCompanyDto,
  CreateUpdateConsultationDto,
  CreateUpdateDictionaryDto,
  CreateUpdateDutyDto,
  CreateUpdateExamDto,
  CreateUpdateExamTestDto,
  CreateUpdateExamTypeCategoryDto,
  CreateUpdateExamTypeDto,
  CreateUpdateExamTypeForChannelDto,
  CreateUpdateExamWithTestsDto,
  CreateUpdateExaminedDto,
  CreateUpdateExamsPackageDto,
  CreateUpdateExternalReferralDto,
  CreateUpdateFiscalPrinterLocationDto,
  CreateUpdateHarmfulFactorDto,
  CreateUpdateHealthcareFacilityDto,
  CreateUpdateImportedIndicatorTestDto,
  CreateUpdateIndicatorTestDto,
  CreateUpdateInvoiceIssuerDto,
  CreateUpdateInvoicePaymentDto,
  CreateUpdateInvoicePaymentLinkDto,
  CreateUpdateJobConfigDto,
  CreateUpdateJobPositionDto,
  CreateUpdateJudgmentDto,
  CreateUpdateJudgmentNumberingDto,
  CreateUpdateKeyTestDto,
  CreateUpdateKeyTestWithKeysDto,
  CreateUpdateManualDto,
  CreateUpdateNormWithValuesDto,
  CreateUpdateOtherPrintDefDto,
  CreateUpdateOtherPrintDto,
  CreateUpdateParamsDto,
  CreateUpdatePaymentCollectionDto,
  CreateUpdatePaymentDto,
  CreateUpdatePdfTemplateDto,
  CreateUpdatePricingDto,
  CreateUpdatePricingGroupDto,
  CreateUpdateReceiptDto,
  CreateUpdateRegisterNumberingDto,
  CreateUpdateResultDto,
  CreateUpdateResultsDto,
  CreateUpdateSalesInvoiceDto,
  CreateUpdateSalesInvoicePositionsDto,
  CreateUpdateSavedPdfDto,
  CreateUpdateSupportingExaminationDictDto,
  CreateUpdateSupportingExaminationDto,
  CreateUpdateTestDto,
  CreateUpdateUserDto,
  CreateUpdateUserInHealthcareFacilityDto,
  CreateUpdateVisitRegistrationDto,
  EFiscalDocumentDto,
  EmailPreviewDto,
  ExamDateDto,
  ExamSexDto,
  ExamTestDateDto,
  FilterData,
  FilterDownloadData,
  GenerateAutoSalesInvoiceDto,
  GenerateAutoSalesInvoiceResultDto,
  GenerateReceiptDto,
  GenerateReceiptResponseDto,
  GetAccessDto,
  GetAnswerDto,
  GetAppointmentChannelDto,
  GetArticleDto,
  GetArticleHarmfulFactorSuppExamDictDto,
  GetAttachmentDto,
  GetBatteryDto,
  GetBatteryWithTestsDto,
  GetCalendarDto,
  GetCardDto,
  GetCompanyDto,
  GetConsultationDto,
  GetCriticalPointDetailsDto,
  GetCriticalPointDto,
  GetCustomFieldsDto,
  GetDictionaryDto,
  GetDictionaryTypeDto,
  GetDocumentationDto,
  GetDutyDto,
  GetEmailDto,
  GetExamBlockDto,
  GetExamDto,
  GetExamTestDto,
  GetExamTypeCategoryDto,
  GetExamTypeDto,
  GetExamTypeForChannelDto,
  GetExaminedDto,
  GetExamsPackageDto,
  GetFiscalPrinterLocationDto,
  GetHarmfulFactorDto,
  GetHealthcareFacilityDto,
  GetIndicatorTestDto,
  GetIndicatorTestRecalculatedDto,
  GetIndicatorTestRecalculatedSimpleDto,
  GetInterpretationNormDto,
  GetInvoiceIssuerDto,
  GetInvoiceIssuerOptionDto,
  GetInvoicePaymentDto,
  GetInvoicePaymentLinkDto,
  GetJobConfigDto,
  GetJobPositionDto,
  GetJudgmentDto,
  GetJudgmentExtendedDto,
  GetJudgmentNumberingDto,
  GetJudgmentP1DocumentDto,
  GetJudgmentWithSignedInfoDto,
  GetKeyTestDto,
  GetKeyValueDto,
  GetLastEditorDto,
  GetManualDto,
  GetNormDto,
  GetOtherPrintDefDto,
  GetOtherPrintDto,
  GetParamsDto,
  GetPaymentCollectionDto,
  GetPaymentDto,
  GetPdfTemplateDto,
  GetPositionNormDto,
  GetPriceTypeDto,
  GetPricingDto,
  GetPricingGroupDto,
  GetPrinterJpkDocumentDto,
  GetPrinterTokenDto,
  GetReceiptDto,
  GetRegisterDto,
  GetRegisterNumberingDto,
  GetReportCompanyDto,
  GetReportConsultationDto,
  GetReportJudgmentDto,
  GetResultDto,
  GetResultForTestsDto,
  GetSalesInvoiceDto,
  GetSalesInvoicePositionDto,
  GetSavedPdfExternalReferralDto,
  GetSavedPdfSignatureStatusDto,
  GetStampDto,
  GetSupervisorsDto,
  GetSupportingExaminationDictDto,
  GetSupportingExaminationDto,
  GetSupportingExaminationPreviewDto,
  GetSynevoDto,
  GetSynevoExamCostSummaryDto,
  GetSynevoReportCompanyDto,
  GetSynevoSelectedCostDto,
  GetTestDto,
  GetUserDto,
  GetUserInHealthcareFacilityDto,
  GetUserPublicDto,
  GetVersionInfoDto,
  GetVisitRegistrationCalendarSlotDto,
  GetVisitRegistrationDto,
  GusClientDto,
  HighestJpkIdDto,
  InactivateJudgmentDto,
  InvoicePaymentControllerImportCsv200Response,
  LabelValue,
  LabelWith2ValuesValue,
  LabelWith3ValuesValue,
  LabelWith4CountsValue,
  MissingJpkIdsDto,
  OverdueInvoiceDebtDto,
  PfxPasswordDto,
  RegisterStatistics,
  ReleasePrinterLockDto,
  SaveLinksDto,
  SetFlagHealthcareFacilityDto,
  SetPrinterTokenDto,
  StatisticsSPD,
  SubmitSzafirSignedP1Dto,
  SupportingExaminationPreviewRequestDto,
  TopCompanyInvoicesDto,
  TopCompanyJudgmentsDto,
  UnlinkedPaymentsTotalDto,
  UploadCertificateUserDto,
  UploadStampsDto,
  XmlProtocolResponseDto,
} from '../models/index';
import {
    AcquirePrinterLockDtoFromJSON,
    AcquirePrinterLockDtoToJSON,
    AcquirePrinterLockResponseDtoFromJSON,
    AcquirePrinterLockResponseDtoToJSON,
    AddExamsSalesInvoiceDtoFromJSON,
    AddExamsSalesInvoiceDtoToJSON,
    AttachmentFileContentFromJSON,
    AttachmentFileContentToJSON,
    CalculatePositionsResultDtoFromJSON,
    CalculatePositionsResultDtoToJSON,
    CalculateResultsDtoFromJSON,
    CalculateResultsDtoToJSON,
    CancelJudgmentDtoFromJSON,
    CancelJudgmentDtoToJSON,
    CertificateResponseDtoFromJSON,
    CertificateResponseDtoToJSON,
    ClientTokenFromJSON,
    ClientTokenToJSON,
    CreateCertificateDtoFromJSON,
    CreateCertificateDtoToJSON,
    CreateDeleteAttachmentsDtoFromJSON,
    CreateDeleteAttachmentsDtoToJSON,
    CreateExamBlockDtoFromJSON,
    CreateExamBlockDtoToJSON,
    CreateForExamSynevoDtoFromJSON,
    CreateForExamSynevoDtoToJSON,
    CreatePrinterJpkDocumentDtoFromJSON,
    CreatePrinterJpkDocumentDtoToJSON,
    CreateUpdateAppointmentChannelDtoFromJSON,
    CreateUpdateAppointmentChannelDtoToJSON,
    CreateUpdateArticleDtoFromJSON,
    CreateUpdateArticleDtoToJSON,
    CreateUpdateAttachmentDtoFromJSON,
    CreateUpdateAttachmentDtoToJSON,
    CreateUpdateBatteryDtoFromJSON,
    CreateUpdateBatteryDtoToJSON,
    CreateUpdateCardDtoFromJSON,
    CreateUpdateCardDtoToJSON,
    CreateUpdateCompanyDtoFromJSON,
    CreateUpdateCompanyDtoToJSON,
    CreateUpdateConsultationDtoFromJSON,
    CreateUpdateConsultationDtoToJSON,
    CreateUpdateDictionaryDtoFromJSON,
    CreateUpdateDictionaryDtoToJSON,
    CreateUpdateDutyDtoFromJSON,
    CreateUpdateDutyDtoToJSON,
    CreateUpdateExamDtoFromJSON,
    CreateUpdateExamDtoToJSON,
    CreateUpdateExamTestDtoFromJSON,
    CreateUpdateExamTestDtoToJSON,
    CreateUpdateExamTypeCategoryDtoFromJSON,
    CreateUpdateExamTypeCategoryDtoToJSON,
    CreateUpdateExamTypeDtoFromJSON,
    CreateUpdateExamTypeDtoToJSON,
    CreateUpdateExamTypeForChannelDtoFromJSON,
    CreateUpdateExamTypeForChannelDtoToJSON,
    CreateUpdateExamWithTestsDtoFromJSON,
    CreateUpdateExamWithTestsDtoToJSON,
    CreateUpdateExaminedDtoFromJSON,
    CreateUpdateExaminedDtoToJSON,
    CreateUpdateExamsPackageDtoFromJSON,
    CreateUpdateExamsPackageDtoToJSON,
    CreateUpdateExternalReferralDtoFromJSON,
    CreateUpdateExternalReferralDtoToJSON,
    CreateUpdateFiscalPrinterLocationDtoFromJSON,
    CreateUpdateFiscalPrinterLocationDtoToJSON,
    CreateUpdateHarmfulFactorDtoFromJSON,
    CreateUpdateHarmfulFactorDtoToJSON,
    CreateUpdateHealthcareFacilityDtoFromJSON,
    CreateUpdateHealthcareFacilityDtoToJSON,
    CreateUpdateImportedIndicatorTestDtoFromJSON,
    CreateUpdateImportedIndicatorTestDtoToJSON,
    CreateUpdateIndicatorTestDtoFromJSON,
    CreateUpdateIndicatorTestDtoToJSON,
    CreateUpdateInvoiceIssuerDtoFromJSON,
    CreateUpdateInvoiceIssuerDtoToJSON,
    CreateUpdateInvoicePaymentDtoFromJSON,
    CreateUpdateInvoicePaymentDtoToJSON,
    CreateUpdateInvoicePaymentLinkDtoFromJSON,
    CreateUpdateInvoicePaymentLinkDtoToJSON,
    CreateUpdateJobConfigDtoFromJSON,
    CreateUpdateJobConfigDtoToJSON,
    CreateUpdateJobPositionDtoFromJSON,
    CreateUpdateJobPositionDtoToJSON,
    CreateUpdateJudgmentDtoFromJSON,
    CreateUpdateJudgmentDtoToJSON,
    CreateUpdateJudgmentNumberingDtoFromJSON,
    CreateUpdateJudgmentNumberingDtoToJSON,
    CreateUpdateKeyTestDtoFromJSON,
    CreateUpdateKeyTestDtoToJSON,
    CreateUpdateKeyTestWithKeysDtoFromJSON,
    CreateUpdateKeyTestWithKeysDtoToJSON,
    CreateUpdateManualDtoFromJSON,
    CreateUpdateManualDtoToJSON,
    CreateUpdateNormWithValuesDtoFromJSON,
    CreateUpdateNormWithValuesDtoToJSON,
    CreateUpdateOtherPrintDefDtoFromJSON,
    CreateUpdateOtherPrintDefDtoToJSON,
    CreateUpdateOtherPrintDtoFromJSON,
    CreateUpdateOtherPrintDtoToJSON,
    CreateUpdateParamsDtoFromJSON,
    CreateUpdateParamsDtoToJSON,
    CreateUpdatePaymentCollectionDtoFromJSON,
    CreateUpdatePaymentCollectionDtoToJSON,
    CreateUpdatePaymentDtoFromJSON,
    CreateUpdatePaymentDtoToJSON,
    CreateUpdatePdfTemplateDtoFromJSON,
    CreateUpdatePdfTemplateDtoToJSON,
    CreateUpdatePricingDtoFromJSON,
    CreateUpdatePricingDtoToJSON,
    CreateUpdatePricingGroupDtoFromJSON,
    CreateUpdatePricingGroupDtoToJSON,
    CreateUpdateReceiptDtoFromJSON,
    CreateUpdateReceiptDtoToJSON,
    CreateUpdateRegisterNumberingDtoFromJSON,
    CreateUpdateRegisterNumberingDtoToJSON,
    CreateUpdateResultDtoFromJSON,
    CreateUpdateResultDtoToJSON,
    CreateUpdateResultsDtoFromJSON,
    CreateUpdateResultsDtoToJSON,
    CreateUpdateSalesInvoiceDtoFromJSON,
    CreateUpdateSalesInvoiceDtoToJSON,
    CreateUpdateSalesInvoicePositionsDtoFromJSON,
    CreateUpdateSalesInvoicePositionsDtoToJSON,
    CreateUpdateSavedPdfDtoFromJSON,
    CreateUpdateSavedPdfDtoToJSON,
    CreateUpdateSupportingExaminationDictDtoFromJSON,
    CreateUpdateSupportingExaminationDictDtoToJSON,
    CreateUpdateSupportingExaminationDtoFromJSON,
    CreateUpdateSupportingExaminationDtoToJSON,
    CreateUpdateTestDtoFromJSON,
    CreateUpdateTestDtoToJSON,
    CreateUpdateUserDtoFromJSON,
    CreateUpdateUserDtoToJSON,
    CreateUpdateUserInHealthcareFacilityDtoFromJSON,
    CreateUpdateUserInHealthcareFacilityDtoToJSON,
    CreateUpdateVisitRegistrationDtoFromJSON,
    CreateUpdateVisitRegistrationDtoToJSON,
    EFiscalDocumentDtoFromJSON,
    EFiscalDocumentDtoToJSON,
    EmailPreviewDtoFromJSON,
    EmailPreviewDtoToJSON,
    ExamDateDtoFromJSON,
    ExamDateDtoToJSON,
    ExamSexDtoFromJSON,
    ExamSexDtoToJSON,
    ExamTestDateDtoFromJSON,
    ExamTestDateDtoToJSON,
    FilterDataFromJSON,
    FilterDataToJSON,
    FilterDownloadDataFromJSON,
    FilterDownloadDataToJSON,
    GenerateAutoSalesInvoiceDtoFromJSON,
    GenerateAutoSalesInvoiceDtoToJSON,
    GenerateAutoSalesInvoiceResultDtoFromJSON,
    GenerateAutoSalesInvoiceResultDtoToJSON,
    GenerateReceiptDtoFromJSON,
    GenerateReceiptDtoToJSON,
    GenerateReceiptResponseDtoFromJSON,
    GenerateReceiptResponseDtoToJSON,
    GetAccessDtoFromJSON,
    GetAccessDtoToJSON,
    GetAnswerDtoFromJSON,
    GetAnswerDtoToJSON,
    GetAppointmentChannelDtoFromJSON,
    GetAppointmentChannelDtoToJSON,
    GetArticleDtoFromJSON,
    GetArticleDtoToJSON,
    GetArticleHarmfulFactorSuppExamDictDtoFromJSON,
    GetArticleHarmfulFactorSuppExamDictDtoToJSON,
    GetAttachmentDtoFromJSON,
    GetAttachmentDtoToJSON,
    GetBatteryDtoFromJSON,
    GetBatteryDtoToJSON,
    GetBatteryWithTestsDtoFromJSON,
    GetBatteryWithTestsDtoToJSON,
    GetCalendarDtoFromJSON,
    GetCalendarDtoToJSON,
    GetCardDtoFromJSON,
    GetCardDtoToJSON,
    GetCompanyDtoFromJSON,
    GetCompanyDtoToJSON,
    GetConsultationDtoFromJSON,
    GetConsultationDtoToJSON,
    GetCriticalPointDetailsDtoFromJSON,
    GetCriticalPointDetailsDtoToJSON,
    GetCriticalPointDtoFromJSON,
    GetCriticalPointDtoToJSON,
    GetCustomFieldsDtoFromJSON,
    GetCustomFieldsDtoToJSON,
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoToJSON,
    GetDictionaryTypeDtoFromJSON,
    GetDictionaryTypeDtoToJSON,
    GetDocumentationDtoFromJSON,
    GetDocumentationDtoToJSON,
    GetDutyDtoFromJSON,
    GetDutyDtoToJSON,
    GetEmailDtoFromJSON,
    GetEmailDtoToJSON,
    GetExamBlockDtoFromJSON,
    GetExamBlockDtoToJSON,
    GetExamDtoFromJSON,
    GetExamDtoToJSON,
    GetExamTestDtoFromJSON,
    GetExamTestDtoToJSON,
    GetExamTypeCategoryDtoFromJSON,
    GetExamTypeCategoryDtoToJSON,
    GetExamTypeDtoFromJSON,
    GetExamTypeDtoToJSON,
    GetExamTypeForChannelDtoFromJSON,
    GetExamTypeForChannelDtoToJSON,
    GetExaminedDtoFromJSON,
    GetExaminedDtoToJSON,
    GetExamsPackageDtoFromJSON,
    GetExamsPackageDtoToJSON,
    GetFiscalPrinterLocationDtoFromJSON,
    GetFiscalPrinterLocationDtoToJSON,
    GetHarmfulFactorDtoFromJSON,
    GetHarmfulFactorDtoToJSON,
    GetHealthcareFacilityDtoFromJSON,
    GetHealthcareFacilityDtoToJSON,
    GetIndicatorTestDtoFromJSON,
    GetIndicatorTestDtoToJSON,
    GetIndicatorTestRecalculatedDtoFromJSON,
    GetIndicatorTestRecalculatedDtoToJSON,
    GetIndicatorTestRecalculatedSimpleDtoFromJSON,
    GetIndicatorTestRecalculatedSimpleDtoToJSON,
    GetInterpretationNormDtoFromJSON,
    GetInterpretationNormDtoToJSON,
    GetInvoiceIssuerDtoFromJSON,
    GetInvoiceIssuerDtoToJSON,
    GetInvoiceIssuerOptionDtoFromJSON,
    GetInvoiceIssuerOptionDtoToJSON,
    GetInvoicePaymentDtoFromJSON,
    GetInvoicePaymentDtoToJSON,
    GetInvoicePaymentLinkDtoFromJSON,
    GetInvoicePaymentLinkDtoToJSON,
    GetJobConfigDtoFromJSON,
    GetJobConfigDtoToJSON,
    GetJobPositionDtoFromJSON,
    GetJobPositionDtoToJSON,
    GetJudgmentDtoFromJSON,
    GetJudgmentDtoToJSON,
    GetJudgmentExtendedDtoFromJSON,
    GetJudgmentExtendedDtoToJSON,
    GetJudgmentNumberingDtoFromJSON,
    GetJudgmentNumberingDtoToJSON,
    GetJudgmentP1DocumentDtoFromJSON,
    GetJudgmentP1DocumentDtoToJSON,
    GetJudgmentWithSignedInfoDtoFromJSON,
    GetJudgmentWithSignedInfoDtoToJSON,
    GetKeyTestDtoFromJSON,
    GetKeyTestDtoToJSON,
    GetKeyValueDtoFromJSON,
    GetKeyValueDtoToJSON,
    GetLastEditorDtoFromJSON,
    GetLastEditorDtoToJSON,
    GetManualDtoFromJSON,
    GetManualDtoToJSON,
    GetNormDtoFromJSON,
    GetNormDtoToJSON,
    GetOtherPrintDefDtoFromJSON,
    GetOtherPrintDefDtoToJSON,
    GetOtherPrintDtoFromJSON,
    GetOtherPrintDtoToJSON,
    GetParamsDtoFromJSON,
    GetParamsDtoToJSON,
    GetPaymentCollectionDtoFromJSON,
    GetPaymentCollectionDtoToJSON,
    GetPaymentDtoFromJSON,
    GetPaymentDtoToJSON,
    GetPdfTemplateDtoFromJSON,
    GetPdfTemplateDtoToJSON,
    GetPositionNormDtoFromJSON,
    GetPositionNormDtoToJSON,
    GetPriceTypeDtoFromJSON,
    GetPriceTypeDtoToJSON,
    GetPricingDtoFromJSON,
    GetPricingDtoToJSON,
    GetPricingGroupDtoFromJSON,
    GetPricingGroupDtoToJSON,
    GetPrinterJpkDocumentDtoFromJSON,
    GetPrinterJpkDocumentDtoToJSON,
    GetPrinterTokenDtoFromJSON,
    GetPrinterTokenDtoToJSON,
    GetReceiptDtoFromJSON,
    GetReceiptDtoToJSON,
    GetRegisterDtoFromJSON,
    GetRegisterDtoToJSON,
    GetRegisterNumberingDtoFromJSON,
    GetRegisterNumberingDtoToJSON,
    GetReportCompanyDtoFromJSON,
    GetReportCompanyDtoToJSON,
    GetReportConsultationDtoFromJSON,
    GetReportConsultationDtoToJSON,
    GetReportJudgmentDtoFromJSON,
    GetReportJudgmentDtoToJSON,
    GetResultDtoFromJSON,
    GetResultDtoToJSON,
    GetResultForTestsDtoFromJSON,
    GetResultForTestsDtoToJSON,
    GetSalesInvoiceDtoFromJSON,
    GetSalesInvoiceDtoToJSON,
    GetSalesInvoicePositionDtoFromJSON,
    GetSalesInvoicePositionDtoToJSON,
    GetSavedPdfExternalReferralDtoFromJSON,
    GetSavedPdfExternalReferralDtoToJSON,
    GetSavedPdfSignatureStatusDtoFromJSON,
    GetSavedPdfSignatureStatusDtoToJSON,
    GetStampDtoFromJSON,
    GetStampDtoToJSON,
    GetSupervisorsDtoFromJSON,
    GetSupervisorsDtoToJSON,
    GetSupportingExaminationDictDtoFromJSON,
    GetSupportingExaminationDictDtoToJSON,
    GetSupportingExaminationDtoFromJSON,
    GetSupportingExaminationDtoToJSON,
    GetSupportingExaminationPreviewDtoFromJSON,
    GetSupportingExaminationPreviewDtoToJSON,
    GetSynevoDtoFromJSON,
    GetSynevoDtoToJSON,
    GetSynevoExamCostSummaryDtoFromJSON,
    GetSynevoExamCostSummaryDtoToJSON,
    GetSynevoReportCompanyDtoFromJSON,
    GetSynevoReportCompanyDtoToJSON,
    GetSynevoSelectedCostDtoFromJSON,
    GetSynevoSelectedCostDtoToJSON,
    GetTestDtoFromJSON,
    GetTestDtoToJSON,
    GetUserDtoFromJSON,
    GetUserDtoToJSON,
    GetUserInHealthcareFacilityDtoFromJSON,
    GetUserInHealthcareFacilityDtoToJSON,
    GetUserPublicDtoFromJSON,
    GetUserPublicDtoToJSON,
    GetVersionInfoDtoFromJSON,
    GetVersionInfoDtoToJSON,
    GetVisitRegistrationCalendarSlotDtoFromJSON,
    GetVisitRegistrationCalendarSlotDtoToJSON,
    GetVisitRegistrationDtoFromJSON,
    GetVisitRegistrationDtoToJSON,
    GusClientDtoFromJSON,
    GusClientDtoToJSON,
    HighestJpkIdDtoFromJSON,
    HighestJpkIdDtoToJSON,
    InactivateJudgmentDtoFromJSON,
    InactivateJudgmentDtoToJSON,
    InvoicePaymentControllerImportCsv200ResponseFromJSON,
    InvoicePaymentControllerImportCsv200ResponseToJSON,
    LabelValueFromJSON,
    LabelValueToJSON,
    LabelWith2ValuesValueFromJSON,
    LabelWith2ValuesValueToJSON,
    LabelWith3ValuesValueFromJSON,
    LabelWith3ValuesValueToJSON,
    LabelWith4CountsValueFromJSON,
    LabelWith4CountsValueToJSON,
    MissingJpkIdsDtoFromJSON,
    MissingJpkIdsDtoToJSON,
    OverdueInvoiceDebtDtoFromJSON,
    OverdueInvoiceDebtDtoToJSON,
    PfxPasswordDtoFromJSON,
    PfxPasswordDtoToJSON,
    RegisterStatisticsFromJSON,
    RegisterStatisticsToJSON,
    ReleasePrinterLockDtoFromJSON,
    ReleasePrinterLockDtoToJSON,
    SaveLinksDtoFromJSON,
    SaveLinksDtoToJSON,
    SetFlagHealthcareFacilityDtoFromJSON,
    SetFlagHealthcareFacilityDtoToJSON,
    SetPrinterTokenDtoFromJSON,
    SetPrinterTokenDtoToJSON,
    StatisticsSPDFromJSON,
    StatisticsSPDToJSON,
    SubmitSzafirSignedP1DtoFromJSON,
    SubmitSzafirSignedP1DtoToJSON,
    SupportingExaminationPreviewRequestDtoFromJSON,
    SupportingExaminationPreviewRequestDtoToJSON,
    TopCompanyInvoicesDtoFromJSON,
    TopCompanyInvoicesDtoToJSON,
    TopCompanyJudgmentsDtoFromJSON,
    TopCompanyJudgmentsDtoToJSON,
    UnlinkedPaymentsTotalDtoFromJSON,
    UnlinkedPaymentsTotalDtoToJSON,
    UploadCertificateUserDtoFromJSON,
    UploadCertificateUserDtoToJSON,
    UploadStampsDtoFromJSON,
    UploadStampsDtoToJSON,
    XmlProtocolResponseDtoFromJSON,
    XmlProtocolResponseDtoToJSON,
} from '../models/index';

export interface AccessControllerCheckAccessRequest {
    device: string;
}

export interface AccessControllerGetRequest {
    id: string;
}

export interface AccessControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface AccessControllerGetAllCountRequest {
    filterText: string;
}

export interface AnswerControllerGetRequest {
    id: string;
}

export interface AnswerControllerGetIntellectualAbilityTextRequest {
    examId: string;
}

export interface AnswerControllerGetIntellectualPsychomotorEfficiencyTextRequest {
    examId: string;
}

export interface AnswerControllerGetInterviewTextRequest {
    examId: string;
}

export interface AnswerControllerGetPersonalityTextRequest {
    examId: string;
}

export interface AppointmentChannelControllerChangeToInactiveRequest {
    id: string;
}

export interface AppointmentChannelControllerCreateRequest {
    createUpdateAppointmentChannelDto: CreateUpdateAppointmentChannelDto;
}

export interface AppointmentChannelControllerGetRequest {
    id: string;
}

export interface AppointmentChannelControllerGetAllRequest {
    healthcareId?: string;
}

export interface AppointmentChannelControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
}

export interface AppointmentChannelControllerGetAllCountRequest {
    filterText: string;
}

export interface AppointmentChannelControllerGetLastEditorRequest {
    id: string;
}

export interface AppointmentChannelControllerUpdateRequest {
    id: string;
    createUpdateAppointmentChannelDto: CreateUpdateAppointmentChannelDto;
}

export interface ArticleControllerChangeToInactiveRequest {
    id: string;
}

export interface ArticleControllerCreateRequest {
    createUpdateArticleDto: CreateUpdateArticleDto;
}

export interface ArticleControllerGetRequest {
    id: string;
}

export interface ArticleControllerGetAllRequest {
    mode?: string;
}

export interface ArticleControllerGetLastEditorRequest {
    id: string;
}

export interface ArticleControllerUpdateRequest {
    id: string;
    createUpdateArticleDto: CreateUpdateArticleDto;
}

export interface ArticleHarmfulFactorSuppExamDictControllerGetByArticleRequest {
    id: string;
}

export interface AttachmentControllerAddDeleteAttachmentsRequest {
    createDeleteAttachmentsDto: CreateDeleteAttachmentsDto;
}

export interface AttachmentControllerCreateRequest {
    createUpdateAttachmentDto: CreateUpdateAttachmentDto;
}

export interface AttachmentControllerDeleteRequest {
    id: string;
}

export interface AttachmentControllerGetRequest {
    id: string;
}

export interface AttachmentControllerGetAllForExaminedRequest {
    examinedId: string;
}

export interface AttachmentControllerGetFileDownloadRequest {
    id: string;
}

export interface AttachmentControllerGetLastEditorRequest {
    id: string;
}

export interface AttachmentControllerRunAttachmentMigrationRequest {
    batchSize?: number;
    delayMs?: number;
    maxRecords?: number;
    filterType?: AttachmentControllerRunAttachmentMigrationFilterTypeEnum;
    maxFileSizeMb?: number;
}

export interface AttachmentControllerUpdateRequest {
    id: string;
    createUpdateAttachmentDto: CreateUpdateAttachmentDto;
}

export interface BatteryControllerCreateRequest {
    createUpdateBatteryDto: CreateUpdateBatteryDto;
}

export interface BatteryControllerGetRequest {
    id: string;
}

export interface BatteryControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface BatteryControllerGetAllCountRequest {
    filterText: string;
}

export interface BatteryControllerGetLastEditorRequest {
    id: string;
}

export interface BatteryControllerUpdateRequest {
    id: string;
    createUpdateBatteryDto: CreateUpdateBatteryDto;
}

export interface CalendarControllerAddDayRequest {
    date: string;
}

export interface CalendarControllerCreateYearRequest {
    date: string;
}

export interface CalendarControllerGetAllForYearRequest {
    year: string;
}

export interface CalendarControllerRemoveDayRequest {
    date: string;
}

export interface CardControllerCreateRequest {
    createUpdateCardDto: CreateUpdateCardDto;
}

export interface CardControllerFixNormsOnCardsRequest {
    cardDateAfter: string;
    commit?: string;
}

export interface CardControllerGetRequest {
    id: string;
}

export interface CardControllerGetAllAutomaticByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface CardControllerGetAllAutomaticCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface CardControllerGetAllByExamRequest {
    examId: string;
}

export interface CardControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface CardControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface CardControllerGetAllForUserToSignRequest {
    userUid?: string;
}

export interface CardControllerGetByExamRequest {
    examId: string;
    type: string;
}

export interface CardControllerGetForSigningByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    userUid?: string;
}

export interface CardControllerGetForSigningCountRequest {
    filterText: string;
    userUid?: string;
}

export interface CardControllerGetLastEditorRequest {
    id: string;
}

export interface CardControllerUpdateRequest {
    id: string;
    createUpdateCardDto: CreateUpdateCardDto;
}

export interface CertificateAuthorityControllerDownloadCertificateWithKeyRequest {
    id: string;
    pfxPasswordDto: PfxPasswordDto;
}

export interface CertificateAuthorityControllerGenerateCertificateRequest {
    createCertificateDto: CreateCertificateDto;
}

export interface CertificateAuthorityControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
}

export interface CertificateAuthorityControllerGetAllCountRequest {
    filterText: string;
}

export interface CompanyControllerCreateRequest {
    createUpdateCompanyDto: CreateUpdateCompanyDto;
}

export interface CompanyControllerDeleteExpectationExamsRequest {
    id: string;
}

export interface CompanyControllerGetRequest {
    id: string;
}

export interface CompanyControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    monthlySettlement?: boolean;
    invoicesSettlement?: boolean;
    externalReferral?: boolean;
}

export interface CompanyControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
    monthlySettlement?: boolean;
    invoicesSettlement?: boolean;
    externalReferral?: boolean;
}

export interface CompanyControllerGetByEmailRequest {
    pattern: string;
    limit: number;
}

export interface CompanyControllerGetByNipRequest {
    pattern: string;
    limit: number;
}

export interface CompanyControllerGetByNipOrNameRequest {
    pattern: string;
    limit: number;
}

export interface CompanyControllerGetByPatternRequest {
    pattern: string;
    limit: number;
}

export interface CompanyControllerGetLastEditorRequest {
    id: string;
}

export interface CompanyControllerUpdateRequest {
    id: string;
    createUpdateCompanyDto: CreateUpdateCompanyDto;
}

export interface ConsultationControllerCreateRequest {
    createUpdateConsultationDto: CreateUpdateConsultationDto;
}

export interface ConsultationControllerGetRequest {
    id: string;
}

export interface ConsultationControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface ConsultationControllerGetAllCountRequest {
    filterText: string;
}

export interface ConsultationControllerGetForExamRequest {
    id: string;
}

export interface ConsultationControllerGetLastEditorRequest {
    id: string;
}

export interface ConsultationControllerUpdateRequest {
    id: string;
    createUpdateConsultationDto: CreateUpdateConsultationDto;
}

export interface CustomFieldsControllerGetRequest {
    id: string;
}

export interface DictionaryControllerChangeToInactiveRequest {
    id: string;
}

export interface DictionaryControllerCreateRequest {
    createUpdateDictionaryDto: CreateUpdateDictionaryDto;
}

export interface DictionaryControllerGetRequest {
    id: string;
}

export interface DictionaryControllerGetByTypeRequest {
    type: string;
}

export interface DictionaryControllerGetByTypeAndShortnameRequest {
    type: string;
    symbol: string;
}

export interface DictionaryControllerGetLastEditorRequest {
    id: string;
}

export interface DictionaryControllerUpdateRequest {
    id: string;
    createUpdateDictionaryDto: CreateUpdateDictionaryDto;
}

export interface DictionaryTypeControllerGetRequest {
    id: string;
}

export interface DocumentationControllerGetExternalFileRequest {
    address: string;
}

export interface DocumentationControllerGetForFilenameRequest {
    filename: string;
}

export interface DownloadsFilesControllerDownloadsFilesCompanySummaryRequest {
    filename: string;
    filterDownloadData: FilterDownloadData;
}

export interface DownloadsFilesControllerDownloadsSalesInvoicesRequest {
    filename: string;
    filterDownloadData: FilterDownloadData;
}

export interface DutyControllerCreateRequest {
    createUpdateDutyDto: CreateUpdateDutyDto;
}

export interface DutyControllerGetRequest {
    id: string;
}

export interface DutyControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface DutyControllerGetAllCountRequest {
    filterText: string;
}

export interface DutyControllerUpdateRequest {
    id: string;
    createUpdateDutyDto: CreateUpdateDutyDto;
}

export interface EmailControllerChangeToInactiveRequest {
    id: string;
}

export interface EmailControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    onlyNotSent: boolean;
}

export interface EmailControllerGetAllCountRequest {
    filterText: string;
    onlyNotSent: boolean;
}

export interface EmailControllerPreviewRequest {
    id: string;
}

export interface EmailControllerResendEmailRequest {
    id: string;
    toOverride: string;
}

export interface EmailControllerSendJudgmentByEmailRequest {
    judgmentId: string;
    english: boolean;
}

export interface EmailControllerSendPsychologicalCardSummaryRequest {
    cardId: string;
}

export interface EmailControllerSendReferralByEmailRequest {
    referralId: string;
}

export interface ExamBlockControllerBlockRequest {
    examId: string;
    createExamBlockDto: CreateExamBlockDto;
}

export interface ExamBlockControllerGetActiveRequest {
    examId: string;
}

export interface ExamBlockControllerGetForExamRequest {
    examId: string;
}

export interface ExamBlockControllerGetLastEditorRequest {
    id: string;
}

export interface ExamBlockControllerUnblockRequest {
    examId: string;
}

export interface ExamBlockControllerUpdateRequest {
    examId: string;
    createExamBlockDto: CreateExamBlockDto;
}

export interface ExamControllerAlarmRequest {
    id: string;
}

export interface ExamControllerChangeDatesRequest {
    id: string;
    examDateDto: ExamDateDto;
}

export interface ExamControllerChangeSexRequest {
    id: string;
    examSexDto: ExamSexDto;
}

export interface ExamControllerChangeToInactiveRequest {
    id: string;
}

export interface ExamControllerCreateWithTestsRequest {
    createUpdateExamWithTestsDto: CreateUpdateExamWithTestsDto;
}

export interface ExamControllerGetRequest {
    id: string;
}

export interface ExamControllerGetActiveByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    type?: string;
}

export interface ExamControllerGetActiveCountRequest {
    filterText: string;
    type?: string;
}

export interface ExamControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    type?: string;
    onlyRemote?: boolean;
    onlyActive?: string;
    forFacility?: string;
    healthcareFacilityId?: string;
    companyId?: string;
    dateFrom?: string;
    dateTo?: string;
    withoutInvoiceAndReceipt?: string;
    completed?: string;
}

export interface ExamControllerGetAllByTestByPortionRequest {
    testId: string;
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    completed?: string;
}

export interface ExamControllerGetAllByTestCountRequest {
    testId: string;
    filterText: string;
    filterColumns?: string;
    completed?: string;
}

export interface ExamControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
    type?: string;
    onlyRemote?: boolean;
    onlyActive?: string;
    forFacility?: string;
    healthcareFacilityId?: string;
    companyId?: string;
    dateFrom?: string;
    dateTo?: string;
    withoutInvoiceAndReceipt?: string;
    completed?: string;
}

export interface ExamControllerGetAllIdsRequest {
    filterText?: string;
    filterColumns?: string;
    onlyActive?: string;
    companyId?: string;
    dateFrom?: string;
    dateTo?: string;
    withoutInvoiceAndReceipt?: string;
    completed?: string;
}

export interface ExamControllerGetBlockedByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    type?: ExamControllerGetBlockedByPortionTypeEnum;
}

export interface ExamControllerGetBlockedCountRequest {
    filterText: string;
    filterColumns?: string;
    type?: ExamControllerGetBlockedCountTypeEnum;
}

export interface ExamControllerGetCriticalPointRequest {
    id: string;
}

export interface ExamControllerGetCriticalPointDetailsRequest {
    id: string;
}

export interface ExamControllerGetExamsWithAutoJudgmentWithoutPaymentByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface ExamControllerGetExamsWithAutoJudgmentWithoutPaymentCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface ExamControllerGetForAutomaticJudgmentByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface ExamControllerGetForAutomaticJudgmentCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface ExamControllerGetForExaminedByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    examinedId?: string;
}

export interface ExamControllerGetForExaminedCountRequest {
    filterText: string;
    examinedId?: string;
}

export interface ExamControllerGetForPackageByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    examPackageId?: string;
}

export interface ExamControllerGetForPackageCountRequest {
    filterText: string;
    examPackageId?: string;
}

export interface ExamControllerGetForSalesInvoiceByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    salesInvoiceId: string;
}

export interface ExamControllerGetForSalesInvoiceCountRequest {
    filterText: string;
    salesInvoiceId: string;
}

export interface ExamControllerGetForSpecialistByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    type?: string;
}

export interface ExamControllerGetForSpecialistCountRequest {
    filterText: string;
    filterColumns?: string;
    type?: string;
}

export interface ExamControllerGetLastEditorRequest {
    id: string;
}

export interface ExamControllerGetSupervisorsRequest {
    id: string;
}

export interface ExamControllerGetSupportingExaminationPreviewRequest {
    supportingExaminationPreviewRequestDto: SupportingExaminationPreviewRequestDto;
}

export interface ExamControllerGetSupportingExaminationPreviewByExamRequest {
    id: string;
}

export interface ExamControllerGetWithExaminedByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    type?: string;
}

export interface ExamControllerGetWithExaminedCountRequest {
    filterText: string;
    filterColumns?: string;
    type?: string;
}

export interface ExamControllerGetWithoutJudgmentByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    type?: string;
    onlyRemote?: boolean;
    forFacility?: string;
    healthcareFacilityId?: string;
}

export interface ExamControllerGetWithoutJudgmentCountRequest {
    filterText: string;
    filterColumns?: string;
    type?: string;
    onlyRemote?: boolean;
    forFacility?: string;
    healthcareFacilityId?: string;
}

export interface ExamControllerGetWithoutJudgmentWithoutReferralsByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    type?: string;
}

export interface ExamControllerGetWithoutJudgmentWithoutReferralsCountRequest {
    filterText: string;
    filterColumns?: string;
    type?: string;
}

export interface ExamControllerSetOnlineRequest {
    id: string;
}

export interface ExamControllerUpdateRequest {
    id: string;
    createUpdateExamDto: CreateUpdateExamDto;
}

export interface ExamControllerUpdateWithTestsRequest {
    examId: string;
    createUpdateExamWithTestsDto: CreateUpdateExamWithTestsDto;
}

export interface ExamTestControllerChangeDatesRequest {
    examId: string;
    testId: string;
    examTestDateDto: ExamTestDateDto;
}

export interface ExamTestControllerCreateRequest {
    createUpdateExamTestDto: CreateUpdateExamTestDto;
}

export interface ExamTestControllerGetRequest {
    id: string;
}

export interface ExamTestControllerGetByExamRequest {
    examId: string;
}

export interface ExamTestControllerGetForExamByPortionRequest {
    exam: string;
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface ExamTestControllerGetForExamCountRequest {
    exam: string;
    filterText: string;
}

export interface ExamTestControllerUpdateRequest {
    id: string;
    createUpdateExamTestDto: CreateUpdateExamTestDto;
}

export interface ExamTypeCategoryControllerChangeToInactiveRequest {
    id: string;
}

export interface ExamTypeCategoryControllerCreateRequest {
    createUpdateExamTypeCategoryDto: CreateUpdateExamTypeCategoryDto;
}

export interface ExamTypeCategoryControllerGetRequest {
    id: string;
}

export interface ExamTypeCategoryControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
}

export interface ExamTypeCategoryControllerGetAllCountRequest {
    filterText: string;
}

export interface ExamTypeCategoryControllerGetLastEditorRequest {
    id: string;
}

export interface ExamTypeCategoryControllerUpdateRequest {
    id: string;
    createUpdateExamTypeCategoryDto: CreateUpdateExamTypeCategoryDto;
}

export interface ExamTypeControllerChangeToInactiveRequest {
    id: string;
}

export interface ExamTypeControllerCreateRequest {
    createUpdateExamTypeDto: CreateUpdateExamTypeDto;
}

export interface ExamTypeControllerGetRequest {
    id: string;
}

export interface ExamTypeControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
}

export interface ExamTypeControllerGetAllCountRequest {
    filterText: string;
}

export interface ExamTypeControllerGetLastEditorRequest {
    id: string;
}

export interface ExamTypeControllerUpdateRequest {
    id: string;
    createUpdateExamTypeDto: CreateUpdateExamTypeDto;
}

export interface ExamTypeForChannelControllerCreateRequest {
    createUpdateExamTypeForChannelDto: CreateUpdateExamTypeForChannelDto;
}

export interface ExamTypeForChannelControllerGetRequest {
    id: string;
}

export interface ExamTypeForChannelControllerUpdateRequest {
    id: string;
    createUpdateExamTypeForChannelDto: CreateUpdateExamTypeForChannelDto;
}

export interface ExaminedControllerChangeToInactiveRequest {
    id: string;
}

export interface ExaminedControllerCreateRequest {
    createUpdateExaminedDto: CreateUpdateExaminedDto;
}

export interface ExaminedControllerGetRequest {
    id: string;
}

export interface ExaminedControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface ExaminedControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface ExaminedControllerGetByPeselOrNameRequest {
    pattern: string;
    limit: number;
}

export interface ExaminedControllerGetCitiesByPatternRequest {
    pattern: string;
    limit: number;
}

export interface ExaminedControllerGetCityByPostCodeRequest {
    postcode: string;
}

export interface ExaminedControllerGetLastEditorRequest {
    id: string;
}

export interface ExaminedControllerGetStreetsByPatternRequest {
    pattern: string;
    limit: number;
}

export interface ExaminedControllerMergeExaminedRequest {
    examinedDeleteId: string;
    examinedStayId: string;
}

export interface ExaminedControllerUpdateRequest {
    id: string;
    createUpdateExaminedDto: CreateUpdateExaminedDto;
}

export interface ExamsPackageControllerDeleteExpectationExamsRequest {
    id: string;
}

export interface ExamsPackageControllerGetRequest {
    id: string;
}

export interface ExamsPackageControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    type?: string;
    onlyWithWaitingExams?: boolean;
}

export interface ExamsPackageControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
    type?: string;
    onlyWithWaitingExams?: boolean;
}

export interface ExamsPackageControllerGetExpectationPinsRequest {
    id: string;
}

export interface ExamsPackageControllerGetLastEditorRequest {
    id: string;
}

export interface ExamsPackageControllerUpdateRequest {
    id: string;
    createUpdateExamsPackageDto: CreateUpdateExamsPackageDto;
}

export interface ExportControllerExportTestResultsRequest {
    ident: string;
}

export interface ExternalReferralControllerCreateRequest {
    createUpdateExternalReferralDto: CreateUpdateExternalReferralDto;
}

export interface ExternalReferralControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    companyId?: string;
    filterColumns?: string;
}

export interface ExternalReferralControllerGetAllCountRequest {
    filterText: string;
    companyId?: string;
    filterColumns?: string;
}

export interface ExternalReferralControllerGetByCompaniesByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface ExternalReferralControllerGetByCompaniesCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface ExternalReferralControllerGetWithoutJudgmentsByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    companyId?: string;
    filterColumns?: string;
}

export interface ExternalReferralControllerGetWithoutJudgmentsCountRequest {
    filterText: string;
    companyId?: string;
    filterColumns?: string;
}

export interface FiscalPrinterControllerGenerateAndPrintReceiptRequest {
    generateReceiptDto: GenerateReceiptDto;
}

export interface FiscalPrinterLocationControllerAcquireLockRequest {
    acquirePrinterLockDto: AcquirePrinterLockDto;
}

export interface FiscalPrinterLocationControllerCreateRequest {
    createUpdateFiscalPrinterLocationDto: CreateUpdateFiscalPrinterLocationDto;
}

export interface FiscalPrinterLocationControllerDeleteRequest {
    id: string;
}

export interface FiscalPrinterLocationControllerGetRequest {
    id: string;
}

export interface FiscalPrinterLocationControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface FiscalPrinterLocationControllerGetAllCountRequest {
    filterText: string;
}

export interface FiscalPrinterLocationControllerGetTokenRequest {
    url: string;
}

export interface FiscalPrinterLocationControllerReleaseLockRequest {
    releasePrinterLockDto: ReleasePrinterLockDto;
}

export interface FiscalPrinterLocationControllerSetTokenRequest {
    setPrinterTokenDto: SetPrinterTokenDto;
}

export interface FiscalPrinterLocationControllerUpdateRequest {
    id: string;
    createUpdateFiscalPrinterLocationDto: CreateUpdateFiscalPrinterLocationDto;
}

export interface GusApiControllerGetByNipRequest {
    nip: string;
}

export interface HarmfulFactorControllerCreateRequest {
    createUpdateHarmfulFactorDto: CreateUpdateHarmfulFactorDto;
}

export interface HarmfulFactorControllerGetRequest {
    id: string;
}

export interface HarmfulFactorControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface HarmfulFactorControllerGetAllCountRequest {
    filterText: string;
}

export interface HarmfulFactorControllerGetLastEditorRequest {
    id: string;
}

export interface HarmfulFactorControllerUpdateRequest {
    id: string;
    createUpdateHarmfulFactorDto: CreateUpdateHarmfulFactorDto;
}

export interface HealthcareFacilityControllerCreateRequest {
    createUpdateHealthcareFacilityDto: CreateUpdateHealthcareFacilityDto;
}

export interface HealthcareFacilityControllerGetRequest {
    id: string;
}

export interface HealthcareFacilityControllerGetAllRequest {
    canSeeAll?: boolean;
}

export interface HealthcareFacilityControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface HealthcareFacilityControllerGetAllCountRequest {
    filterText: string;
}

export interface HealthcareFacilityControllerGetAllHistoricalByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface HealthcareFacilityControllerGetAllHistoricalCountRequest {
    filterText: string;
}

export interface HealthcareFacilityControllerGetLastEditorRequest {
    id: string;
}

export interface HealthcareFacilityControllerGetWithDataIdRequest {
    id: string;
    dataId: string;
}

export interface HealthcareFacilityControllerSetFlagRequest {
    id: string;
    setFlagHealthcareFacilityDto: SetFlagHealthcareFacilityDto;
}

export interface HealthcareFacilityControllerUpdateRequest {
    id: string;
    createUpdateHealthcareFacilityDto: CreateUpdateHealthcareFacilityDto;
}

export interface IndicatorTestControllerCalculateResultsRequest {
    testFileName: string;
    calculateResultsDto: CalculateResultsDto;
}

export interface IndicatorTestControllerCreateRequest {
    createUpdateIndicatorTestDto: CreateUpdateIndicatorTestDto;
}

export interface IndicatorTestControllerCreateImportedRequest {
    createUpdateImportedIndicatorTestDto: CreateUpdateImportedIndicatorTestDto;
}

export interface IndicatorTestControllerDeleteRequest {
    id: string;
}

export interface IndicatorTestControllerGetRequest {
    id: string;
}

export interface IndicatorTestControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface IndicatorTestControllerGetAllCountRequest {
    filterText: string;
}

export interface IndicatorTestControllerGetByExamTestRequest {
    examTestId: string;
}

export interface IndicatorTestControllerUpdateRequest {
    id: string;
    createUpdateIndicatorTestDto: CreateUpdateIndicatorTestDto;
}

export interface InterpretationNormControllerGetByNormRequest {
    normId: string;
}

export interface InterpretationNormControllerGetByNormCountRequest {
    normId: string;
}

export interface InvoiceIssuerControllerCreateRequest {
    createUpdateInvoiceIssuerDto: CreateUpdateInvoiceIssuerDto;
}

export interface InvoiceIssuerControllerGetRequest {
    id: string;
}

export interface InvoiceIssuerControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface InvoiceIssuerControllerGetAllCountRequest {
    filterText: string;
}

export interface InvoiceIssuerControllerUpdateRequest {
    id: string;
    createUpdateInvoiceIssuerDto: CreateUpdateInvoiceIssuerDto;
}

export interface InvoicePaymentControllerCreateRequest {
    createUpdateInvoicePaymentDto: CreateUpdateInvoicePaymentDto;
}

export interface InvoicePaymentControllerCreateLinkRequest {
    createUpdateInvoicePaymentLinkDto: CreateUpdateInvoicePaymentLinkDto;
}

export interface InvoicePaymentControllerCreateSingleRequest {
    createUpdateInvoicePaymentDto: CreateUpdateInvoicePaymentDto;
}

export interface InvoicePaymentControllerDeleteLinkRequest {
    id: string;
}

export interface InvoicePaymentControllerGetRequest {
    id: string;
}

export interface InvoicePaymentControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
    filterColumns?: string;
    collectionId?: string;
    onlyWithUnlinkedAmount?: string;
    onlyFullyLinked?: string;
    companyId?: string;
}

export interface InvoicePaymentControllerGetAllCountRequest {
    filterText?: string;
    filterColumns?: string;
    collectionId?: string;
    onlyWithUnlinkedAmount?: string;
    onlyFullyLinked?: string;
    companyId?: string;
}

export interface InvoicePaymentControllerGetLinksByInvoiceIdRequest {
    id: string;
}

export interface InvoicePaymentControllerGetLinksByPaymentIdRequest {
    id: string;
}

export interface InvoicePaymentControllerImportCsvRequest {
    file?: Blob;
    collectionName?: string;
}

export interface InvoicePaymentControllerSaveLinksRequest {
    id: string;
    saveLinksDto: SaveLinksDto;
}

export interface InvoicePaymentControllerUpdateRequest {
    id: string;
    createUpdateInvoicePaymentDto: CreateUpdateInvoicePaymentDto;
}

export interface JobConfigControllerCreateRequest {
    createUpdateJobConfigDto: CreateUpdateJobConfigDto;
}

export interface JobConfigControllerGetRequest {
    id: string;
}

export interface JobConfigControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface JobConfigControllerGetAllCountRequest {
    filterText: string;
}

export interface JobConfigControllerGetByJobNameRequest {
    jobName: string;
}

export interface JobConfigControllerGetLastEditorRequest {
    id: string;
}

export interface JobConfigControllerUpdateRequest {
    id: string;
    createUpdateJobConfigDto: CreateUpdateJobConfigDto;
}

export interface JobPositionControllerCreateRequest {
    createUpdateJobPositionDto: CreateUpdateJobPositionDto;
}

export interface JobPositionControllerGetRequest {
    id: string;
}

export interface JobPositionControllerGetAllByNameRequest {
    text: string;
}

export interface JobPositionControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface JobPositionControllerGetAllCountRequest {
    filterText: string;
}

export interface JobPositionControllerUpdateRequest {
    id: string;
    createUpdateJobPositionDto: CreateUpdateJobPositionDto;
}

export interface JudgmentControllerChangeToInactiveRequest {
    id: string;
    cancelJudgmentDto: CancelJudgmentDto;
}

export interface JudgmentControllerCreateRequest {
    createUpdateJudgmentDto: CreateUpdateJudgmentDto;
}

export interface JudgmentControllerGetRequest {
    id: string;
}

export interface JudgmentControllerGetAllAutomaticByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentControllerGetAllAutomaticCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentControllerGetAllForUserRegisterToSignRequest {
    userUid: string;
    registerId?: string;
}

export interface JudgmentControllerGetByUserCompanyByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentControllerGetByUserCompanyCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentControllerGetForExamRequest {
    id: string;
}

export interface JudgmentControllerGetForRegisterByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    registerId: string;
    dateFrom?: Date;
    dateTo?: Date;
    userUid?: string;
    healthcareFacilityId?: string;
}

export interface JudgmentControllerGetForRegisterCountRequest {
    filterText: string;
    registerId: string;
    dateFrom?: Date;
    dateTo?: Date;
    userUid?: string;
    healthcareFacilityId?: string;
}

export interface JudgmentControllerGetForSigningByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    userUid?: string;
}

export interface JudgmentControllerGetForSigningCountRequest {
    filterText: string;
    userUid?: string;
}

export interface JudgmentControllerGetLastEditorRequest {
    id: string;
}

export interface JudgmentControllerGetNextExamDateRequest {
    examId: string;
    articleId?: string;
    articleMode?: string;
    pdfTemplateType?: string;
    contactWithFood?: string;
    referenceDate?: string;
}

export interface JudgmentControllerGetWithoutElectronicSigningByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    userUid?: string;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface JudgmentControllerGetWithoutElectronicSigningCountRequest {
    filterText: string;
    filterColumns?: string;
    userUid?: string;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface JudgmentControllerUpdateRequest {
    id: string;
    createUpdateJudgmentDto: CreateUpdateJudgmentDto;
}

export interface JudgmentNumberingControllerCreateRequest {
    createUpdateJudgmentNumberingDto: CreateUpdateJudgmentNumberingDto;
}

export interface JudgmentNumberingControllerGetRequest {
    id: string;
}

export interface JudgmentNumberingControllerUpdateRequest {
    id: string;
    createUpdateJudgmentNumberingDto: CreateUpdateJudgmentNumberingDto;
}

export interface JudgmentP1DocumentControllerGetAcceptedXmlForJudgmentRequest {
    judgmentId: string;
}

export interface JudgmentP1DocumentControllerGetDocumentForJudgmentRequest {
    judgmentId: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsAllByPageRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsIncompleteByPageRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsIncompleteCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsRejectedByPageRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsRejectedCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsToSignByPageRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsToSignCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsWaitingByPageRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerGetDocumentsWaitingCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface JudgmentP1DocumentControllerRetryDocumentRequest {
    id: string;
}

export interface JudgmentP1DocumentControllerSignDocumentRequest {
    id: string;
}

export interface JudgmentP1DocumentControllerSignDocumentWithSzafirRequest {
    id: string;
    submitSzafirSignedP1Dto: SubmitSzafirSignedP1Dto;
}

export interface KeyTestControllerCreateRequest {
    createUpdateKeyTestDto: CreateUpdateKeyTestDto;
}

export interface KeyTestControllerCreateWithValuesRequest {
    createUpdateKeyTestWithKeysDto: CreateUpdateKeyTestWithKeysDto;
}

export interface KeyTestControllerDeleteRequest {
    id: string;
}

export interface KeyTestControllerGetRequest {
    id: string;
}

export interface KeyTestControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface KeyTestControllerGetAllCountRequest {
    filterText: string;
}

export interface KeyTestControllerUpdateRequest {
    id: string;
    createUpdateKeyTestDto: CreateUpdateKeyTestDto;
}

export interface KeyValueControllerGetByKeyRequest {
    keyTestId: string;
}

export interface KeyValueControllerGetByKeyCountRequest {
    keyTestId: string;
}

export interface ManualControllerCreateRequest {
    createUpdateManualDto: CreateUpdateManualDto;
}

export interface ManualControllerGetRequest {
    id: string;
}

export interface ManualControllerGetAllByPortionRequest {
    pageSize?: number;
    pageNumber?: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
    filterColumns?: string;
}

export interface ManualControllerGetAllCountRequest {
    filterText?: string;
    filterColumns?: string;
}

export interface ManualControllerGetLastEditorRequest {
    id: string;
}

export interface ManualControllerUpdateRequest {
    id: string;
    createUpdateManualDto: CreateUpdateManualDto;
}

export interface NormControllerCreateWithValuesRequest {
    createUpdateNormWithValuesDto: CreateUpdateNormWithValuesDto;
}

export interface NormControllerDeleteRequest {
    id: string;
}

export interface NormControllerGetRequest {
    id: string;
}

export interface NormControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface NormControllerGetAllCountRequest {
    filterText: string;
}

export interface OtherPrintControllerChangeToInactiveRequest {
    id: string;
}

export interface OtherPrintControllerCreateRequest {
    createUpdateOtherPrintDto: CreateUpdateOtherPrintDto;
}

export interface OtherPrintControllerGetRequest {
    id: string;
}

export interface OtherPrintControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface OtherPrintControllerGetAllCountRequest {
    filterText: string;
}

export interface OtherPrintControllerGetForExamRequest {
    id: string;
}

export interface OtherPrintControllerGetForSigningByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    userUid?: string;
}

export interface OtherPrintControllerGetForSigningCountRequest {
    filterText: string;
    userUid?: string;
}

export interface OtherPrintControllerUpdateRequest {
    id: string;
    createUpdateOtherPrintDto: CreateUpdateOtherPrintDto;
}

export interface OtherPrintDefControllerChangeToInactiveRequest {
    id: string;
}

export interface OtherPrintDefControllerCreateRequest {
    createUpdateOtherPrintDefDto: CreateUpdateOtherPrintDefDto;
}

export interface OtherPrintDefControllerGetRequest {
    id: string;
}

export interface OtherPrintDefControllerGetAllRequest {
    mode?: string;
}

export interface OtherPrintDefControllerUpdateRequest {
    id: string;
    createUpdateOtherPrintDefDto: CreateUpdateOtherPrintDefDto;
}

export interface ParamsControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface ParamsControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface ParamsControllerGetByIdRequest {
    id: string;
}

export interface ParamsControllerGetLastEditorRequest {
    id: string;
}

export interface ParamsControllerUpdateRequest {
    id: string;
    createUpdateParamsDto: CreateUpdateParamsDto;
}

export interface PaymentCollectionControllerCreateRequest {
    createUpdatePaymentCollectionDto: CreateUpdatePaymentCollectionDto;
}

export interface PaymentCollectionControllerGetRequest {
    id: string;
}

export interface PaymentCollectionControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
    filterColumns?: string;
}

export interface PaymentCollectionControllerGetAllCountRequest {
    filterText?: string;
    filterColumns?: string;
}

export interface PaymentControllerCountRequest {
    filterText?: string;
    filterColumns?: string;
}

export interface PaymentControllerCreateRequest {
    createUpdatePaymentDto: CreateUpdatePaymentDto;
}

export interface PaymentControllerFindOneRequest {
    id: string;
}

export interface PaymentControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
    filterColumns?: string;
}

export interface PaymentControllerGetByExamRequest {
    id: string;
}

export interface PaymentControllerGetSellDocumentNotIssuedByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
    filterColumns?: string;
}

export interface PaymentControllerGetSellDocumentNotIssuedCountRequest {
    filterText?: string;
    filterColumns?: string;
}

export interface PaymentControllerUpdateRequest {
    id: string;
    createUpdatePaymentDto: CreateUpdatePaymentDto;
}

export interface PdfPrinterControllerLoadAndPrintCardRequest {
    id: string;
}

export interface PdfPrinterControllerLoadAndPrintConsultationRequest {
    id: string;
}

export interface PdfPrinterControllerLoadAndPrintExternalReferralRequest {
    examId: string;
}

export interface PdfPrinterControllerLoadAndPrintJudgmentRequest {
    id: string;
}

export interface PdfPrinterControllerLoadAndPrintJudgmentInEnglishRequest {
    id: string;
}

export interface PdfPrinterControllerLoadAndPrintJudgmentWithStampAndSignatureRequest {
    id: string;
}

export interface PdfPrinterControllerLoadAndPrintSupportingExaminationRequest {
    id: string;
}

export interface PdfPrinterControllerPreviewInvoiceRequest {
    id: string;
}

export interface PdfPrinterControllerPrintAnswersRequest {
    testId: string;
    examId: string;
}

export interface PdfPrinterControllerPrintCompaniesRequest {
    monthlySettlement: boolean;
}

export interface PdfPrinterControllerPrintInvoiceRequest {
    id: string;
}

export interface PdfPrinterControllerPrintMissingCardsToJudgmentsRequest {
    startDate: string;
    endDate: string;
}

export interface PdfPrinterControllerPrintMultiplePdfRequest {
    userUid?: string;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface PdfPrinterControllerPrintRegisterJudgmentRequest {
    registerId: string;
    dateFrom: Date;
    dateTo?: Date;
    userUid?: string;
    healthcareFacilityId?: string;
}

export interface PdfPrinterControllerPrintReportJudgmentsRequest {
    filterText: string;
    psychologistId?: string;
    companyId?: string;
    registerId?: string;
    healthcareFacilityId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    onlyMonthlySettlement?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface PdfPrinterControllerSaveAndPrintCardRequest {
    id: string;
}

export interface PdfPrinterControllerSaveAndPrintConsultationRequest {
    type: string;
    id: string;
}

export interface PdfPrinterControllerSaveAndPrintJudgmentRequest {
    id: string;
}

export interface PdfPrinterControllerSaveAndPrintSupportingExaminationRequest {
    id: string;
}

export interface PdfTemplateControllerGetRequest {
    id: string;
}

export interface PdfTemplateControllerGetStampPositionRequest {
    judgmentId: string;
}

export interface PdfTemplateControllerUpdateRequest {
    id: string;
    createUpdatePdfTemplateDto: CreateUpdatePdfTemplateDto;
}

export interface PositionNormControllerGetByNormRequest {
    normId: string;
}

export interface PositionNormControllerGetByNormCountRequest {
    normId: string;
}

export interface PricingControllerCreateWithPricelistRequest {
    createUpdatePricingDto: CreateUpdatePricingDto;
}

export interface PricingControllerGetAllByPortionRequest {
    pageSize?: number;
    pageNumber?: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
}

export interface PricingControllerGetAllCountRequest {
    filterText?: string;
}

export interface PricingControllerGetByIdRequest {
    id: string;
}

export interface PricingControllerUpdateWithPricelistRequest {
    id: string;
    createUpdatePricingDto: CreateUpdatePricingDto;
}

export interface PricingGroupControllerCreateRequest {
    createUpdatePricingGroupDto: CreateUpdatePricingGroupDto;
}

export interface PricingGroupControllerGetRequest {
    id: string;
}

export interface PricingGroupControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface PricingGroupControllerGetAllCountRequest {
    filterText: string;
}

export interface PricingGroupControllerUpdateRequest {
    id: string;
    createUpdatePricingGroupDto: CreateUpdatePricingGroupDto;
}

export interface PrinterJpkDocumentControllerCreateRequest {
    createPrinterJpkDocumentDto: CreatePrinterJpkDocumentDto;
}

export interface PrinterJpkDocumentControllerGetAllByPortionRequest {
    pageSize?: number;
    pageNumber?: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
    filterColumns?: string;
}

export interface PrinterJpkDocumentControllerGetAllCountRequest {
    filterText?: string;
    filterColumns?: string;
}

export interface PrinterJpkDocumentControllerGetByIdRequest {
    id: string;
}

export interface PrinterJpkDocumentControllerGetHighestJpkIdRequest {
    printerUid: string;
}

export interface PrinterJpkDocumentControllerGetMissingJpkIdsRequest {
    printerUid: string;
}

export interface ReceiptControllerCreateRequest {
    createUpdateReceiptDto: CreateUpdateReceiptDto;
}

export interface ReceiptControllerEdocumentRequest {
    eFiscalDocumentDto: EFiscalDocumentDto;
}

export interface ReceiptControllerGetRequest {
    id: string;
}

export interface ReceiptControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface ReceiptControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface ReceiptControllerGetByExamRequest {
    id: string;
}

export interface ReceiptControllerUpdateRequest {
    id: string;
    createUpdateReceiptDto: CreateUpdateReceiptDto;
}

export interface RegisterControllerGetRequest {
    id: string;
}

export interface RegisterControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface RegisterControllerGetAllCountRequest {
    filterText: string;
}

export interface RegisterControllerGetByModeRequest {
    mode: string;
}

export interface RegisterNumberingControllerCreateRequest {
    createUpdateRegisterNumberingDto: CreateUpdateRegisterNumberingDto;
}

export interface RegisterNumberingControllerFindByHealthcareFacilityIdRequest {
    healthcareFacilityId: string;
    pageSize: number;
    pageNumber: number;
    orderBy?: string;
    orderDirection?: string;
    filterText?: string;
}

export interface RegisterNumberingControllerGetRequest {
    id: string;
}

export interface RegisterNumberingControllerGetByHealthcareFacilityIdCountRequest {
    healthcareFacilityId: string;
    filterText?: string;
}

export interface ReportControllerGetCompaniesByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    onlyMonthlySettlement?: boolean;
    companyId?: string;
    healthcareFacilityId?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface ReportControllerGetCompaniesCountRequest {
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    onlyMonthlySettlement?: boolean;
    companyId?: string;
    healthcareFacilityId?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface ReportControllerGetCompaniesDetailsByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    psychologistId?: string;
    companyId?: string;
    registerId?: string;
    healthcareFacilityId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    onlyMonthlySettlement?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface ReportControllerGetCompaniesDetailsCountRequest {
    filterText: string;
    psychologistId?: string;
    companyId?: string;
    registerId?: string;
    healthcareFacilityId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    onlyMonthlySettlement?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface ReportControllerGetConsultationsByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    userUid?: string;
    companyId?: string;
    healthcareFacilityId?: string;
    withHealthcareFacility?: boolean;
    withType?: boolean;
}

export interface ReportControllerGetConsultationsCountRequest {
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    userUid?: string;
    companyId?: string;
    healthcareFacilityId?: string;
    withHealthcareFacility?: boolean;
    withType?: boolean;
}

export interface ReportControllerGetJudgmentsByCreatorByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ReportControllerGetJudgmentsByCreatorCountRequest {
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ReportControllerGetJudgmentsByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    userUid?: string;
    companyId?: string;
    healthcareFacilityId?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface ReportControllerGetJudgmentsCountRequest {
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    userUid?: string;
    companyId?: string;
    healthcareFacilityId?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface ReportControllerGetSynevoCompaniesByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    companyId?: string;
}

export interface ReportControllerGetSynevoCompaniesCountRequest {
    filterText: string;
    dateFrom?: Date;
    dateTo?: Date;
    companyId?: string;
}

export interface ReportControllerReportByTypeExamsRequest {
    currentMonthOnly?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    companyId?: string;
}

export interface ReportControllerReportCloseExamsRequest {
    currentMonthOnly?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    companyId?: string;
}

export interface ReportControllerReportInvoicesReceiptsRequest {
    currentMonthOnly?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    companyId?: string;
}

export interface ReportControllerReportInvoicesReceiptsByPaymentRequest {
    currentMonthOnly?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    companyId?: string;
}

export interface ReportControllerReportJudgmentsRequest {
    currentMonthOnly?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    companyId?: string;
}

export interface ReportControllerReportPaymentsByDateRequest {
    currentMonthOnly?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ReportControllerReportRegisterStatisticsSPDByMonthsCountsRequest {
    dateFrom?: Date;
    dateTo?: Date;
    userUid?: string;
    companyId?: string;
}

export interface ReportControllerReportStatisticsSPDCountsRequest {
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ReportControllerReportTopCompaniesByInvoicesRequest {
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ReportControllerReportTopCompaniesByJudgmentsRequest {
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ReportExcelControllerDownloadReportJudgmentsRequest {
    filterText: string;
    psychologistId?: string;
    companyId?: string;
    registerId?: string;
    healthcareFacilityId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    onlyMonthlySettlement?: string;
    withHealthcareFacility?: boolean;
    withRegister?: boolean;
}

export interface ReportExcelControllerReportBillingSummaryRequest {
    filterData: FilterData;
}

export interface ReportExcelControllerReportCompanySummaryRequest {
    filterData: FilterData;
}

export interface ReportExcelControllerReportSalesInvoicesRequest {
    filterData: FilterData;
}

export interface ResultControllerGetByExamTestRequest {
    examId: string;
    testId: string;
}

export interface ResultControllerGetByExamTestIdRequest {
    id: string;
}

export interface ResultControllerSaveResultRequest {
    examId: string;
    testId: string;
    createUpdateResultDto: CreateUpdateResultDto;
}

export interface ResultControllerSaveResultsRequest {
    examId: string;
    testId: string;
    createUpdateResultsDto: CreateUpdateResultsDto;
}

export interface SalesInvoiceControllerAddExamsRequest {
    id: string;
    addExamsSalesInvoiceDto: AddExamsSalesInvoiceDto;
}

export interface SalesInvoiceControllerCalculatePositionsRequest {
    id: string;
}

export interface SalesInvoiceControllerCreateRequest {
    createUpdateSalesInvoiceDto: CreateUpdateSalesInvoiceDto;
}

export interface SalesInvoiceControllerCreateCorrectionRequest {
    id: string;
}

export interface SalesInvoiceControllerCreateFromExamRequest {
    id: string;
}

export interface SalesInvoiceControllerCreateFromPaymentRequest {
    id: string;
}

export interface SalesInvoiceControllerDeactivateRequest {
    id: string;
}

export interface SalesInvoiceControllerGenerateAutoInvoiceRequest {
    generateAutoSalesInvoiceDto: GenerateAutoSalesInvoiceDto;
}

export interface SalesInvoiceControllerGetRequest {
    id: string;
}

export interface SalesInvoiceControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
    status?: string;
    statuses?: string;
    ksefStatuses?: string;
    onlyWithUnlinkedAmount?: string;
    onlyLinkable?: string;
    paymentId?: string;
    onlyOverpaid?: string;
    examId?: string;
    companyId?: string;
    onlyOverdue?: string;
    onlyAutoGenerated?: string;
}

export interface SalesInvoiceControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
    status?: string;
    statuses?: string;
    ksefStatuses?: string;
    onlyWithUnlinkedAmount?: string;
    onlyLinkable?: string;
    paymentId?: string;
    onlyOverpaid?: string;
    examId?: string;
    companyId?: string;
    onlyOverdue?: string;
    onlyAutoGenerated?: string;
}

export interface SalesInvoiceControllerGetByExamRequest {
    id: string;
}

export interface SalesInvoiceControllerGetLastEditorRequest {
    id: string;
}

export interface SalesInvoiceControllerGetNumberToCorrectRequest {
    id: string;
}

export interface SalesInvoiceControllerRemoveExamRequest {
    invoiceId: string;
    examId: string;
}

export interface SalesInvoiceControllerRetryKsefRequest {
    id: string;
}

export interface SalesInvoiceControllerRevertToDraftRequest {
    id: string;
}

export interface SalesInvoiceControllerUpdateRequest {
    id: string;
    createUpdateSalesInvoiceDto: CreateUpdateSalesInvoiceDto;
}

export interface SalesInvoicePositionControllerCreateManyRequest {
    createUpdateSalesInvoicePositionsDto: CreateUpdateSalesInvoicePositionsDto;
}

export interface SavedPdfControllerGetCardSignatureStatusRequest {
    id: string;
}

export interface SavedPdfControllerGetExternalReferralForExaminedRequest {
    examinedId: string;
}

export interface SavedPdfControllerGetFileDownloadRequest {
    id: string;
}

export interface SavedPdfControllerGetJudgmentSignatureStatusRequest {
    id: string;
}

export interface SavedPdfControllerGetReferralSignatureStatusRequest {
    id: string;
}

export interface SavedPdfControllerSavePdfFileForCardRequest {
    createUpdateSavedPdfDto: CreateUpdateSavedPdfDto;
}

export interface SavedPdfControllerSavePdfFileForJudgmentRequest {
    createUpdateSavedPdfDto: CreateUpdateSavedPdfDto;
}

export interface SavedPdfControllerSavePdfFileForReferralRequest {
    createUpdateSavedPdfDto: CreateUpdateSavedPdfDto;
}

export interface StampControllerGetStampsByUserRequest {
    userId?: string;
}

export interface StampControllerUploadStampsRequest {
    uploadStampsDto: UploadStampsDto;
    userUid?: string;
}

export interface StethoControllerGetCardioResultRequest {
    examId: string;
    testId: string;
}

export interface StethoControllerGetPulmonaryResultRequest {
    examId: string;
    testId: string;
}

export interface StethoControllerGetSrcFrameRequest {
    visitId: string;
    point: number;
}

export interface StethoControllerGetViewStethoTestRequest {
    examId: string;
    testId: string;
}

export interface SupportingExaminationControllerCreateRequest {
    createUpdateSupportingExaminationDto: CreateUpdateSupportingExaminationDto;
}

export interface SupportingExaminationControllerDeleteRequest {
    id: string;
}

export interface SupportingExaminationControllerGetRequest {
    id: string;
}

export interface SupportingExaminationControllerGetAllByExamRequest {
    examId: string;
}

export interface SupportingExaminationControllerGetAllForUserToSignRequest {
    userUid?: string;
}

export interface SupportingExaminationControllerGetWithPrintsByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface SupportingExaminationControllerGetWithPrintsCountRequest {
    filterText: string;
}

export interface SupportingExaminationControllerGetWithPrintsForSigningByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    userUid?: string;
}

export interface SupportingExaminationControllerGetWithPrintsForSigningCountRequest {
    filterText: string;
    userUid?: string;
}

export interface SupportingExaminationControllerUpdateRequest {
    id: string;
    createUpdateSupportingExaminationDto: CreateUpdateSupportingExaminationDto;
}

export interface SupportingExaminationDictControllerCreateRequest {
    createUpdateSupportingExaminationDictDto: CreateUpdateSupportingExaminationDictDto;
}

export interface SupportingExaminationDictControllerGetRequest {
    id: string;
}

export interface SupportingExaminationDictControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface SupportingExaminationDictControllerGetAllCountRequest {
    filterText: string;
}

export interface SupportingExaminationDictControllerUpdateRequest {
    id: string;
    createUpdateSupportingExaminationDictDto: CreateUpdateSupportingExaminationDictDto;
}

export interface SynevoControllerCancelOrderRequest {
    synevoId: string;
    sentOrderId: string;
}

export interface SynevoControllerCreateForExamRequest {
    examId: string;
    createForExamSynevoDto: CreateForExamSynevoDto;
}

export interface SynevoControllerGetRequest {
    id: string;
}

export interface SynevoControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface SynevoControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface SynevoControllerGetDictCostRequest {
    dictIds: Array<string>;
}

export interface SynevoControllerGetForExamByPortionRequest {
    examId: string;
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface SynevoControllerGetForExamCountRequest {
    examId: string;
    filterText: string;
    filterColumns?: string;
}

export interface SynevoControllerGetForExamSummaryRequest {
    examId: string;
}

export interface SynevoControllerGetReadyByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface SynevoControllerGetReadyCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface SynevoControllerGetWaitingByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface SynevoControllerGetWaitingCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface SzafirControllerGetTaskListForCardRequest {
    documentId: string;
}

export interface SzafirControllerGetTaskListForJudgmentRequest {
    documentId: string;
    english: boolean;
}

export interface SzafirControllerGetTaskListForJudgmentP1Request {
    documentId: string;
}

export interface SzafirControllerGetTaskListForSupportingExaminationRequest {
    documentId: string;
}

export interface TestControllerCreateRequest {
    createUpdateTestDto: CreateUpdateTestDto;
}

export interface TestControllerGetRequest {
    id: string;
}

export interface TestControllerGetAllByNameRequest {
    text: string;
}

export interface TestControllerGetAllByPortionRequest {
    withNotActive: boolean;
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
}

export interface TestControllerGetAllCountRequest {
    withNotActive: boolean;
    filterText: string;
}

export interface TestControllerGetByBatteryRequest {
    batteryId: string;
}

export interface TestControllerGetByIdentifierRequest {
    identifier: string;
}

export interface TestControllerUpdateRequest {
    id: string;
    createUpdateTestDto: CreateUpdateTestDto;
}

export interface TestGivingControllerGetExamByIdRequest {
    id: string;
}

export interface TestGivingControllerGetExamByPinRequest {
    pin: string;
}

export interface TestGivingControllerGetExamByPinExamIdExternalRequest {
    pin: string;
    examId: string;
}

export interface TestGivingControllerGetExamByTokenRequest {
    token: string;
}

export interface UserControllerChangeEmailRequest {
    id: string;
    createUpdateUserDto: CreateUpdateUserDto;
}

export interface UserControllerChangePinRequest {
    id: string;
    createUpdateUserDto: CreateUpdateUserDto;
}

export interface UserControllerChangeSignP1WithSzafirRequest {
    id: string;
    createUpdateUserDto: CreateUpdateUserDto;
}

export interface UserControllerCreateRequest {
    createUpdateUserDto: CreateUpdateUserDto;
}

export interface UserControllerGetRequest {
    id: string;
}

export interface UserControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    mode?: string;
    filterColumns?: string;
}

export interface UserControllerGetAllByRolesRequest {
    roles: Array<string>;
}

export interface UserControllerGetAllCountRequest {
    filterText: string;
    mode?: string;
    filterColumns?: string;
}

export interface UserControllerGetByEmailRequest {
    email: string;
}

export interface UserControllerGetByUidRequest {
    uid: string;
}

export interface UserControllerGetLastEditorRequest {
    id: string;
}

export interface UserControllerRegisterRequest {
    id: string;
}

export interface UserControllerUpdateRequest {
    id: string;
    createUpdateUserDto: CreateUpdateUserDto;
}

export interface UserControllerUploadCertificateRequest {
    id: string;
    uploadCertificateUserDto: UploadCertificateUserDto;
}

export interface UserInHealthcareFacilityControllerCreateRequest {
    createUpdateUserInHealthcareFacilityDto: CreateUpdateUserInHealthcareFacilityDto;
}

export interface UserInHealthcareFacilityControllerGetAllRequest {
    userId: string;
}

export interface UserInHealthcareFacilityControllerUpdateRequest {
    id: string;
    createUpdateUserInHealthcareFacilityDto: CreateUpdateUserInHealthcareFacilityDto;
}

export interface VisitRegistrationControllerChangeToInactiveRequest {
    id: string;
}

export interface VisitRegistrationControllerCreateRequest {
    createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto;
}

export interface VisitRegistrationControllerCreateExternalBookingRequest {
    createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto;
}

export interface VisitRegistrationControllerGetRequest {
    id: string;
}

export interface VisitRegistrationControllerGetAllRequest {
    healthcareId?: string;
    dateStart?: Date;
    dateEnd?: Date;
}

export interface VisitRegistrationControllerGetAllByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface VisitRegistrationControllerGetAllCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface VisitRegistrationControllerGetByAppointmentChannelRequest {
    appointmentChannel: string;
}

export interface VisitRegistrationControllerGetByHealthcareFacilityRequest {
    healthcareFacility: string;
}

export interface VisitRegistrationControllerGetExternalBookingRequest {
    id: string;
}

export interface VisitRegistrationControllerGetExternalBookingByPortionRequest {
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderDirection: string;
    filterText: string;
    filterColumns?: string;
}

export interface VisitRegistrationControllerGetExternalBookingCalendarRequest {
    dateStart?: Date;
    dateEnd?: Date;
    healthcareId?: string;
}

export interface VisitRegistrationControllerGetExternalBookingCountRequest {
    filterText: string;
    filterColumns?: string;
}

export interface VisitRegistrationControllerGetLastEditorRequest {
    id: string;
}

export interface VisitRegistrationControllerGetMyAppointmentChannelsRequest {
    healthcareId?: string;
}

export interface VisitRegistrationControllerUpdateRequest {
    id: string;
    createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto;
}

export interface VisitRegistrationControllerUpdateExternalBookingRequest {
    id: string;
    createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async accessControllerCheckAccessRaw(requestParameters: AccessControllerCheckAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAccessDto>>> {
        if (requestParameters['device'] == null) {
            throw new runtime.RequiredError(
                'device',
                'Required parameter "device" was null or undefined when calling accessControllerCheckAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['device'] != null) {
            queryParameters['device'] = requestParameters['device'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access/checkAccess/byDevice`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAccessDtoFromJSON));
    }

    /**
     */
    async accessControllerCheckAccess(device: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAccessDto>> {
        const response = await this.accessControllerCheckAccessRaw({ device: device }, initOverrides);
        return await response.value();
    }

    /**
     */
    async accessControllerGetRaw(requestParameters: AccessControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling accessControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessDtoFromJSON(jsonValue));
    }

    /**
     */
    async accessControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessDto> {
        const response = await this.accessControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async accessControllerGetAllByPortionRaw(requestParameters: AccessControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAccessDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling accessControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling accessControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling accessControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling accessControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling accessControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAccessDtoFromJSON));
    }

    /**
     */
    async accessControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAccessDto>> {
        const response = await this.accessControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async accessControllerGetAllCountRaw(requestParameters: AccessControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling accessControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async accessControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.accessControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async answerControllerChangeAllCardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/answer/changeAllCards`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async answerControllerChangeAllCards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.answerControllerChangeAllCardsRaw(initOverrides);
    }

    /**
     */
    async answerControllerGetRaw(requestParameters: AnswerControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAnswerDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling answerControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/answer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAnswerDtoFromJSON(jsonValue));
    }

    /**
     */
    async answerControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAnswerDto> {
        const response = await this.answerControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async answerControllerGetIntellectualAbilityTextRaw(requestParameters: AnswerControllerGetIntellectualAbilityTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling answerControllerGetIntellectualAbilityText().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/answer/get/intellectualAbility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async answerControllerGetIntellectualAbilityText(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.answerControllerGetIntellectualAbilityTextRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async answerControllerGetIntellectualPsychomotorEfficiencyTextRaw(requestParameters: AnswerControllerGetIntellectualPsychomotorEfficiencyTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling answerControllerGetIntellectualPsychomotorEfficiencyText().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/answer/get/intellectualPsychomotorEfficiencyText`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async answerControllerGetIntellectualPsychomotorEfficiencyText(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.answerControllerGetIntellectualPsychomotorEfficiencyTextRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async answerControllerGetInterviewTextRaw(requestParameters: AnswerControllerGetInterviewTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling answerControllerGetInterviewText().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/answer/get/interviewText`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async answerControllerGetInterviewText(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.answerControllerGetInterviewTextRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async answerControllerGetPersonalityTextRaw(requestParameters: AnswerControllerGetPersonalityTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling answerControllerGetPersonalityText().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/answer/get/personalityText`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async answerControllerGetPersonalityText(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.answerControllerGetPersonalityTextRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async appointmentChannelControllerChangeToInactiveRaw(requestParameters: AppointmentChannelControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appointmentChannelControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appointmentChannelControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.appointmentChannelControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async appointmentChannelControllerCreateRaw(requestParameters: AppointmentChannelControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAppointmentChannelDto>> {
        if (requestParameters['createUpdateAppointmentChannelDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateAppointmentChannelDto',
                'Required parameter "createUpdateAppointmentChannelDto" was null or undefined when calling appointmentChannelControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateAppointmentChannelDtoToJSON(requestParameters['createUpdateAppointmentChannelDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAppointmentChannelDtoFromJSON(jsonValue));
    }

    /**
     */
    async appointmentChannelControllerCreate(createUpdateAppointmentChannelDto: CreateUpdateAppointmentChannelDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAppointmentChannelDto> {
        const response = await this.appointmentChannelControllerCreateRaw({ createUpdateAppointmentChannelDto: createUpdateAppointmentChannelDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async appointmentChannelControllerGetRaw(requestParameters: AppointmentChannelControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAppointmentChannelDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appointmentChannelControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAppointmentChannelDtoFromJSON(jsonValue));
    }

    /**
     */
    async appointmentChannelControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAppointmentChannelDto> {
        const response = await this.appointmentChannelControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async appointmentChannelControllerGetAllRaw(requestParameters: AppointmentChannelControllerGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAppointmentChannelDto>>> {
        const queryParameters: any = {};

        if (requestParameters['healthcareId'] != null) {
            queryParameters['healthcareId'] = requestParameters['healthcareId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAppointmentChannelDtoFromJSON));
    }

    /**
     */
    async appointmentChannelControllerGetAll(healthcareId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAppointmentChannelDto>> {
        const response = await this.appointmentChannelControllerGetAllRaw({ healthcareId: healthcareId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async appointmentChannelControllerGetAllByPortionRaw(requestParameters: AppointmentChannelControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAppointmentChannelDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling appointmentChannelControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling appointmentChannelControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAppointmentChannelDtoFromJSON));
    }

    /**
     */
    async appointmentChannelControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAppointmentChannelDto>> {
        const response = await this.appointmentChannelControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async appointmentChannelControllerGetAllCountRaw(requestParameters: AppointmentChannelControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling appointmentChannelControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async appointmentChannelControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.appointmentChannelControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async appointmentChannelControllerGetLastEditorRaw(requestParameters: AppointmentChannelControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appointmentChannelControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async appointmentChannelControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.appointmentChannelControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async appointmentChannelControllerUpdateRaw(requestParameters: AppointmentChannelControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appointmentChannelControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateAppointmentChannelDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateAppointmentChannelDto',
                'Required parameter "createUpdateAppointmentChannelDto" was null or undefined when calling appointmentChannelControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/appointmentChannel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateAppointmentChannelDtoToJSON(requestParameters['createUpdateAppointmentChannelDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appointmentChannelControllerUpdate(id: string, createUpdateAppointmentChannelDto: CreateUpdateAppointmentChannelDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.appointmentChannelControllerUpdateRaw({ id: id, createUpdateAppointmentChannelDto: createUpdateAppointmentChannelDto }, initOverrides);
    }

    /**
     */
    async articleControllerChangeToInactiveRaw(requestParameters: ArticleControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling articleControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/article/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async articleControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.articleControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async articleControllerCreateRaw(requestParameters: ArticleControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetArticleDto>> {
        if (requestParameters['createUpdateArticleDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateArticleDto',
                'Required parameter "createUpdateArticleDto" was null or undefined when calling articleControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/article`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateArticleDtoToJSON(requestParameters['createUpdateArticleDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetArticleDtoFromJSON(jsonValue));
    }

    /**
     */
    async articleControllerCreate(createUpdateArticleDto: CreateUpdateArticleDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetArticleDto> {
        const response = await this.articleControllerCreateRaw({ createUpdateArticleDto: createUpdateArticleDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async articleControllerGetRaw(requestParameters: ArticleControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetArticleDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling articleControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/article/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetArticleDtoFromJSON(jsonValue));
    }

    /**
     */
    async articleControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetArticleDto> {
        const response = await this.articleControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async articleControllerGetAllRaw(requestParameters: ArticleControllerGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetArticleDto>>> {
        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/article`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetArticleDtoFromJSON));
    }

    /**
     */
    async articleControllerGetAll(mode?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetArticleDto>> {
        const response = await this.articleControllerGetAllRaw({ mode: mode }, initOverrides);
        return await response.value();
    }

    /**
     */
    async articleControllerGetLastEditorRaw(requestParameters: ArticleControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling articleControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/article/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async articleControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.articleControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async articleControllerUpdateRaw(requestParameters: ArticleControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling articleControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateArticleDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateArticleDto',
                'Required parameter "createUpdateArticleDto" was null or undefined when calling articleControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/article/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateArticleDtoToJSON(requestParameters['createUpdateArticleDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async articleControllerUpdate(id: string, createUpdateArticleDto: CreateUpdateArticleDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.articleControllerUpdateRaw({ id: id, createUpdateArticleDto: createUpdateArticleDto }, initOverrides);
    }

    /**
     */
    async articleHarmfulFactorSuppExamDictControllerGetByArticleRaw(requestParameters: ArticleHarmfulFactorSuppExamDictControllerGetByArticleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetArticleHarmfulFactorSuppExamDictDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling articleHarmfulFactorSuppExamDictControllerGetByArticle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/articleHarmfulFactorSuppExamDict/byArticle/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetArticleHarmfulFactorSuppExamDictDtoFromJSON));
    }

    /**
     */
    async articleHarmfulFactorSuppExamDictControllerGetByArticle(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetArticleHarmfulFactorSuppExamDictDto>> {
        const response = await this.articleHarmfulFactorSuppExamDictControllerGetByArticleRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async attachmentControllerAddDeleteAttachmentsRaw(requestParameters: AttachmentControllerAddDeleteAttachmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createDeleteAttachmentsDto'] == null) {
            throw new runtime.RequiredError(
                'createDeleteAttachmentsDto',
                'Required parameter "createDeleteAttachmentsDto" was null or undefined when calling attachmentControllerAddDeleteAttachments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/addDeleteAttachments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeleteAttachmentsDtoToJSON(requestParameters['createDeleteAttachmentsDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async attachmentControllerAddDeleteAttachments(createDeleteAttachmentsDto: CreateDeleteAttachmentsDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.attachmentControllerAddDeleteAttachmentsRaw({ createDeleteAttachmentsDto: createDeleteAttachmentsDto }, initOverrides);
    }

    /**
     */
    async attachmentControllerCreateRaw(requestParameters: AttachmentControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAttachmentDto>> {
        if (requestParameters['createUpdateAttachmentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateAttachmentDto',
                'Required parameter "createUpdateAttachmentDto" was null or undefined when calling attachmentControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateAttachmentDtoToJSON(requestParameters['createUpdateAttachmentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAttachmentDtoFromJSON(jsonValue));
    }

    /**
     */
    async attachmentControllerCreate(createUpdateAttachmentDto: CreateUpdateAttachmentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAttachmentDto> {
        const response = await this.attachmentControllerCreateRaw({ createUpdateAttachmentDto: createUpdateAttachmentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async attachmentControllerDeleteRaw(requestParameters: AttachmentControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling attachmentControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async attachmentControllerDelete(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.attachmentControllerDeleteRaw({ id: id }, initOverrides);
    }

    /**
     */
    async attachmentControllerGetRaw(requestParameters: AttachmentControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAttachmentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling attachmentControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAttachmentDtoFromJSON(jsonValue));
    }

    /**
     */
    async attachmentControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAttachmentDto> {
        const response = await this.attachmentControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async attachmentControllerGetAllForExaminedRaw(requestParameters: AttachmentControllerGetAllForExaminedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAttachmentDto>>> {
        if (requestParameters['examinedId'] == null) {
            throw new runtime.RequiredError(
                'examinedId',
                'Required parameter "examinedId" was null or undefined when calling attachmentControllerGetAllForExamined().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examinedId'] != null) {
            queryParameters['examinedId'] = requestParameters['examinedId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/forObject`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAttachmentDtoFromJSON));
    }

    /**
     */
    async attachmentControllerGetAllForExamined(examinedId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAttachmentDto>> {
        const response = await this.attachmentControllerGetAllForExaminedRaw({ examinedId: examinedId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async attachmentControllerGetFileDownloadRaw(requestParameters: AttachmentControllerGetFileDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttachmentFileContent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling attachmentControllerGetFileDownload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/{id}/fileDownload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentFileContentFromJSON(jsonValue));
    }

    /**
     */
    async attachmentControllerGetFileDownload(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttachmentFileContent> {
        const response = await this.attachmentControllerGetFileDownloadRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async attachmentControllerGetLastEditorRaw(requestParameters: AttachmentControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling attachmentControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async attachmentControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.attachmentControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     * Przenosi załączniki z bazy danych do Object Storage. filterType: file|scan|both (domyślnie both). maxFileSizeMb: filtruje rekordy wg rozmiaru kolumny w bazie (dla formatu JSON Buffer rzeczywisty plik jest ~3.5x mniejszy niż rozmiar kolumny).
     * Migracja załączników do Object Storage
     */
    async attachmentControllerRunAttachmentMigrationRaw(requestParameters: AttachmentControllerRunAttachmentMigrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['batchSize'] != null) {
            queryParameters['batchSize'] = requestParameters['batchSize'];
        }

        if (requestParameters['delayMs'] != null) {
            queryParameters['delayMs'] = requestParameters['delayMs'];
        }

        if (requestParameters['maxRecords'] != null) {
            queryParameters['maxRecords'] = requestParameters['maxRecords'];
        }

        if (requestParameters['filterType'] != null) {
            queryParameters['filterType'] = requestParameters['filterType'];
        }

        if (requestParameters['maxFileSizeMb'] != null) {
            queryParameters['maxFileSizeMb'] = requestParameters['maxFileSizeMb'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/runMigration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Przenosi załączniki z bazy danych do Object Storage. filterType: file|scan|both (domyślnie both). maxFileSizeMb: filtruje rekordy wg rozmiaru kolumny w bazie (dla formatu JSON Buffer rzeczywisty plik jest ~3.5x mniejszy niż rozmiar kolumny).
     * Migracja załączników do Object Storage
     */
    async attachmentControllerRunAttachmentMigration(batchSize?: number, delayMs?: number, maxRecords?: number, filterType?: AttachmentControllerRunAttachmentMigrationFilterTypeEnum, maxFileSizeMb?: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.attachmentControllerRunAttachmentMigrationRaw({ batchSize: batchSize, delayMs: delayMs, maxRecords: maxRecords, filterType: filterType, maxFileSizeMb: maxFileSizeMb }, initOverrides);
    }

    /**
     */
    async attachmentControllerUpdateRaw(requestParameters: AttachmentControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling attachmentControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateAttachmentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateAttachmentDto',
                'Required parameter "createUpdateAttachmentDto" was null or undefined when calling attachmentControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateAttachmentDtoToJSON(requestParameters['createUpdateAttachmentDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async attachmentControllerUpdate(id: string, createUpdateAttachmentDto: CreateUpdateAttachmentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.attachmentControllerUpdateRaw({ id: id, createUpdateAttachmentDto: createUpdateAttachmentDto }, initOverrides);
    }

    /**
     */
    async batteryControllerCreateRaw(requestParameters: BatteryControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBatteryDto>> {
        if (requestParameters['createUpdateBatteryDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateBatteryDto',
                'Required parameter "createUpdateBatteryDto" was null or undefined when calling batteryControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/battery`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateBatteryDtoToJSON(requestParameters['createUpdateBatteryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBatteryDtoFromJSON(jsonValue));
    }

    /**
     */
    async batteryControllerCreate(createUpdateBatteryDto: CreateUpdateBatteryDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBatteryDto> {
        const response = await this.batteryControllerCreateRaw({ createUpdateBatteryDto: createUpdateBatteryDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async batteryControllerGetRaw(requestParameters: BatteryControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBatteryDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling batteryControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/battery/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBatteryDtoFromJSON(jsonValue));
    }

    /**
     */
    async batteryControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBatteryDto> {
        const response = await this.batteryControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async batteryControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetBatteryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/battery`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetBatteryDtoFromJSON));
    }

    /**
     */
    async batteryControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetBatteryDto>> {
        const response = await this.batteryControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async batteryControllerGetAllByPortionRaw(requestParameters: BatteryControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetBatteryWithTestsDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling batteryControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling batteryControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling batteryControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling batteryControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling batteryControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/battery/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetBatteryWithTestsDtoFromJSON));
    }

    /**
     */
    async batteryControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetBatteryWithTestsDto>> {
        const response = await this.batteryControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async batteryControllerGetAllCountRaw(requestParameters: BatteryControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling batteryControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/battery/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async batteryControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.batteryControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async batteryControllerGetLastEditorRaw(requestParameters: BatteryControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling batteryControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/battery/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async batteryControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.batteryControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async batteryControllerUpdateRaw(requestParameters: BatteryControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling batteryControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateBatteryDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateBatteryDto',
                'Required parameter "createUpdateBatteryDto" was null or undefined when calling batteryControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/battery/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateBatteryDtoToJSON(requestParameters['createUpdateBatteryDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async batteryControllerUpdate(id: string, createUpdateBatteryDto: CreateUpdateBatteryDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.batteryControllerUpdateRaw({ id: id, createUpdateBatteryDto: createUpdateBatteryDto }, initOverrides);
    }

    /**
     */
    async calendarControllerAddDayRaw(requestParameters: CalendarControllerAddDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCalendarDto>> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling calendarControllerAddDay().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calendar`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCalendarDtoFromJSON(jsonValue));
    }

    /**
     */
    async calendarControllerAddDay(date: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCalendarDto> {
        const response = await this.calendarControllerAddDayRaw({ date: date }, initOverrides);
        return await response.value();
    }

    /**
     */
    async calendarControllerCreateYearRaw(requestParameters: CalendarControllerCreateYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling calendarControllerCreateYear().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calendar/createYear`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async calendarControllerCreateYear(date: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.calendarControllerCreateYearRaw({ date: date }, initOverrides);
    }

    /**
     */
    async calendarControllerGetAllForYearRaw(requestParameters: CalendarControllerGetAllForYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling calendarControllerGetAllForYear().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calendar/get/allForYear`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async calendarControllerGetAllForYear(year: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.calendarControllerGetAllForYearRaw({ year: year }, initOverrides);
        return await response.value();
    }

    /**
     */
    async calendarControllerRemoveDayRaw(requestParameters: CalendarControllerRemoveDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling calendarControllerRemoveDay().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calendar/remove/day`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async calendarControllerRemoveDay(date: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.calendarControllerRemoveDayRaw({ date: date }, initOverrides);
    }

    /**
     */
    async cardControllerCreateRaw(requestParameters: CardControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCardDto>> {
        if (requestParameters['createUpdateCardDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateCardDto',
                'Required parameter "createUpdateCardDto" was null or undefined when calling cardControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateCardDtoToJSON(requestParameters['createUpdateCardDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCardDtoFromJSON(jsonValue));
    }

    /**
     */
    async cardControllerCreate(createUpdateCardDto: CreateUpdateCardDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCardDto> {
        const response = await this.cardControllerCreateRaw({ createUpdateCardDto: createUpdateCardDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerFixNormsOnCardsRaw(requestParameters: CardControllerFixNormsOnCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['cardDateAfter'] == null) {
            throw new runtime.RequiredError(
                'cardDateAfter',
                'Required parameter "cardDateAfter" was null or undefined when calling cardControllerFixNormsOnCards().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cardDateAfter'] != null) {
            queryParameters['cardDateAfter'] = requestParameters['cardDateAfter'];
        }

        if (requestParameters['commit'] != null) {
            queryParameters['commit'] = requestParameters['commit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/admin/fixNormsOnCards`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cardControllerFixNormsOnCards(cardDateAfter: string, commit?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cardControllerFixNormsOnCardsRaw({ cardDateAfter: cardDateAfter, commit: commit }, initOverrides);
    }

    /**
     */
    async cardControllerGetRaw(requestParameters: CardControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCardDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cardControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCardDtoFromJSON(jsonValue));
    }

    /**
     */
    async cardControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCardDto> {
        const response = await this.cardControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetAllAutomaticByPortionRaw(requestParameters: CardControllerGetAllAutomaticByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCardDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling cardControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling cardControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling cardControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling cardControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling cardControllerGetAllAutomaticByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/searchAutomatic/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCardDtoFromJSON));
    }

    /**
     */
    async cardControllerGetAllAutomaticByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCardDto>> {
        const response = await this.cardControllerGetAllAutomaticByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetAllAutomaticCountRaw(requestParameters: CardControllerGetAllAutomaticCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling cardControllerGetAllAutomaticCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/searchAutomatic/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async cardControllerGetAllAutomaticCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.cardControllerGetAllAutomaticCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetAllByExamRaw(requestParameters: CardControllerGetAllByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCardDto>>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling cardControllerGetAllByExam().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/getAllByExam/byExam`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCardDtoFromJSON));
    }

    /**
     */
    async cardControllerGetAllByExam(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCardDto>> {
        const response = await this.cardControllerGetAllByExamRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetAllByPortionRaw(requestParameters: CardControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCardDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling cardControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling cardControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling cardControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling cardControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling cardControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCardDtoFromJSON));
    }

    /**
     */
    async cardControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCardDto>> {
        const response = await this.cardControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetAllCountRaw(requestParameters: CardControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling cardControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async cardControllerGetAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.cardControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetAllForUserToSignRaw(requestParameters: CardControllerGetAllForUserToSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCardDto>>> {
        const queryParameters: any = {};

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/getAll/forUserToSign`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCardDtoFromJSON));
    }

    /**
     */
    async cardControllerGetAllForUserToSign(userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCardDto>> {
        const response = await this.cardControllerGetAllForUserToSignRaw({ userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetByExamRaw(requestParameters: CardControllerGetByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCardDto>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling cardControllerGetByExam().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling cardControllerGetByExam().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/get/byExam`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCardDtoFromJSON(jsonValue));
    }

    /**
     */
    async cardControllerGetByExam(examId: string, type: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCardDto> {
        const response = await this.cardControllerGetByExamRaw({ examId: examId, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetForSigningByPortionRaw(requestParameters: CardControllerGetForSigningByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCardDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling cardControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling cardControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling cardControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling cardControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling cardControllerGetForSigningByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/searchForSigning/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCardDtoFromJSON));
    }

    /**
     */
    async cardControllerGetForSigningByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCardDto>> {
        const response = await this.cardControllerGetForSigningByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetForSigningCountRaw(requestParameters: CardControllerGetForSigningCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling cardControllerGetForSigningCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/searchForSigning/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async cardControllerGetForSigningCount(filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.cardControllerGetForSigningCountRaw({ filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerGetLastEditorRaw(requestParameters: CardControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cardControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async cardControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.cardControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async cardControllerUpdateRaw(requestParameters: CardControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cardControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateCardDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateCardDto',
                'Required parameter "createUpdateCardDto" was null or undefined when calling cardControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/card/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateCardDtoToJSON(requestParameters['createUpdateCardDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cardControllerUpdate(id: string, createUpdateCardDto: CreateUpdateCardDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cardControllerUpdateRaw({ id: id, createUpdateCardDto: createUpdateCardDto }, initOverrides);
    }

    /**
     */
    async certificateAuthorityControllerDownloadCertificateWithKeyRaw(requestParameters: CertificateAuthorityControllerDownloadCertificateWithKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling certificateAuthorityControllerDownloadCertificateWithKey().'
            );
        }

        if (requestParameters['pfxPasswordDto'] == null) {
            throw new runtime.RequiredError(
                'pfxPasswordDto',
                'Required parameter "pfxPasswordDto" was null or undefined when calling certificateAuthorityControllerDownloadCertificateWithKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/certificates/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PfxPasswordDtoToJSON(requestParameters['pfxPasswordDto']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async certificateAuthorityControllerDownloadCertificateWithKey(id: string, pfxPasswordDto: PfxPasswordDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.certificateAuthorityControllerDownloadCertificateWithKeyRaw({ id: id, pfxPasswordDto: pfxPasswordDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async certificateAuthorityControllerDownloadRootCARaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/certificates/root-ca/download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async certificateAuthorityControllerDownloadRootCA(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.certificateAuthorityControllerDownloadRootCARaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async certificateAuthorityControllerGenerateCertificateRaw(requestParameters: CertificateAuthorityControllerGenerateCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CertificateResponseDto>> {
        if (requestParameters['createCertificateDto'] == null) {
            throw new runtime.RequiredError(
                'createCertificateDto',
                'Required parameter "createCertificateDto" was null or undefined when calling certificateAuthorityControllerGenerateCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/certificates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCertificateDtoToJSON(requestParameters['createCertificateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CertificateResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async certificateAuthorityControllerGenerateCertificate(createCertificateDto: CreateCertificateDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CertificateResponseDto> {
        const response = await this.certificateAuthorityControllerGenerateCertificateRaw({ createCertificateDto: createCertificateDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async certificateAuthorityControllerGetAllByPortionRaw(requestParameters: CertificateAuthorityControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CertificateResponseDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling certificateAuthorityControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling certificateAuthorityControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/certificates/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CertificateResponseDtoFromJSON));
    }

    /**
     */
    async certificateAuthorityControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CertificateResponseDto>> {
        const response = await this.certificateAuthorityControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async certificateAuthorityControllerGetAllCountRaw(requestParameters: CertificateAuthorityControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling certificateAuthorityControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/certificates/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async certificateAuthorityControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.certificateAuthorityControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerCreateRaw(requestParameters: CompanyControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompanyDto>> {
        if (requestParameters['createUpdateCompanyDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateCompanyDto',
                'Required parameter "createUpdateCompanyDto" was null or undefined when calling companyControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateCompanyDtoToJSON(requestParameters['createUpdateCompanyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyDtoFromJSON(jsonValue));
    }

    /**
     */
    async companyControllerCreate(createUpdateCompanyDto: CreateUpdateCompanyDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompanyDto> {
        const response = await this.companyControllerCreateRaw({ createUpdateCompanyDto: createUpdateCompanyDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerDeleteExpectationExamsRaw(requestParameters: CompanyControllerDeleteExpectationExamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companyControllerDeleteExpectationExams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/deleteExpectationExams/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companyControllerDeleteExpectationExams(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companyControllerDeleteExpectationExamsRaw({ id: id }, initOverrides);
    }

    /**
     */
    async companyControllerGetRaw(requestParameters: CompanyControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompanyDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companyControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyDtoFromJSON(jsonValue));
    }

    /**
     */
    async companyControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompanyDto> {
        const response = await this.companyControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetAllByPortionRaw(requestParameters: CompanyControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling companyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling companyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling companyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling companyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling companyControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['monthlySettlement'] != null) {
            queryParameters['monthlySettlement'] = requestParameters['monthlySettlement'];
        }

        if (requestParameters['invoicesSettlement'] != null) {
            queryParameters['invoicesSettlement'] = requestParameters['invoicesSettlement'];
        }

        if (requestParameters['externalReferral'] != null) {
            queryParameters['externalReferral'] = requestParameters['externalReferral'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, monthlySettlement?: boolean, invoicesSettlement?: boolean, externalReferral?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, monthlySettlement: monthlySettlement, invoicesSettlement: invoicesSettlement, externalReferral: externalReferral }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetAllCountRaw(requestParameters: CompanyControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling companyControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['monthlySettlement'] != null) {
            queryParameters['monthlySettlement'] = requestParameters['monthlySettlement'];
        }

        if (requestParameters['invoicesSettlement'] != null) {
            queryParameters['invoicesSettlement'] = requestParameters['invoicesSettlement'];
        }

        if (requestParameters['externalReferral'] != null) {
            queryParameters['externalReferral'] = requestParameters['externalReferral'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async companyControllerGetAllCount(filterText: string, filterColumns?: string, monthlySettlement?: boolean, invoicesSettlement?: boolean, externalReferral?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.companyControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns, monthlySettlement: monthlySettlement, invoicesSettlement: invoicesSettlement, externalReferral: externalReferral }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetAllForExternalReferralRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/byExternalReferral/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetAllForExternalReferral(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetAllForExternalReferralRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetByEmailRaw(requestParameters: CompanyControllerGetByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        if (requestParameters['pattern'] == null) {
            throw new runtime.RequiredError(
                'pattern',
                'Required parameter "pattern" was null or undefined when calling companyControllerGetByEmail().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling companyControllerGetByEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pattern'] != null) {
            queryParameters['pattern'] = requestParameters['pattern'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/search/byEmail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetByEmail(pattern: string, limit: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetByEmailRaw({ pattern: pattern, limit: limit }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetByNipRaw(requestParameters: CompanyControllerGetByNipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        if (requestParameters['pattern'] == null) {
            throw new runtime.RequiredError(
                'pattern',
                'Required parameter "pattern" was null or undefined when calling companyControllerGetByNip().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling companyControllerGetByNip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pattern'] != null) {
            queryParameters['pattern'] = requestParameters['pattern'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/search/byNip`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetByNip(pattern: string, limit: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetByNipRaw({ pattern: pattern, limit: limit }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetByNipOrNameRaw(requestParameters: CompanyControllerGetByNipOrNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        if (requestParameters['pattern'] == null) {
            throw new runtime.RequiredError(
                'pattern',
                'Required parameter "pattern" was null or undefined when calling companyControllerGetByNipOrName().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling companyControllerGetByNipOrName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pattern'] != null) {
            queryParameters['pattern'] = requestParameters['pattern'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/search/byNipOrName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetByNipOrName(pattern: string, limit: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetByNipOrNameRaw({ pattern: pattern, limit: limit }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetByPatternRaw(requestParameters: CompanyControllerGetByPatternRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        if (requestParameters['pattern'] == null) {
            throw new runtime.RequiredError(
                'pattern',
                'Required parameter "pattern" was null or undefined when calling companyControllerGetByPattern().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling companyControllerGetByPattern().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pattern'] != null) {
            queryParameters['pattern'] = requestParameters['pattern'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/search/byName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetByPattern(pattern: string, limit: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetByPatternRaw({ pattern: pattern, limit: limit }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetLastEditorRaw(requestParameters: CompanyControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companyControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async companyControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.companyControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerGetMineRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanyDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/byMine/withBatteries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanyDtoFromJSON));
    }

    /**
     */
    async companyControllerGetMine(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanyDto>> {
        const response = await this.companyControllerGetMineRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async companyControllerUpdateRaw(requestParameters: CompanyControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companyControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateCompanyDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateCompanyDto',
                'Required parameter "createUpdateCompanyDto" was null or undefined when calling companyControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateCompanyDtoToJSON(requestParameters['createUpdateCompanyDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companyControllerUpdate(id: string, createUpdateCompanyDto: CreateUpdateCompanyDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companyControllerUpdateRaw({ id: id, createUpdateCompanyDto: createUpdateCompanyDto }, initOverrides);
    }

    /**
     */
    async consultationControllerCreateRaw(requestParameters: ConsultationControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConsultationDto>> {
        if (requestParameters['createUpdateConsultationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateConsultationDto',
                'Required parameter "createUpdateConsultationDto" was null or undefined when calling consultationControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consultation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateConsultationDtoToJSON(requestParameters['createUpdateConsultationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConsultationDtoFromJSON(jsonValue));
    }

    /**
     */
    async consultationControllerCreate(createUpdateConsultationDto: CreateUpdateConsultationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConsultationDto> {
        const response = await this.consultationControllerCreateRaw({ createUpdateConsultationDto: createUpdateConsultationDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async consultationControllerGetRaw(requestParameters: ConsultationControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConsultationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling consultationControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consultation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConsultationDtoFromJSON(jsonValue));
    }

    /**
     */
    async consultationControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConsultationDto> {
        const response = await this.consultationControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async consultationControllerGetAllByPortionRaw(requestParameters: ConsultationControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetConsultationDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling consultationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling consultationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling consultationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling consultationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling consultationControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consultation/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetConsultationDtoFromJSON));
    }

    /**
     */
    async consultationControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetConsultationDto>> {
        const response = await this.consultationControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async consultationControllerGetAllCountRaw(requestParameters: ConsultationControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling consultationControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consultation/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async consultationControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.consultationControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async consultationControllerGetForExamRaw(requestParameters: ConsultationControllerGetForExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetConsultationDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling consultationControllerGetForExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consultation/forExam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetConsultationDtoFromJSON));
    }

    /**
     */
    async consultationControllerGetForExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetConsultationDto>> {
        const response = await this.consultationControllerGetForExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async consultationControllerGetLastEditorRaw(requestParameters: ConsultationControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling consultationControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consultation/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async consultationControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.consultationControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async consultationControllerUpdateRaw(requestParameters: ConsultationControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling consultationControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateConsultationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateConsultationDto',
                'Required parameter "createUpdateConsultationDto" was null or undefined when calling consultationControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consultation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateConsultationDtoToJSON(requestParameters['createUpdateConsultationDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async consultationControllerUpdate(id: string, createUpdateConsultationDto: CreateUpdateConsultationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.consultationControllerUpdateRaw({ id: id, createUpdateConsultationDto: createUpdateConsultationDto }, initOverrides);
    }

    /**
     */
    async customFieldsControllerGetRaw(requestParameters: CustomFieldsControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomFieldsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling customFieldsControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customFields/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomFieldsDtoFromJSON(jsonValue));
    }

    /**
     */
    async customFieldsControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomFieldsDto> {
        const response = await this.customFieldsControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async customFieldsControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCustomFieldsDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customFields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCustomFieldsDtoFromJSON));
    }

    /**
     */
    async customFieldsControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCustomFieldsDto>> {
        const response = await this.customFieldsControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryControllerChangeToInactiveRaw(requestParameters: DictionaryControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dictionaryControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async dictionaryControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dictionaryControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async dictionaryControllerCreateRaw(requestParameters: DictionaryControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDictionaryDto>> {
        if (requestParameters['createUpdateDictionaryDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateDictionaryDto',
                'Required parameter "createUpdateDictionaryDto" was null or undefined when calling dictionaryControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDictionaryDtoToJSON(requestParameters['createUpdateDictionaryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDictionaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async dictionaryControllerCreate(createUpdateDictionaryDto: CreateUpdateDictionaryDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDictionaryDto> {
        const response = await this.dictionaryControllerCreateRaw({ createUpdateDictionaryDto: createUpdateDictionaryDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryControllerGetRaw(requestParameters: DictionaryControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDictionaryDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dictionaryControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary/byId/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDictionaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async dictionaryControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDictionaryDto> {
        const response = await this.dictionaryControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryControllerGetActiveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDictionaryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary/active`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDictionaryDtoFromJSON));
    }

    /**
     */
    async dictionaryControllerGetActive(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDictionaryDto>> {
        const response = await this.dictionaryControllerGetActiveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryControllerGetByTypeRaw(requestParameters: DictionaryControllerGetByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDictionaryDto>>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling dictionaryControllerGetByType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary/get/byType`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDictionaryDtoFromJSON));
    }

    /**
     */
    async dictionaryControllerGetByType(type: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDictionaryDto>> {
        const response = await this.dictionaryControllerGetByTypeRaw({ type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryControllerGetByTypeAndShortnameRaw(requestParameters: DictionaryControllerGetByTypeAndShortnameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDictionaryDto>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling dictionaryControllerGetByTypeAndShortname().'
            );
        }

        if (requestParameters['symbol'] == null) {
            throw new runtime.RequiredError(
                'symbol',
                'Required parameter "symbol" was null or undefined when calling dictionaryControllerGetByTypeAndShortname().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['symbol'] != null) {
            queryParameters['symbol'] = requestParameters['symbol'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary/get/byTypeAndShortname`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDictionaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async dictionaryControllerGetByTypeAndShortname(type: string, symbol: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDictionaryDto> {
        const response = await this.dictionaryControllerGetByTypeAndShortnameRaw({ type: type, symbol: symbol }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryControllerGetLastEditorRaw(requestParameters: DictionaryControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dictionaryControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async dictionaryControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.dictionaryControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryControllerUpdateRaw(requestParameters: DictionaryControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dictionaryControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateDictionaryDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateDictionaryDto',
                'Required parameter "createUpdateDictionaryDto" was null or undefined when calling dictionaryControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionary/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDictionaryDtoToJSON(requestParameters['createUpdateDictionaryDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async dictionaryControllerUpdate(id: string, createUpdateDictionaryDto: CreateUpdateDictionaryDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dictionaryControllerUpdateRaw({ id: id, createUpdateDictionaryDto: createUpdateDictionaryDto }, initOverrides);
    }

    /**
     */
    async dictionaryTypeControllerGetRaw(requestParameters: DictionaryTypeControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDictionaryTypeDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dictionaryTypeControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionaryType/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDictionaryTypeDtoFromJSON(jsonValue));
    }

    /**
     */
    async dictionaryTypeControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDictionaryTypeDto> {
        const response = await this.dictionaryTypeControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dictionaryTypeControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDictionaryTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dictionaryType`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDictionaryTypeDtoFromJSON));
    }

    /**
     */
    async dictionaryTypeControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDictionaryTypeDto>> {
        const response = await this.dictionaryTypeControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async documentationControllerGetExternalFileRaw(requestParameters: DocumentationControllerGetExternalFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentationDto>> {
        if (requestParameters['address'] == null) {
            throw new runtime.RequiredError(
                'address',
                'Required parameter "address" was null or undefined when calling documentationControllerGetExternalFile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['address'] != null) {
            queryParameters['address'] = requestParameters['address'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/documentation/external/byAddress`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentationDtoFromJSON(jsonValue));
    }

    /**
     */
    async documentationControllerGetExternalFile(address: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentationDto> {
        const response = await this.documentationControllerGetExternalFileRaw({ address: address }, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentationControllerGetForFilenameRaw(requestParameters: DocumentationControllerGetForFilenameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentationDto>> {
        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling documentationControllerGetForFilename().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/documentation/byFilename`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentationDtoFromJSON(jsonValue));
    }

    /**
     */
    async documentationControllerGetForFilename(filename: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentationDto> {
        const response = await this.documentationControllerGetForFilenameRaw({ filename: filename }, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentationControllerGetVersionInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVersionInfoDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/documentation/getVersionInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVersionInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async documentationControllerGetVersionInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVersionInfoDto> {
        const response = await this.documentationControllerGetVersionInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async downloadsFilesControllerDownloadsFilesCompanySummaryRaw(requestParameters: DownloadsFilesControllerDownloadsFilesCompanySummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling downloadsFilesControllerDownloadsFilesCompanySummary().'
            );
        }

        if (requestParameters['filterDownloadData'] == null) {
            throw new runtime.RequiredError(
                'filterDownloadData',
                'Required parameter "filterDownloadData" was null or undefined when calling downloadsFilesControllerDownloadsFilesCompanySummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/downloadsFiles/get/byCompanySummary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterDownloadDataToJSON(requestParameters['filterDownloadData']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadsFilesControllerDownloadsFilesCompanySummary(filename: string, filterDownloadData: FilterDownloadData, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadsFilesControllerDownloadsFilesCompanySummaryRaw({ filename: filename, filterDownloadData: filterDownloadData }, initOverrides);
        return await response.value();
    }

    /**
     */
    async downloadsFilesControllerDownloadsSalesInvoicesRaw(requestParameters: DownloadsFilesControllerDownloadsSalesInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling downloadsFilesControllerDownloadsSalesInvoices().'
            );
        }

        if (requestParameters['filterDownloadData'] == null) {
            throw new runtime.RequiredError(
                'filterDownloadData',
                'Required parameter "filterDownloadData" was null or undefined when calling downloadsFilesControllerDownloadsSalesInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/downloadsFiles/get/salesInvoices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterDownloadDataToJSON(requestParameters['filterDownloadData']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadsFilesControllerDownloadsSalesInvoices(filename: string, filterDownloadData: FilterDownloadData, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadsFilesControllerDownloadsSalesInvoicesRaw({ filename: filename, filterDownloadData: filterDownloadData }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dutyControllerCreateRaw(requestParameters: DutyControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDutyDto>> {
        if (requestParameters['createUpdateDutyDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateDutyDto',
                'Required parameter "createUpdateDutyDto" was null or undefined when calling dutyControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/duty`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDutyDtoToJSON(requestParameters['createUpdateDutyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDutyDtoFromJSON(jsonValue));
    }

    /**
     */
    async dutyControllerCreate(createUpdateDutyDto: CreateUpdateDutyDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDutyDto> {
        const response = await this.dutyControllerCreateRaw({ createUpdateDutyDto: createUpdateDutyDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dutyControllerGetRaw(requestParameters: DutyControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDutyDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dutyControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/duty/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDutyDtoFromJSON(jsonValue));
    }

    /**
     */
    async dutyControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDutyDto> {
        const response = await this.dutyControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dutyControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDutyDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/duty`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDutyDtoFromJSON));
    }

    /**
     */
    async dutyControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDutyDto>> {
        const response = await this.dutyControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async dutyControllerGetAllByPortionRaw(requestParameters: DutyControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDutyDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling dutyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling dutyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling dutyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling dutyControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling dutyControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/duty/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDutyDtoFromJSON));
    }

    /**
     */
    async dutyControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDutyDto>> {
        const response = await this.dutyControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dutyControllerGetAllCountRaw(requestParameters: DutyControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling dutyControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/duty/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async dutyControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.dutyControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async dutyControllerUpdateRaw(requestParameters: DutyControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dutyControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateDutyDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateDutyDto',
                'Required parameter "createUpdateDutyDto" was null or undefined when calling dutyControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/duty/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDutyDtoToJSON(requestParameters['createUpdateDutyDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async dutyControllerUpdate(id: string, createUpdateDutyDto: CreateUpdateDutyDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dutyControllerUpdateRaw({ id: id, createUpdateDutyDto: createUpdateDutyDto }, initOverrides);
    }

    /**
     */
    async emailControllerChangeToInactiveRaw(requestParameters: EmailControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emailControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async emailControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.emailControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async emailControllerGetAllByPortionRaw(requestParameters: EmailControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetEmailDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling emailControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling emailControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling emailControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling emailControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling emailControllerGetAllByPortion().'
            );
        }

        if (requestParameters['onlyNotSent'] == null) {
            throw new runtime.RequiredError(
                'onlyNotSent',
                'Required parameter "onlyNotSent" was null or undefined when calling emailControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['onlyNotSent'] != null) {
            queryParameters['onlyNotSent'] = requestParameters['onlyNotSent'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetEmailDtoFromJSON));
    }

    /**
     */
    async emailControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, onlyNotSent: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetEmailDto>> {
        const response = await this.emailControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, onlyNotSent: onlyNotSent }, initOverrides);
        return await response.value();
    }

    /**
     */
    async emailControllerGetAllCountRaw(requestParameters: EmailControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling emailControllerGetAllCount().'
            );
        }

        if (requestParameters['onlyNotSent'] == null) {
            throw new runtime.RequiredError(
                'onlyNotSent',
                'Required parameter "onlyNotSent" was null or undefined when calling emailControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['onlyNotSent'] != null) {
            queryParameters['onlyNotSent'] = requestParameters['onlyNotSent'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async emailControllerGetAllCount(filterText: string, onlyNotSent: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.emailControllerGetAllCountRaw({ filterText: filterText, onlyNotSent: onlyNotSent }, initOverrides);
        return await response.value();
    }

    /**
     */
    async emailControllerPreviewRaw(requestParameters: EmailControllerPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailPreviewDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emailControllerPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/preview/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailPreviewDtoFromJSON(jsonValue));
    }

    /**
     */
    async emailControllerPreview(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailPreviewDto> {
        const response = await this.emailControllerPreviewRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async emailControllerResendEmailRaw(requestParameters: EmailControllerResendEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmailDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emailControllerResendEmail().'
            );
        }

        if (requestParameters['toOverride'] == null) {
            throw new runtime.RequiredError(
                'toOverride',
                'Required parameter "toOverride" was null or undefined when calling emailControllerResendEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['toOverride'] != null) {
            queryParameters['toOverride'] = requestParameters['toOverride'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/resendEmail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmailDtoFromJSON(jsonValue));
    }

    /**
     */
    async emailControllerResendEmail(id: string, toOverride: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmailDto> {
        const response = await this.emailControllerResendEmailRaw({ id: id, toOverride: toOverride }, initOverrides);
        return await response.value();
    }

    /**
     */
    async emailControllerSendAllWaitingEmailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/sendAllWaitingEmails`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async emailControllerSendAllWaitingEmails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.emailControllerSendAllWaitingEmailsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async emailControllerSendJudgmentByEmailRaw(requestParameters: EmailControllerSendJudgmentByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmailDto>> {
        if (requestParameters['judgmentId'] == null) {
            throw new runtime.RequiredError(
                'judgmentId',
                'Required parameter "judgmentId" was null or undefined when calling emailControllerSendJudgmentByEmail().'
            );
        }

        if (requestParameters['english'] == null) {
            throw new runtime.RequiredError(
                'english',
                'Required parameter "english" was null or undefined when calling emailControllerSendJudgmentByEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['judgmentId'] != null) {
            queryParameters['judgmentId'] = requestParameters['judgmentId'];
        }

        if (requestParameters['english'] != null) {
            queryParameters['english'] = requestParameters['english'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/sendJudgmentByEmail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmailDtoFromJSON(jsonValue));
    }

    /**
     */
    async emailControllerSendJudgmentByEmail(judgmentId: string, english: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmailDto> {
        const response = await this.emailControllerSendJudgmentByEmailRaw({ judgmentId: judgmentId, english: english }, initOverrides);
        return await response.value();
    }

    /**
     */
    async emailControllerSendPsychologicalCardSummaryRaw(requestParameters: EmailControllerSendPsychologicalCardSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmailDto>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling emailControllerSendPsychologicalCardSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cardId'] != null) {
            queryParameters['cardId'] = requestParameters['cardId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/sendPsychologicalCardSummary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmailDtoFromJSON(jsonValue));
    }

    /**
     */
    async emailControllerSendPsychologicalCardSummary(cardId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmailDto> {
        const response = await this.emailControllerSendPsychologicalCardSummaryRaw({ cardId: cardId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async emailControllerSendReferralByEmailRaw(requestParameters: EmailControllerSendReferralByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmailDto>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling emailControllerSendReferralByEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['referralId'] != null) {
            queryParameters['referralId'] = requestParameters['referralId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/email/sendReferralByEmail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmailDtoFromJSON(jsonValue));
    }

    /**
     */
    async emailControllerSendReferralByEmail(referralId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmailDto> {
        const response = await this.emailControllerSendReferralByEmailRaw({ referralId: referralId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examBlockControllerBlockRaw(requestParameters: ExamBlockControllerBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamBlockDto>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examBlockControllerBlock().'
            );
        }

        if (requestParameters['createExamBlockDto'] == null) {
            throw new runtime.RequiredError(
                'createExamBlockDto',
                'Required parameter "createExamBlockDto" was null or undefined when calling examBlockControllerBlock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam-block/block/{examId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExamBlockDtoToJSON(requestParameters['createExamBlockDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamBlockDtoFromJSON(jsonValue));
    }

    /**
     */
    async examBlockControllerBlock(examId: string, createExamBlockDto: CreateExamBlockDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamBlockDto> {
        const response = await this.examBlockControllerBlockRaw({ examId: examId, createExamBlockDto: createExamBlockDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examBlockControllerGetActiveRaw(requestParameters: ExamBlockControllerGetActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamBlockDto>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examBlockControllerGetActive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam-block/active/{examId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamBlockDtoFromJSON(jsonValue));
    }

    /**
     */
    async examBlockControllerGetActive(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamBlockDto> {
        const response = await this.examBlockControllerGetActiveRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examBlockControllerGetForExamRaw(requestParameters: ExamBlockControllerGetForExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamBlockDto>>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examBlockControllerGetForExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam-block/forExam/{examId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamBlockDtoFromJSON));
    }

    /**
     */
    async examBlockControllerGetForExam(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamBlockDto>> {
        const response = await this.examBlockControllerGetForExamRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examBlockControllerGetLastEditorRaw(requestParameters: ExamBlockControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examBlockControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam-block/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async examBlockControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.examBlockControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examBlockControllerUnblockRaw(requestParameters: ExamBlockControllerUnblockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examBlockControllerUnblock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam-block/unblock/{examId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examBlockControllerUnblock(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examBlockControllerUnblockRaw({ examId: examId }, initOverrides);
    }

    /**
     */
    async examBlockControllerUpdateRaw(requestParameters: ExamBlockControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamBlockDto>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examBlockControllerUpdate().'
            );
        }

        if (requestParameters['createExamBlockDto'] == null) {
            throw new runtime.RequiredError(
                'createExamBlockDto',
                'Required parameter "createExamBlockDto" was null or undefined when calling examBlockControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam-block/update/{examId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExamBlockDtoToJSON(requestParameters['createExamBlockDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamBlockDtoFromJSON(jsonValue));
    }

    /**
     */
    async examBlockControllerUpdate(examId: string, createExamBlockDto: CreateExamBlockDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamBlockDto> {
        const response = await this.examBlockControllerUpdateRaw({ examId: examId, createExamBlockDto: createExamBlockDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerAlarmRaw(requestParameters: ExamControllerAlarmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerAlarm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/alarm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examControllerAlarm(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examControllerAlarmRaw({ id: id }, initOverrides);
    }

    /**
     */
    async examControllerChangeDatesRaw(requestParameters: ExamControllerChangeDatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerChangeDates().'
            );
        }

        if (requestParameters['examDateDto'] == null) {
            throw new runtime.RequiredError(
                'examDateDto',
                'Required parameter "examDateDto" was null or undefined when calling examControllerChangeDates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/exam/{id}/changeDates`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ExamDateDtoToJSON(requestParameters['examDateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examControllerChangeDates(id: string, examDateDto: ExamDateDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examControllerChangeDatesRaw({ id: id, examDateDto: examDateDto }, initOverrides);
    }

    /**
     */
    async examControllerChangeSexRaw(requestParameters: ExamControllerChangeSexRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerChangeSex().'
            );
        }

        if (requestParameters['examSexDto'] == null) {
            throw new runtime.RequiredError(
                'examSexDto',
                'Required parameter "examSexDto" was null or undefined when calling examControllerChangeSex().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/exam/{id}/changeSex`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ExamSexDtoToJSON(requestParameters['examSexDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examControllerChangeSex(id: string, examSexDto: ExamSexDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examControllerChangeSexRaw({ id: id, examSexDto: examSexDto }, initOverrides);
    }

    /**
     */
    async examControllerChangeToInactiveRaw(requestParameters: ExamControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async examControllerCreateWithTestsRaw(requestParameters: ExamControllerCreateWithTestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['createUpdateExamWithTestsDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamWithTestsDto',
                'Required parameter "createUpdateExamWithTestsDto" was null or undefined when calling examControllerCreateWithTests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/withTest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamWithTestsDtoToJSON(requestParameters['createUpdateExamWithTestsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerCreateWithTests(createUpdateExamWithTestsDto: CreateUpdateExamWithTestsDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerCreateWithTestsRaw({ createUpdateExamWithTestsDto: createUpdateExamWithTestsDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetRaw(requestParameters: ExamControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamDto> {
        const response = await this.examControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetActiveByPortionRaw(requestParameters: ExamControllerGetActiveByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetActiveByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetActiveByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetActiveByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetActiveByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetActiveByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchActive/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetActiveByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetActiveByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetActiveCountRaw(requestParameters: ExamControllerGetActiveCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetActiveCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchActive/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetActiveCount(filterText: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetActiveCountRaw({ filterText: filterText, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetAllByPortionRaw(requestParameters: ExamControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['onlyRemote'] != null) {
            queryParameters['onlyRemote'] = requestParameters['onlyRemote'];
        }

        if (requestParameters['onlyActive'] != null) {
            queryParameters['onlyActive'] = requestParameters['onlyActive'];
        }

        if (requestParameters['forFacility'] != null) {
            queryParameters['forFacility'] = requestParameters['forFacility'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = requestParameters['dateFrom'];
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = requestParameters['dateTo'];
        }

        if (requestParameters['withoutInvoiceAndReceipt'] != null) {
            queryParameters['withoutInvoiceAndReceipt'] = requestParameters['withoutInvoiceAndReceipt'];
        }

        if (requestParameters['completed'] != null) {
            queryParameters['completed'] = requestParameters['completed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, type?: string, onlyRemote?: boolean, onlyActive?: string, forFacility?: string, healthcareFacilityId?: string, companyId?: string, dateFrom?: string, dateTo?: string, withoutInvoiceAndReceipt?: string, completed?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, type: type, onlyRemote: onlyRemote, onlyActive: onlyActive, forFacility: forFacility, healthcareFacilityId: healthcareFacilityId, companyId: companyId, dateFrom: dateFrom, dateTo: dateTo, withoutInvoiceAndReceipt: withoutInvoiceAndReceipt, completed: completed }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetAllByTestByPortionRaw(requestParameters: ExamControllerGetAllByTestByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling examControllerGetAllByTestByPortion().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetAllByTestByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetAllByTestByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetAllByTestByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetAllByTestByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetAllByTestByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['testId'] != null) {
            queryParameters['testId'] = requestParameters['testId'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['completed'] != null) {
            queryParameters['completed'] = requestParameters['completed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchByTest/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetAllByTestByPortion(testId: string, pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, completed?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetAllByTestByPortionRaw({ testId: testId, pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, completed: completed }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetAllByTestCountRaw(requestParameters: ExamControllerGetAllByTestCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling examControllerGetAllByTestCount().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetAllByTestCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['testId'] != null) {
            queryParameters['testId'] = requestParameters['testId'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['completed'] != null) {
            queryParameters['completed'] = requestParameters['completed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchByTest/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetAllByTestCount(testId: string, filterText: string, filterColumns?: string, completed?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetAllByTestCountRaw({ testId: testId, filterText: filterText, filterColumns: filterColumns, completed: completed }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetAllCountRaw(requestParameters: ExamControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['onlyRemote'] != null) {
            queryParameters['onlyRemote'] = requestParameters['onlyRemote'];
        }

        if (requestParameters['onlyActive'] != null) {
            queryParameters['onlyActive'] = requestParameters['onlyActive'];
        }

        if (requestParameters['forFacility'] != null) {
            queryParameters['forFacility'] = requestParameters['forFacility'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = requestParameters['dateFrom'];
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = requestParameters['dateTo'];
        }

        if (requestParameters['withoutInvoiceAndReceipt'] != null) {
            queryParameters['withoutInvoiceAndReceipt'] = requestParameters['withoutInvoiceAndReceipt'];
        }

        if (requestParameters['completed'] != null) {
            queryParameters['completed'] = requestParameters['completed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetAllCount(filterText: string, filterColumns?: string, type?: string, onlyRemote?: boolean, onlyActive?: string, forFacility?: string, healthcareFacilityId?: string, companyId?: string, dateFrom?: string, dateTo?: string, withoutInvoiceAndReceipt?: string, completed?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns, type: type, onlyRemote: onlyRemote, onlyActive: onlyActive, forFacility: forFacility, healthcareFacilityId: healthcareFacilityId, companyId: companyId, dateFrom: dateFrom, dateTo: dateTo, withoutInvoiceAndReceipt: withoutInvoiceAndReceipt, completed: completed }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetAllIdsRaw(requestParameters: ExamControllerGetAllIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['onlyActive'] != null) {
            queryParameters['onlyActive'] = requestParameters['onlyActive'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = requestParameters['dateFrom'];
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = requestParameters['dateTo'];
        }

        if (requestParameters['withoutInvoiceAndReceipt'] != null) {
            queryParameters['withoutInvoiceAndReceipt'] = requestParameters['withoutInvoiceAndReceipt'];
        }

        if (requestParameters['completed'] != null) {
            queryParameters['completed'] = requestParameters['completed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/search/ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async examControllerGetAllIds(filterText?: string, filterColumns?: string, onlyActive?: string, companyId?: string, dateFrom?: string, dateTo?: string, withoutInvoiceAndReceipt?: string, completed?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.examControllerGetAllIdsRaw({ filterText: filterText, filterColumns: filterColumns, onlyActive: onlyActive, companyId: companyId, dateFrom: dateFrom, dateTo: dateTo, withoutInvoiceAndReceipt: withoutInvoiceAndReceipt, completed: completed }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetBlockedByPortionRaw(requestParameters: ExamControllerGetBlockedByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetBlockedByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetBlockedByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetBlockedByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetBlockedByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetBlockedByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchBlocked/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetBlockedByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, type?: ExamControllerGetBlockedByPortionTypeEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetBlockedByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetBlockedCountRaw(requestParameters: ExamControllerGetBlockedCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetBlockedCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchBlocked/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetBlockedCount(filterText: string, filterColumns?: string, type?: ExamControllerGetBlockedCountTypeEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetBlockedCountRaw({ filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetCriticalPointRaw(requestParameters: ExamControllerGetCriticalPointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCriticalPointDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerGetCriticalPoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/criticalPoint/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCriticalPointDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerGetCriticalPoint(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCriticalPointDto> {
        const response = await this.examControllerGetCriticalPointRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetCriticalPointDetailsRaw(requestParameters: ExamControllerGetCriticalPointDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCriticalPointDetailsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerGetCriticalPointDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/criticalPointDetails/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCriticalPointDetailsDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerGetCriticalPointDetails(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCriticalPointDetailsDto> {
        const response = await this.examControllerGetCriticalPointDetailsRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortionRaw(requestParameters: ExamControllerGetExamsWithAutoJudgmentWithoutPaymentByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithAutoJudgmentWithoutPayment/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetExamsWithAutoJudgmentWithoutPaymentByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetExamsWithAutoJudgmentWithoutPaymentCountRaw(requestParameters: ExamControllerGetExamsWithAutoJudgmentWithoutPaymentCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetExamsWithAutoJudgmentWithoutPaymentCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithAutoJudgmentWithoutPayment/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetExamsWithAutoJudgmentWithoutPaymentCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetExamsWithAutoJudgmentWithoutPaymentCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForAutomaticJudgmentByPortionRaw(requestParameters: ExamControllerGetForAutomaticJudgmentByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetForAutomaticJudgmentByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetForAutomaticJudgmentByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetForAutomaticJudgmentByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetForAutomaticJudgmentByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForAutomaticJudgmentByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForAutomaticJudgment/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetForAutomaticJudgmentByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetForAutomaticJudgmentByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForAutomaticJudgmentCountRaw(requestParameters: ExamControllerGetForAutomaticJudgmentCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForAutomaticJudgmentCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForAutomaticJudgment/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetForAutomaticJudgmentCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetForAutomaticJudgmentCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForExaminedByPortionRaw(requestParameters: ExamControllerGetForExaminedByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetForExaminedByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetForExaminedByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetForExaminedByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetForExaminedByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForExaminedByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['examinedId'] != null) {
            queryParameters['examinedId'] = requestParameters['examinedId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForExamined/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetForExaminedByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, examinedId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetForExaminedByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, examinedId: examinedId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForExaminedCountRaw(requestParameters: ExamControllerGetForExaminedCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForExaminedCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['examinedId'] != null) {
            queryParameters['examinedId'] = requestParameters['examinedId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForExamined/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetForExaminedCount(filterText: string, examinedId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetForExaminedCountRaw({ filterText: filterText, examinedId: examinedId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForPackageByPortionRaw(requestParameters: ExamControllerGetForPackageByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetForPackageByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetForPackageByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetForPackageByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetForPackageByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForPackageByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['examPackageId'] != null) {
            queryParameters['examPackageId'] = requestParameters['examPackageId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForPackage/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetForPackageByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, examPackageId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetForPackageByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, examPackageId: examPackageId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForPackageCountRaw(requestParameters: ExamControllerGetForPackageCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForPackageCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['examPackageId'] != null) {
            queryParameters['examPackageId'] = requestParameters['examPackageId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForPackage/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetForPackageCount(filterText: string, examPackageId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetForPackageCountRaw({ filterText: filterText, examPackageId: examPackageId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForSalesInvoiceByPortionRaw(requestParameters: ExamControllerGetForSalesInvoiceByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetForSalesInvoiceByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetForSalesInvoiceByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetForSalesInvoiceByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetForSalesInvoiceByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForSalesInvoiceByPortion().'
            );
        }

        if (requestParameters['salesInvoiceId'] == null) {
            throw new runtime.RequiredError(
                'salesInvoiceId',
                'Required parameter "salesInvoiceId" was null or undefined when calling examControllerGetForSalesInvoiceByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['salesInvoiceId'] != null) {
            queryParameters['salesInvoiceId'] = requestParameters['salesInvoiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForSalesInvoice/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetForSalesInvoiceByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, salesInvoiceId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetForSalesInvoiceByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, salesInvoiceId: salesInvoiceId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForSalesInvoiceCountRaw(requestParameters: ExamControllerGetForSalesInvoiceCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForSalesInvoiceCount().'
            );
        }

        if (requestParameters['salesInvoiceId'] == null) {
            throw new runtime.RequiredError(
                'salesInvoiceId',
                'Required parameter "salesInvoiceId" was null or undefined when calling examControllerGetForSalesInvoiceCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['salesInvoiceId'] != null) {
            queryParameters['salesInvoiceId'] = requestParameters['salesInvoiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForSalesInvoice/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetForSalesInvoiceCount(filterText: string, salesInvoiceId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetForSalesInvoiceCountRaw({ filterText: filterText, salesInvoiceId: salesInvoiceId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForSpecialistByPortionRaw(requestParameters: ExamControllerGetForSpecialistByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetForSpecialistByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetForSpecialistByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetForSpecialistByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetForSpecialistByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForSpecialistByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForSpecialist/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetForSpecialistByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetForSpecialistByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetForSpecialistCountRaw(requestParameters: ExamControllerGetForSpecialistCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetForSpecialistCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchForSpecialist/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetForSpecialistCount(filterText: string, filterColumns?: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetForSpecialistCountRaw({ filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetLastEditorRaw(requestParameters: ExamControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.examControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetSupervisorsRaw(requestParameters: ExamControllerGetSupervisorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupervisorsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerGetSupervisors().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/supervisors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupervisorsDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerGetSupervisors(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupervisorsDto> {
        const response = await this.examControllerGetSupervisorsRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetSupportingExaminationPreviewRaw(requestParameters: ExamControllerGetSupportingExaminationPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupportingExaminationPreviewDto>> {
        if (requestParameters['supportingExaminationPreviewRequestDto'] == null) {
            throw new runtime.RequiredError(
                'supportingExaminationPreviewRequestDto',
                'Required parameter "supportingExaminationPreviewRequestDto" was null or undefined when calling examControllerGetSupportingExaminationPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/supportingExaminationPreview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportingExaminationPreviewRequestDtoToJSON(requestParameters['supportingExaminationPreviewRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupportingExaminationPreviewDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerGetSupportingExaminationPreview(supportingExaminationPreviewRequestDto: SupportingExaminationPreviewRequestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupportingExaminationPreviewDto> {
        const response = await this.examControllerGetSupportingExaminationPreviewRaw({ supportingExaminationPreviewRequestDto: supportingExaminationPreviewRequestDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetSupportingExaminationPreviewByExamRaw(requestParameters: ExamControllerGetSupportingExaminationPreviewByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupportingExaminationPreviewDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerGetSupportingExaminationPreviewByExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/{id}/supportingExaminationPreview`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupportingExaminationPreviewDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerGetSupportingExaminationPreviewByExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupportingExaminationPreviewDto> {
        const response = await this.examControllerGetSupportingExaminationPreviewByExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetWithExaminedByPortionRaw(requestParameters: ExamControllerGetWithExaminedByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetWithExaminedByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetWithExaminedByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetWithExaminedByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetWithExaminedByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetWithExaminedByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithExamined/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetWithExaminedByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetWithExaminedByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetWithExaminedCountRaw(requestParameters: ExamControllerGetWithExaminedCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetWithExaminedCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithExamined/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetWithExaminedCount(filterText: string, filterColumns?: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetWithExaminedCountRaw({ filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetWithoutJudgmentByPortionRaw(requestParameters: ExamControllerGetWithoutJudgmentByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetWithoutJudgmentByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetWithoutJudgmentByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetWithoutJudgmentByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetWithoutJudgmentByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetWithoutJudgmentByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['onlyRemote'] != null) {
            queryParameters['onlyRemote'] = requestParameters['onlyRemote'];
        }

        if (requestParameters['forFacility'] != null) {
            queryParameters['forFacility'] = requestParameters['forFacility'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithoutJudgment/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetWithoutJudgmentByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, type?: string, onlyRemote?: boolean, forFacility?: string, healthcareFacilityId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetWithoutJudgmentByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, type: type, onlyRemote: onlyRemote, forFacility: forFacility, healthcareFacilityId: healthcareFacilityId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetWithoutJudgmentCountRaw(requestParameters: ExamControllerGetWithoutJudgmentCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetWithoutJudgmentCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['onlyRemote'] != null) {
            queryParameters['onlyRemote'] = requestParameters['onlyRemote'];
        }

        if (requestParameters['forFacility'] != null) {
            queryParameters['forFacility'] = requestParameters['forFacility'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithoutJudgment/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetWithoutJudgmentCount(filterText: string, filterColumns?: string, type?: string, onlyRemote?: boolean, forFacility?: string, healthcareFacilityId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetWithoutJudgmentCountRaw({ filterText: filterText, filterColumns: filterColumns, type: type, onlyRemote: onlyRemote, forFacility: forFacility, healthcareFacilityId: healthcareFacilityId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetWithoutJudgmentWithoutReferralsByPortionRaw(requestParameters: ExamControllerGetWithoutJudgmentWithoutReferralsByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examControllerGetWithoutJudgmentWithoutReferralsByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examControllerGetWithoutJudgmentWithoutReferralsByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examControllerGetWithoutJudgmentWithoutReferralsByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examControllerGetWithoutJudgmentWithoutReferralsByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetWithoutJudgmentWithoutReferralsByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithoutJudgmentWithoutReferrals/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async examControllerGetWithoutJudgmentWithoutReferralsByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.examControllerGetWithoutJudgmentWithoutReferralsByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerGetWithoutJudgmentWithoutReferralsCountRaw(requestParameters: ExamControllerGetWithoutJudgmentWithoutReferralsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examControllerGetWithoutJudgmentWithoutReferralsCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/searchWithoutJudgmentWithoutReferrals/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examControllerGetWithoutJudgmentWithoutReferralsCount(filterText: string, filterColumns?: string, type?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examControllerGetWithoutJudgmentWithoutReferralsCountRaw({ filterText: filterText, filterColumns: filterColumns, type: type }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examControllerSetOnlineRaw(requestParameters: ExamControllerSetOnlineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerSetOnline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/setOnline/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examControllerSetOnline(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examControllerSetOnlineRaw({ id: id }, initOverrides);
    }

    /**
     */
    async examControllerUpdateRaw(requestParameters: ExamControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateExamDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamDto',
                'Required parameter "createUpdateExamDto" was null or undefined when calling examControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamDtoToJSON(requestParameters['createUpdateExamDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examControllerUpdate(id: string, createUpdateExamDto: CreateUpdateExamDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examControllerUpdateRaw({ id: id, createUpdateExamDto: createUpdateExamDto }, initOverrides);
    }

    /**
     */
    async examControllerUpdateWithTestsRaw(requestParameters: ExamControllerUpdateWithTestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamDto>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examControllerUpdateWithTests().'
            );
        }

        if (requestParameters['createUpdateExamWithTestsDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamWithTestsDto',
                'Required parameter "createUpdateExamWithTestsDto" was null or undefined when calling examControllerUpdateWithTests().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/exam/withTest`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamWithTestsDtoToJSON(requestParameters['createUpdateExamWithTestsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamDtoFromJSON(jsonValue));
    }

    /**
     */
    async examControllerUpdateWithTests(examId: string, createUpdateExamWithTestsDto: CreateUpdateExamWithTestsDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamDto> {
        const response = await this.examControllerUpdateWithTestsRaw({ examId: examId, createUpdateExamWithTestsDto: createUpdateExamWithTestsDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTestControllerChangeDatesRaw(requestParameters: ExamTestControllerChangeDatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examTestControllerChangeDates().'
            );
        }

        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling examTestControllerChangeDates().'
            );
        }

        if (requestParameters['examTestDateDto'] == null) {
            throw new runtime.RequiredError(
                'examTestDateDto',
                'Required parameter "examTestDateDto" was null or undefined when calling examTestControllerChangeDates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTest/exam/{examId}/test/{testId}/changeDates`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))).replace(`{${"testId"}}`, encodeURIComponent(String(requestParameters['testId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ExamTestDateDtoToJSON(requestParameters['examTestDateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examTestControllerChangeDates(examId: string, testId: string, examTestDateDto: ExamTestDateDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examTestControllerChangeDatesRaw({ examId: examId, testId: testId, examTestDateDto: examTestDateDto }, initOverrides);
    }

    /**
     */
    async examTestControllerCreateRaw(requestParameters: ExamTestControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTestDto>> {
        if (requestParameters['createUpdateExamTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTestDto',
                'Required parameter "createUpdateExamTestDto" was null or undefined when calling examTestControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTestDtoToJSON(requestParameters['createUpdateExamTestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTestControllerCreate(createUpdateExamTestDto: CreateUpdateExamTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTestDto> {
        const response = await this.examTestControllerCreateRaw({ createUpdateExamTestDto: createUpdateExamTestDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTestControllerGetRaw(requestParameters: ExamTestControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTestDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTestControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTestControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTestDto> {
        const response = await this.examTestControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTestControllerGetByExamRaw(requestParameters: ExamTestControllerGetByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamTestDto>>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling examTestControllerGetByExam().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTest/get/byExam`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamTestDtoFromJSON));
    }

    /**
     */
    async examTestControllerGetByExam(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamTestDto>> {
        const response = await this.examTestControllerGetByExamRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTestControllerGetForExamByPortionRaw(requestParameters: ExamTestControllerGetForExamByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamTestDto>>> {
        if (requestParameters['exam'] == null) {
            throw new runtime.RequiredError(
                'exam',
                'Required parameter "exam" was null or undefined when calling examTestControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examTestControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examTestControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examTestControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examTestControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examTestControllerGetForExamByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['exam'] != null) {
            queryParameters['exam'] = requestParameters['exam'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTest/search/forExamByPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamTestDtoFromJSON));
    }

    /**
     */
    async examTestControllerGetForExamByPortion(exam: string, pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamTestDto>> {
        const response = await this.examTestControllerGetForExamByPortionRaw({ exam: exam, pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTestControllerGetForExamCountRaw(requestParameters: ExamTestControllerGetForExamCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['exam'] == null) {
            throw new runtime.RequiredError(
                'exam',
                'Required parameter "exam" was null or undefined when calling examTestControllerGetForExamCount().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examTestControllerGetForExamCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['exam'] != null) {
            queryParameters['exam'] = requestParameters['exam'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTest/search/forExamCount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examTestControllerGetForExamCount(exam: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examTestControllerGetForExamCountRaw({ exam: exam, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTestControllerUpdateRaw(requestParameters: ExamTestControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTestControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateExamTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTestDto',
                'Required parameter "createUpdateExamTestDto" was null or undefined when calling examTestControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTestDtoToJSON(requestParameters['createUpdateExamTestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examTestControllerUpdate(id: string, createUpdateExamTestDto: CreateUpdateExamTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examTestControllerUpdateRaw({ id: id, createUpdateExamTestDto: createUpdateExamTestDto }, initOverrides);
    }

    /**
     */
    async examTypeCategoryControllerChangeToInactiveRaw(requestParameters: ExamTypeCategoryControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeCategoryControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examTypeCategoryControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examTypeCategoryControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async examTypeCategoryControllerCreateRaw(requestParameters: ExamTypeCategoryControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTypeCategoryDto>> {
        if (requestParameters['createUpdateExamTypeCategoryDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTypeCategoryDto',
                'Required parameter "createUpdateExamTypeCategoryDto" was null or undefined when calling examTypeCategoryControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTypeCategoryDtoToJSON(requestParameters['createUpdateExamTypeCategoryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTypeCategoryDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeCategoryControllerCreate(createUpdateExamTypeCategoryDto: CreateUpdateExamTypeCategoryDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTypeCategoryDto> {
        const response = await this.examTypeCategoryControllerCreateRaw({ createUpdateExamTypeCategoryDto: createUpdateExamTypeCategoryDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeCategoryControllerGetRaw(requestParameters: ExamTypeCategoryControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTypeCategoryDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeCategoryControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTypeCategoryDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeCategoryControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTypeCategoryDto> {
        const response = await this.examTypeCategoryControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeCategoryControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamTypeCategoryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamTypeCategoryDtoFromJSON));
    }

    /**
     */
    async examTypeCategoryControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamTypeCategoryDto>> {
        const response = await this.examTypeCategoryControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeCategoryControllerGetAllByPortionRaw(requestParameters: ExamTypeCategoryControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamTypeCategoryDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examTypeCategoryControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examTypeCategoryControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamTypeCategoryDtoFromJSON));
    }

    /**
     */
    async examTypeCategoryControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamTypeCategoryDto>> {
        const response = await this.examTypeCategoryControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeCategoryControllerGetAllCountRaw(requestParameters: ExamTypeCategoryControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examTypeCategoryControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examTypeCategoryControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examTypeCategoryControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeCategoryControllerGetLastEditorRaw(requestParameters: ExamTypeCategoryControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeCategoryControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeCategoryControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.examTypeCategoryControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeCategoryControllerUpdateRaw(requestParameters: ExamTypeCategoryControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeCategoryControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateExamTypeCategoryDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTypeCategoryDto',
                'Required parameter "createUpdateExamTypeCategoryDto" was null or undefined when calling examTypeCategoryControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeCategory/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTypeCategoryDtoToJSON(requestParameters['createUpdateExamTypeCategoryDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examTypeCategoryControllerUpdate(id: string, createUpdateExamTypeCategoryDto: CreateUpdateExamTypeCategoryDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examTypeCategoryControllerUpdateRaw({ id: id, createUpdateExamTypeCategoryDto: createUpdateExamTypeCategoryDto }, initOverrides);
    }

    /**
     */
    async examTypeControllerChangeToInactiveRaw(requestParameters: ExamTypeControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examTypeControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examTypeControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async examTypeControllerCreateRaw(requestParameters: ExamTypeControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTypeDto>> {
        if (requestParameters['createUpdateExamTypeDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTypeDto',
                'Required parameter "createUpdateExamTypeDto" was null or undefined when calling examTypeControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTypeDtoToJSON(requestParameters['createUpdateExamTypeDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTypeDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeControllerCreate(createUpdateExamTypeDto: CreateUpdateExamTypeDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTypeDto> {
        const response = await this.examTypeControllerCreateRaw({ createUpdateExamTypeDto: createUpdateExamTypeDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeControllerGetRaw(requestParameters: ExamTypeControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTypeDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTypeDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTypeDto> {
        const response = await this.examTypeControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamTypeDtoFromJSON));
    }

    /**
     */
    async examTypeControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamTypeDto>> {
        const response = await this.examTypeControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeControllerGetAllByPortionRaw(requestParameters: ExamTypeControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamTypeDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examTypeControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examTypeControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamTypeDtoFromJSON));
    }

    /**
     */
    async examTypeControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamTypeDto>> {
        const response = await this.examTypeControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeControllerGetAllCountRaw(requestParameters: ExamTypeControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examTypeControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examTypeControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examTypeControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeControllerGetLastEditorRaw(requestParameters: ExamTypeControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.examTypeControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeControllerUpdateRaw(requestParameters: ExamTypeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateExamTypeDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTypeDto',
                'Required parameter "createUpdateExamTypeDto" was null or undefined when calling examTypeControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examType/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTypeDtoToJSON(requestParameters['createUpdateExamTypeDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examTypeControllerUpdate(id: string, createUpdateExamTypeDto: CreateUpdateExamTypeDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examTypeControllerUpdateRaw({ id: id, createUpdateExamTypeDto: createUpdateExamTypeDto }, initOverrides);
    }

    /**
     */
    async examTypeForChannelControllerCreateRaw(requestParameters: ExamTypeForChannelControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTypeForChannelDto>> {
        if (requestParameters['createUpdateExamTypeForChannelDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTypeForChannelDto',
                'Required parameter "createUpdateExamTypeForChannelDto" was null or undefined when calling examTypeForChannelControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeForChannel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTypeForChannelDtoToJSON(requestParameters['createUpdateExamTypeForChannelDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTypeForChannelDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeForChannelControllerCreate(createUpdateExamTypeForChannelDto: CreateUpdateExamTypeForChannelDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTypeForChannelDto> {
        const response = await this.examTypeForChannelControllerCreateRaw({ createUpdateExamTypeForChannelDto: createUpdateExamTypeForChannelDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeForChannelControllerGetRaw(requestParameters: ExamTypeForChannelControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamTypeForChannelDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeForChannelControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeForChannel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamTypeForChannelDtoFromJSON(jsonValue));
    }

    /**
     */
    async examTypeForChannelControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamTypeForChannelDto> {
        const response = await this.examTypeForChannelControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeForChannelControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamTypeForChannelDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeForChannel`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamTypeForChannelDtoFromJSON));
    }

    /**
     */
    async examTypeForChannelControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamTypeForChannelDto>> {
        const response = await this.examTypeForChannelControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async examTypeForChannelControllerUpdateRaw(requestParameters: ExamTypeForChannelControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examTypeForChannelControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateExamTypeForChannelDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamTypeForChannelDto',
                'Required parameter "createUpdateExamTypeForChannelDto" was null or undefined when calling examTypeForChannelControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examTypeForChannel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamTypeForChannelDtoToJSON(requestParameters['createUpdateExamTypeForChannelDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examTypeForChannelControllerUpdate(id: string, createUpdateExamTypeForChannelDto: CreateUpdateExamTypeForChannelDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examTypeForChannelControllerUpdateRaw({ id: id, createUpdateExamTypeForChannelDto: createUpdateExamTypeForChannelDto }, initOverrides);
    }

    /**
     */
    async examinedControllerChangeToInactiveRaw(requestParameters: ExaminedControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examinedControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examinedControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examinedControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async examinedControllerCreateRaw(requestParameters: ExaminedControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExaminedDto>> {
        if (requestParameters['createUpdateExaminedDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExaminedDto',
                'Required parameter "createUpdateExaminedDto" was null or undefined when calling examinedControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExaminedDtoToJSON(requestParameters['createUpdateExaminedDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExaminedDtoFromJSON(jsonValue));
    }

    /**
     */
    async examinedControllerCreate(createUpdateExaminedDto: CreateUpdateExaminedDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExaminedDto> {
        const response = await this.examinedControllerCreateRaw({ createUpdateExaminedDto: createUpdateExaminedDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetRaw(requestParameters: ExaminedControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExaminedDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examinedControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExaminedDtoFromJSON(jsonValue));
    }

    /**
     */
    async examinedControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExaminedDto> {
        const response = await this.examinedControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetAllByPortionRaw(requestParameters: ExaminedControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExaminedDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examinedControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examinedControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examinedControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examinedControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examinedControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExaminedDtoFromJSON));
    }

    /**
     */
    async examinedControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExaminedDto>> {
        const response = await this.examinedControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetAllCountRaw(requestParameters: ExaminedControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examinedControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examinedControllerGetAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examinedControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetByPeselOrNameRaw(requestParameters: ExaminedControllerGetByPeselOrNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExaminedDto>>> {
        if (requestParameters['pattern'] == null) {
            throw new runtime.RequiredError(
                'pattern',
                'Required parameter "pattern" was null or undefined when calling examinedControllerGetByPeselOrName().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling examinedControllerGetByPeselOrName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pattern'] != null) {
            queryParameters['pattern'] = requestParameters['pattern'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/search/byPeselOrName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExaminedDtoFromJSON));
    }

    /**
     */
    async examinedControllerGetByPeselOrName(pattern: string, limit: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExaminedDto>> {
        const response = await this.examinedControllerGetByPeselOrNameRaw({ pattern: pattern, limit: limit }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetCitiesByPatternRaw(requestParameters: ExaminedControllerGetCitiesByPatternRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['pattern'] == null) {
            throw new runtime.RequiredError(
                'pattern',
                'Required parameter "pattern" was null or undefined when calling examinedControllerGetCitiesByPattern().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling examinedControllerGetCitiesByPattern().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pattern'] != null) {
            queryParameters['pattern'] = requestParameters['pattern'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/cities/byName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async examinedControllerGetCitiesByPattern(pattern: string, limit: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.examinedControllerGetCitiesByPatternRaw({ pattern: pattern, limit: limit }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetCityByPostCodeRaw(requestParameters: ExaminedControllerGetCityByPostCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['postcode'] == null) {
            throw new runtime.RequiredError(
                'postcode',
                'Required parameter "postcode" was null or undefined when calling examinedControllerGetCityByPostCode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['postcode'] != null) {
            queryParameters['postcode'] = requestParameters['postcode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/city/byPostCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examinedControllerGetCityByPostCode(postcode: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.examinedControllerGetCityByPostCodeRaw({ postcode: postcode }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetLastEditorRaw(requestParameters: ExaminedControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examinedControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async examinedControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.examinedControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerGetStreetsByPatternRaw(requestParameters: ExaminedControllerGetStreetsByPatternRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['pattern'] == null) {
            throw new runtime.RequiredError(
                'pattern',
                'Required parameter "pattern" was null or undefined when calling examinedControllerGetStreetsByPattern().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling examinedControllerGetStreetsByPattern().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pattern'] != null) {
            queryParameters['pattern'] = requestParameters['pattern'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/streets/byName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async examinedControllerGetStreetsByPattern(pattern: string, limit: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.examinedControllerGetStreetsByPatternRaw({ pattern: pattern, limit: limit }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examinedControllerMergeExaminedRaw(requestParameters: ExaminedControllerMergeExaminedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['examinedDeleteId'] == null) {
            throw new runtime.RequiredError(
                'examinedDeleteId',
                'Required parameter "examinedDeleteId" was null or undefined when calling examinedControllerMergeExamined().'
            );
        }

        if (requestParameters['examinedStayId'] == null) {
            throw new runtime.RequiredError(
                'examinedStayId',
                'Required parameter "examinedStayId" was null or undefined when calling examinedControllerMergeExamined().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examinedDeleteId'] != null) {
            queryParameters['examinedDeleteId'] = requestParameters['examinedDeleteId'];
        }

        if (requestParameters['examinedStayId'] != null) {
            queryParameters['examinedStayId'] = requestParameters['examinedStayId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/merge/examined`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examinedControllerMergeExamined(examinedDeleteId: string, examinedStayId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examinedControllerMergeExaminedRaw({ examinedDeleteId: examinedDeleteId, examinedStayId: examinedStayId }, initOverrides);
    }

    /**
     */
    async examinedControllerUpdateRaw(requestParameters: ExaminedControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examinedControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateExaminedDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExaminedDto',
                'Required parameter "createUpdateExaminedDto" was null or undefined when calling examinedControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examined/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExaminedDtoToJSON(requestParameters['createUpdateExaminedDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examinedControllerUpdate(id: string, createUpdateExaminedDto: CreateUpdateExaminedDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examinedControllerUpdateRaw({ id: id, createUpdateExaminedDto: createUpdateExaminedDto }, initOverrides);
    }

    /**
     */
    async examsPackageControllerDeleteExpectationExamsRaw(requestParameters: ExamsPackageControllerDeleteExpectationExamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examsPackageControllerDeleteExpectationExams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examsPackage/deleteExpectationExams/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examsPackageControllerDeleteExpectationExams(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examsPackageControllerDeleteExpectationExamsRaw({ id: id }, initOverrides);
    }

    /**
     */
    async examsPackageControllerGetRaw(requestParameters: ExamsPackageControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExamsPackageDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examsPackageControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examsPackage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExamsPackageDtoFromJSON(jsonValue));
    }

    /**
     */
    async examsPackageControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExamsPackageDto> {
        const response = await this.examsPackageControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examsPackageControllerGetAllByPortionRaw(requestParameters: ExamsPackageControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamsPackageDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling examsPackageControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling examsPackageControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling examsPackageControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling examsPackageControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examsPackageControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['onlyWithWaitingExams'] != null) {
            queryParameters['onlyWithWaitingExams'] = requestParameters['onlyWithWaitingExams'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examsPackage/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamsPackageDtoFromJSON));
    }

    /**
     */
    async examsPackageControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, type?: string, onlyWithWaitingExams?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamsPackageDto>> {
        const response = await this.examsPackageControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, type: type, onlyWithWaitingExams: onlyWithWaitingExams }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examsPackageControllerGetAllCountRaw(requestParameters: ExamsPackageControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling examsPackageControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['onlyWithWaitingExams'] != null) {
            queryParameters['onlyWithWaitingExams'] = requestParameters['onlyWithWaitingExams'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examsPackage/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examsPackageControllerGetAllCount(filterText: string, filterColumns?: string, type?: string, onlyWithWaitingExams?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.examsPackageControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns, type: type, onlyWithWaitingExams: onlyWithWaitingExams }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examsPackageControllerGetExpectationPinsRaw(requestParameters: ExamsPackageControllerGetExpectationPinsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examsPackageControllerGetExpectationPins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examsPackage/getExpectationPins/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async examsPackageControllerGetExpectationPins(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.examsPackageControllerGetExpectationPinsRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examsPackageControllerGetLastEditorRaw(requestParameters: ExamsPackageControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examsPackageControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examsPackage/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async examsPackageControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.examsPackageControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async examsPackageControllerUpdateRaw(requestParameters: ExamsPackageControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling examsPackageControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateExamsPackageDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExamsPackageDto',
                'Required parameter "createUpdateExamsPackageDto" was null or undefined when calling examsPackageControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/examsPackage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExamsPackageDtoToJSON(requestParameters['createUpdateExamsPackageDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async examsPackageControllerUpdate(id: string, createUpdateExamsPackageDto: CreateUpdateExamsPackageDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.examsPackageControllerUpdateRaw({ id: id, createUpdateExamsPackageDto: createUpdateExamsPackageDto }, initOverrides);
    }

    /**
     */
    async exportControllerExportTestResultsRaw(requestParameters: ExportControllerExportTestResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['ident'] == null) {
            throw new runtime.RequiredError(
                'ident',
                'Required parameter "ident" was null or undefined when calling exportControllerExportTestResults().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/export/exportTestResults/{ident}`.replace(`{${"ident"}}`, encodeURIComponent(String(requestParameters['ident']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportControllerExportTestResults(ident: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportControllerExportTestResultsRaw({ ident: ident }, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalReferralControllerCreateRaw(requestParameters: ExternalReferralControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createUpdateExternalReferralDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateExternalReferralDto',
                'Required parameter "createUpdateExternalReferralDto" was null or undefined when calling externalReferralControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/externalReferral`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateExternalReferralDtoToJSON(requestParameters['createUpdateExternalReferralDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async externalReferralControllerCreate(createUpdateExternalReferralDto: CreateUpdateExternalReferralDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.externalReferralControllerCreateRaw({ createUpdateExternalReferralDto: createUpdateExternalReferralDto }, initOverrides);
    }

    /**
     */
    async externalReferralControllerGetAllByPortionRaw(requestParameters: ExternalReferralControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling externalReferralControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling externalReferralControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling externalReferralControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling externalReferralControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling externalReferralControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/externalReferral/all/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async externalReferralControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, companyId?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.externalReferralControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, companyId: companyId, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalReferralControllerGetAllCountRaw(requestParameters: ExternalReferralControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling externalReferralControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/externalReferral/all/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async externalReferralControllerGetAllCount(filterText: string, companyId?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.externalReferralControllerGetAllCountRaw({ filterText: filterText, companyId: companyId, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalReferralControllerGetByCompaniesByPortionRaw(requestParameters: ExternalReferralControllerGetByCompaniesByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling externalReferralControllerGetByCompaniesByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling externalReferralControllerGetByCompaniesByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling externalReferralControllerGetByCompaniesByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling externalReferralControllerGetByCompaniesByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling externalReferralControllerGetByCompaniesByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/externalReferral/byCompany/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async externalReferralControllerGetByCompaniesByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.externalReferralControllerGetByCompaniesByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalReferralControllerGetByCompaniesCountRaw(requestParameters: ExternalReferralControllerGetByCompaniesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling externalReferralControllerGetByCompaniesCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/externalReferral/byCompany/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async externalReferralControllerGetByCompaniesCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.externalReferralControllerGetByCompaniesCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalReferralControllerGetWithoutJudgmentsByPortionRaw(requestParameters: ExternalReferralControllerGetWithoutJudgmentsByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetExamDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling externalReferralControllerGetWithoutJudgmentsByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling externalReferralControllerGetWithoutJudgmentsByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling externalReferralControllerGetWithoutJudgmentsByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling externalReferralControllerGetWithoutJudgmentsByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling externalReferralControllerGetWithoutJudgmentsByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/externalReferral/withoutJudgments/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExamDtoFromJSON));
    }

    /**
     */
    async externalReferralControllerGetWithoutJudgmentsByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, companyId?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetExamDto>> {
        const response = await this.externalReferralControllerGetWithoutJudgmentsByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, companyId: companyId, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalReferralControllerGetWithoutJudgmentsCountRaw(requestParameters: ExternalReferralControllerGetWithoutJudgmentsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling externalReferralControllerGetWithoutJudgmentsCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/externalReferral/withoutJudgments/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async externalReferralControllerGetWithoutJudgmentsCount(filterText: string, companyId?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.externalReferralControllerGetWithoutJudgmentsCountRaw({ filterText: filterText, companyId: companyId, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterControllerGenerateAndPrintReceiptRaw(requestParameters: FiscalPrinterControllerGenerateAndPrintReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateReceiptResponseDto>> {
        if (requestParameters['generateReceiptDto'] == null) {
            throw new runtime.RequiredError(
                'generateReceiptDto',
                'Required parameter "generateReceiptDto" was null or undefined when calling fiscalPrinterControllerGenerateAndPrintReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/fiscal-printer/receipt`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateReceiptDtoToJSON(requestParameters['generateReceiptDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async fiscalPrinterControllerGenerateAndPrintReceipt(generateReceiptDto: GenerateReceiptDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateReceiptResponseDto> {
        const response = await this.fiscalPrinterControllerGenerateAndPrintReceiptRaw({ generateReceiptDto: generateReceiptDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterControllerGenerateEReceiptConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XmlProtocolResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/fiscal-printer/ereceipt-config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => XmlProtocolResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async fiscalPrinterControllerGenerateEReceiptConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XmlProtocolResponseDto> {
        const response = await this.fiscalPrinterControllerGenerateEReceiptConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerAcquireLockRaw(requestParameters: FiscalPrinterLocationControllerAcquireLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcquirePrinterLockResponseDto>> {
        if (requestParameters['acquirePrinterLockDto'] == null) {
            throw new runtime.RequiredError(
                'acquirePrinterLockDto',
                'Required parameter "acquirePrinterLockDto" was null or undefined when calling fiscalPrinterLocationControllerAcquireLock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/token/lock`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcquirePrinterLockDtoToJSON(requestParameters['acquirePrinterLockDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcquirePrinterLockResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async fiscalPrinterLocationControllerAcquireLock(acquirePrinterLockDto: AcquirePrinterLockDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcquirePrinterLockResponseDto> {
        const response = await this.fiscalPrinterLocationControllerAcquireLockRaw({ acquirePrinterLockDto: acquirePrinterLockDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerCreateRaw(requestParameters: FiscalPrinterLocationControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFiscalPrinterLocationDto>> {
        if (requestParameters['createUpdateFiscalPrinterLocationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateFiscalPrinterLocationDto',
                'Required parameter "createUpdateFiscalPrinterLocationDto" was null or undefined when calling fiscalPrinterLocationControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateFiscalPrinterLocationDtoToJSON(requestParameters['createUpdateFiscalPrinterLocationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFiscalPrinterLocationDtoFromJSON(jsonValue));
    }

    /**
     */
    async fiscalPrinterLocationControllerCreate(createUpdateFiscalPrinterLocationDto: CreateUpdateFiscalPrinterLocationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFiscalPrinterLocationDto> {
        const response = await this.fiscalPrinterLocationControllerCreateRaw({ createUpdateFiscalPrinterLocationDto: createUpdateFiscalPrinterLocationDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerDeleteRaw(requestParameters: FiscalPrinterLocationControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling fiscalPrinterLocationControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fiscalPrinterLocationControllerDelete(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fiscalPrinterLocationControllerDeleteRaw({ id: id }, initOverrides);
    }

    /**
     */
    async fiscalPrinterLocationControllerGetRaw(requestParameters: FiscalPrinterLocationControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFiscalPrinterLocationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling fiscalPrinterLocationControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFiscalPrinterLocationDtoFromJSON(jsonValue));
    }

    /**
     */
    async fiscalPrinterLocationControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFiscalPrinterLocationDto> {
        const response = await this.fiscalPrinterLocationControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFiscalPrinterLocationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFiscalPrinterLocationDtoFromJSON));
    }

    /**
     */
    async fiscalPrinterLocationControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFiscalPrinterLocationDto>> {
        const response = await this.fiscalPrinterLocationControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerGetAllByPortionRaw(requestParameters: FiscalPrinterLocationControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFiscalPrinterLocationDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling fiscalPrinterLocationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling fiscalPrinterLocationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling fiscalPrinterLocationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling fiscalPrinterLocationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling fiscalPrinterLocationControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFiscalPrinterLocationDtoFromJSON));
    }

    /**
     */
    async fiscalPrinterLocationControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFiscalPrinterLocationDto>> {
        const response = await this.fiscalPrinterLocationControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerGetAllCountRaw(requestParameters: FiscalPrinterLocationControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling fiscalPrinterLocationControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async fiscalPrinterLocationControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.fiscalPrinterLocationControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerGetTokenRaw(requestParameters: FiscalPrinterLocationControllerGetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrinterTokenDto>> {
        if (requestParameters['url'] == null) {
            throw new runtime.RequiredError(
                'url',
                'Required parameter "url" was null or undefined when calling fiscalPrinterLocationControllerGetToken().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrinterTokenDtoFromJSON(jsonValue));
    }

    /**
     */
    async fiscalPrinterLocationControllerGetToken(url: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrinterTokenDto> {
        const response = await this.fiscalPrinterLocationControllerGetTokenRaw({ url: url }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fiscalPrinterLocationControllerReleaseLockRaw(requestParameters: FiscalPrinterLocationControllerReleaseLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['releasePrinterLockDto'] == null) {
            throw new runtime.RequiredError(
                'releasePrinterLockDto',
                'Required parameter "releasePrinterLockDto" was null or undefined when calling fiscalPrinterLocationControllerReleaseLock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/token/release`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReleasePrinterLockDtoToJSON(requestParameters['releasePrinterLockDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fiscalPrinterLocationControllerReleaseLock(releasePrinterLockDto: ReleasePrinterLockDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fiscalPrinterLocationControllerReleaseLockRaw({ releasePrinterLockDto: releasePrinterLockDto }, initOverrides);
    }

    /**
     */
    async fiscalPrinterLocationControllerSetTokenRaw(requestParameters: FiscalPrinterLocationControllerSetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['setPrinterTokenDto'] == null) {
            throw new runtime.RequiredError(
                'setPrinterTokenDto',
                'Required parameter "setPrinterTokenDto" was null or undefined when calling fiscalPrinterLocationControllerSetToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetPrinterTokenDtoToJSON(requestParameters['setPrinterTokenDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fiscalPrinterLocationControllerSetToken(setPrinterTokenDto: SetPrinterTokenDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fiscalPrinterLocationControllerSetTokenRaw({ setPrinterTokenDto: setPrinterTokenDto }, initOverrides);
    }

    /**
     */
    async fiscalPrinterLocationControllerUpdateRaw(requestParameters: FiscalPrinterLocationControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling fiscalPrinterLocationControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateFiscalPrinterLocationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateFiscalPrinterLocationDto',
                'Required parameter "createUpdateFiscalPrinterLocationDto" was null or undefined when calling fiscalPrinterLocationControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fiscalPrinterLocation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateFiscalPrinterLocationDtoToJSON(requestParameters['createUpdateFiscalPrinterLocationDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fiscalPrinterLocationControllerUpdate(id: string, createUpdateFiscalPrinterLocationDto: CreateUpdateFiscalPrinterLocationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fiscalPrinterLocationControllerUpdateRaw({ id: id, createUpdateFiscalPrinterLocationDto: createUpdateFiscalPrinterLocationDto }, initOverrides);
    }

    /**
     */
    async gusApiControllerGetByNipRaw(requestParameters: GusApiControllerGetByNipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GusClientDto>> {
        if (requestParameters['nip'] == null) {
            throw new runtime.RequiredError(
                'nip',
                'Required parameter "nip" was null or undefined when calling gusApiControllerGetByNip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nip'] != null) {
            queryParameters['nip'] = requestParameters['nip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/gusApi/nip`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GusClientDtoFromJSON(jsonValue));
    }

    /**
     */
    async gusApiControllerGetByNip(nip: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GusClientDto> {
        const response = await this.gusApiControllerGetByNipRaw({ nip: nip }, initOverrides);
        return await response.value();
    }

    /**
     */
    async harmfulFactorControllerCreateRaw(requestParameters: HarmfulFactorControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHarmfulFactorDto>> {
        if (requestParameters['createUpdateHarmfulFactorDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateHarmfulFactorDto',
                'Required parameter "createUpdateHarmfulFactorDto" was null or undefined when calling harmfulFactorControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/harmfulFactor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateHarmfulFactorDtoToJSON(requestParameters['createUpdateHarmfulFactorDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHarmfulFactorDtoFromJSON(jsonValue));
    }

    /**
     */
    async harmfulFactorControllerCreate(createUpdateHarmfulFactorDto: CreateUpdateHarmfulFactorDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHarmfulFactorDto> {
        const response = await this.harmfulFactorControllerCreateRaw({ createUpdateHarmfulFactorDto: createUpdateHarmfulFactorDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async harmfulFactorControllerGetRaw(requestParameters: HarmfulFactorControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHarmfulFactorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling harmfulFactorControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/harmfulFactor/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHarmfulFactorDtoFromJSON(jsonValue));
    }

    /**
     */
    async harmfulFactorControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHarmfulFactorDto> {
        const response = await this.harmfulFactorControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async harmfulFactorControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetHarmfulFactorDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/harmfulFactor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetHarmfulFactorDtoFromJSON));
    }

    /**
     */
    async harmfulFactorControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetHarmfulFactorDto>> {
        const response = await this.harmfulFactorControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async harmfulFactorControllerGetAllByPortionRaw(requestParameters: HarmfulFactorControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetHarmfulFactorDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling harmfulFactorControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling harmfulFactorControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling harmfulFactorControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling harmfulFactorControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling harmfulFactorControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/harmfulFactor/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetHarmfulFactorDtoFromJSON));
    }

    /**
     */
    async harmfulFactorControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetHarmfulFactorDto>> {
        const response = await this.harmfulFactorControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async harmfulFactorControllerGetAllCountRaw(requestParameters: HarmfulFactorControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling harmfulFactorControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/harmfulFactor/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async harmfulFactorControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.harmfulFactorControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async harmfulFactorControllerGetLastEditorRaw(requestParameters: HarmfulFactorControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling harmfulFactorControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/harmfulFactor/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async harmfulFactorControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.harmfulFactorControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async harmfulFactorControllerUpdateRaw(requestParameters: HarmfulFactorControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling harmfulFactorControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateHarmfulFactorDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateHarmfulFactorDto',
                'Required parameter "createUpdateHarmfulFactorDto" was null or undefined when calling harmfulFactorControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/harmfulFactor/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateHarmfulFactorDtoToJSON(requestParameters['createUpdateHarmfulFactorDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async harmfulFactorControllerUpdate(id: string, createUpdateHarmfulFactorDto: CreateUpdateHarmfulFactorDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.harmfulFactorControllerUpdateRaw({ id: id, createUpdateHarmfulFactorDto: createUpdateHarmfulFactorDto }, initOverrides);
    }

    /**
     */
    async healthcareFacilityControllerCreateRaw(requestParameters: HealthcareFacilityControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHealthcareFacilityDto>> {
        if (requestParameters['createUpdateHealthcareFacilityDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateHealthcareFacilityDto',
                'Required parameter "createUpdateHealthcareFacilityDto" was null or undefined when calling healthcareFacilityControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateHealthcareFacilityDtoToJSON(requestParameters['createUpdateHealthcareFacilityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHealthcareFacilityDtoFromJSON(jsonValue));
    }

    /**
     */
    async healthcareFacilityControllerCreate(createUpdateHealthcareFacilityDto: CreateUpdateHealthcareFacilityDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHealthcareFacilityDto> {
        const response = await this.healthcareFacilityControllerCreateRaw({ createUpdateHealthcareFacilityDto: createUpdateHealthcareFacilityDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetRaw(requestParameters: HealthcareFacilityControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHealthcareFacilityDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling healthcareFacilityControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHealthcareFacilityDtoFromJSON(jsonValue));
    }

    /**
     */
    async healthcareFacilityControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHealthcareFacilityDto> {
        const response = await this.healthcareFacilityControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetAllRaw(requestParameters: HealthcareFacilityControllerGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetHealthcareFacilityDto>>> {
        const queryParameters: any = {};

        if (requestParameters['canSeeAll'] != null) {
            queryParameters['canSeeAll'] = requestParameters['canSeeAll'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/getAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetHealthcareFacilityDtoFromJSON));
    }

    /**
     */
    async healthcareFacilityControllerGetAll(canSeeAll?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetHealthcareFacilityDto>> {
        const response = await this.healthcareFacilityControllerGetAllRaw({ canSeeAll: canSeeAll }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetAllByPortionRaw(requestParameters: HealthcareFacilityControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetHealthcareFacilityDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling healthcareFacilityControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling healthcareFacilityControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling healthcareFacilityControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling healthcareFacilityControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling healthcareFacilityControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetHealthcareFacilityDtoFromJSON));
    }

    /**
     */
    async healthcareFacilityControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetHealthcareFacilityDto>> {
        const response = await this.healthcareFacilityControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetAllCountRaw(requestParameters: HealthcareFacilityControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling healthcareFacilityControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async healthcareFacilityControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.healthcareFacilityControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetAllHistoricalByPortionRaw(requestParameters: HealthcareFacilityControllerGetAllHistoricalByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetHealthcareFacilityDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling healthcareFacilityControllerGetAllHistoricalByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling healthcareFacilityControllerGetAllHistoricalByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling healthcareFacilityControllerGetAllHistoricalByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling healthcareFacilityControllerGetAllHistoricalByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling healthcareFacilityControllerGetAllHistoricalByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/historicalSearch/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetHealthcareFacilityDtoFromJSON));
    }

    /**
     */
    async healthcareFacilityControllerGetAllHistoricalByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetHealthcareFacilityDto>> {
        const response = await this.healthcareFacilityControllerGetAllHistoricalByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetAllHistoricalCountRaw(requestParameters: HealthcareFacilityControllerGetAllHistoricalCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling healthcareFacilityControllerGetAllHistoricalCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/historicalSearch/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async healthcareFacilityControllerGetAllHistoricalCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.healthcareFacilityControllerGetAllHistoricalCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetDefaultRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/get/default`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async healthcareFacilityControllerGetDefault(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.healthcareFacilityControllerGetDefaultRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetLastEditorRaw(requestParameters: HealthcareFacilityControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling healthcareFacilityControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async healthcareFacilityControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.healthcareFacilityControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerGetWithDataIdRaw(requestParameters: HealthcareFacilityControllerGetWithDataIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHealthcareFacilityDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling healthcareFacilityControllerGetWithDataId().'
            );
        }

        if (requestParameters['dataId'] == null) {
            throw new runtime.RequiredError(
                'dataId',
                'Required parameter "dataId" was null or undefined when calling healthcareFacilityControllerGetWithDataId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/getWithData/{id}/{dataId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"dataId"}}`, encodeURIComponent(String(requestParameters['dataId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHealthcareFacilityDtoFromJSON(jsonValue));
    }

    /**
     */
    async healthcareFacilityControllerGetWithDataId(id: string, dataId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHealthcareFacilityDto> {
        const response = await this.healthcareFacilityControllerGetWithDataIdRaw({ id: id, dataId: dataId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerSetFlagRaw(requestParameters: HealthcareFacilityControllerSetFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHealthcareFacilityDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling healthcareFacilityControllerSetFlag().'
            );
        }

        if (requestParameters['setFlagHealthcareFacilityDto'] == null) {
            throw new runtime.RequiredError(
                'setFlagHealthcareFacilityDto',
                'Required parameter "setFlagHealthcareFacilityDto" was null or undefined when calling healthcareFacilityControllerSetFlag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/setFlag/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SetFlagHealthcareFacilityDtoToJSON(requestParameters['setFlagHealthcareFacilityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHealthcareFacilityDtoFromJSON(jsonValue));
    }

    /**
     */
    async healthcareFacilityControllerSetFlag(id: string, setFlagHealthcareFacilityDto: SetFlagHealthcareFacilityDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHealthcareFacilityDto> {
        const response = await this.healthcareFacilityControllerSetFlagRaw({ id: id, setFlagHealthcareFacilityDto: setFlagHealthcareFacilityDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthcareFacilityControllerUpdateRaw(requestParameters: HealthcareFacilityControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling healthcareFacilityControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateHealthcareFacilityDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateHealthcareFacilityDto',
                'Required parameter "createUpdateHealthcareFacilityDto" was null or undefined when calling healthcareFacilityControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/healthcareFacility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateHealthcareFacilityDtoToJSON(requestParameters['createUpdateHealthcareFacilityDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async healthcareFacilityControllerUpdate(id: string, createUpdateHealthcareFacilityDto: CreateUpdateHealthcareFacilityDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.healthcareFacilityControllerUpdateRaw({ id: id, createUpdateHealthcareFacilityDto: createUpdateHealthcareFacilityDto }, initOverrides);
    }

    /**
     */
    async indicatorTestControllerCalculateResultsRaw(requestParameters: IndicatorTestControllerCalculateResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetIndicatorTestRecalculatedSimpleDto>>> {
        if (requestParameters['testFileName'] == null) {
            throw new runtime.RequiredError(
                'testFileName',
                'Required parameter "testFileName" was null or undefined when calling indicatorTestControllerCalculateResults().'
            );
        }

        if (requestParameters['calculateResultsDto'] == null) {
            throw new runtime.RequiredError(
                'calculateResultsDto',
                'Required parameter "calculateResultsDto" was null or undefined when calling indicatorTestControllerCalculateResults().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['testFileName'] != null) {
            queryParameters['testFileName'] = requestParameters['testFileName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/calculateResults`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalculateResultsDtoToJSON(requestParameters['calculateResultsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetIndicatorTestRecalculatedSimpleDtoFromJSON));
    }

    /**
     */
    async indicatorTestControllerCalculateResults(testFileName: string, calculateResultsDto: CalculateResultsDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetIndicatorTestRecalculatedSimpleDto>> {
        const response = await this.indicatorTestControllerCalculateResultsRaw({ testFileName: testFileName, calculateResultsDto: calculateResultsDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerCreateRaw(requestParameters: IndicatorTestControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIndicatorTestDto>> {
        if (requestParameters['createUpdateIndicatorTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateIndicatorTestDto',
                'Required parameter "createUpdateIndicatorTestDto" was null or undefined when calling indicatorTestControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateIndicatorTestDtoToJSON(requestParameters['createUpdateIndicatorTestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIndicatorTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async indicatorTestControllerCreate(createUpdateIndicatorTestDto: CreateUpdateIndicatorTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIndicatorTestDto> {
        const response = await this.indicatorTestControllerCreateRaw({ createUpdateIndicatorTestDto: createUpdateIndicatorTestDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerCreateImportedRaw(requestParameters: IndicatorTestControllerCreateImportedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIndicatorTestDto>> {
        if (requestParameters['createUpdateImportedIndicatorTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateImportedIndicatorTestDto',
                'Required parameter "createUpdateImportedIndicatorTestDto" was null or undefined when calling indicatorTestControllerCreateImported().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/imported`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateImportedIndicatorTestDtoToJSON(requestParameters['createUpdateImportedIndicatorTestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIndicatorTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async indicatorTestControllerCreateImported(createUpdateImportedIndicatorTestDto: CreateUpdateImportedIndicatorTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIndicatorTestDto> {
        const response = await this.indicatorTestControllerCreateImportedRaw({ createUpdateImportedIndicatorTestDto: createUpdateImportedIndicatorTestDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerDeleteRaw(requestParameters: IndicatorTestControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling indicatorTestControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async indicatorTestControllerDelete(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.indicatorTestControllerDeleteRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerGetRaw(requestParameters: IndicatorTestControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIndicatorTestDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling indicatorTestControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIndicatorTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async indicatorTestControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIndicatorTestDto> {
        const response = await this.indicatorTestControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerGetAllByPortionRaw(requestParameters: IndicatorTestControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetIndicatorTestDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling indicatorTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling indicatorTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling indicatorTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling indicatorTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling indicatorTestControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetIndicatorTestDtoFromJSON));
    }

    /**
     */
    async indicatorTestControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetIndicatorTestDto>> {
        const response = await this.indicatorTestControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerGetAllCountRaw(requestParameters: IndicatorTestControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling indicatorTestControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async indicatorTestControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.indicatorTestControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerGetByExamTestRaw(requestParameters: IndicatorTestControllerGetByExamTestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetIndicatorTestRecalculatedDto>>> {
        if (requestParameters['examTestId'] == null) {
            throw new runtime.RequiredError(
                'examTestId',
                'Required parameter "examTestId" was null or undefined when calling indicatorTestControllerGetByExamTest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examTestId'] != null) {
            queryParameters['examTestId'] = requestParameters['examTestId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/get/byExamTest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetIndicatorTestRecalculatedDtoFromJSON));
    }

    /**
     */
    async indicatorTestControllerGetByExamTest(examTestId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetIndicatorTestRecalculatedDto>> {
        const response = await this.indicatorTestControllerGetByExamTestRaw({ examTestId: examTestId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indicatorTestControllerUpdateRaw(requestParameters: IndicatorTestControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling indicatorTestControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateIndicatorTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateIndicatorTestDto',
                'Required parameter "createUpdateIndicatorTestDto" was null or undefined when calling indicatorTestControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/indicatorTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateIndicatorTestDtoToJSON(requestParameters['createUpdateIndicatorTestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async indicatorTestControllerUpdate(id: string, createUpdateIndicatorTestDto: CreateUpdateIndicatorTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.indicatorTestControllerUpdateRaw({ id: id, createUpdateIndicatorTestDto: createUpdateIndicatorTestDto }, initOverrides);
    }

    /**
     */
    async interpretationNormControllerGetByNormRaw(requestParameters: InterpretationNormControllerGetByNormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInterpretationNormDto>>> {
        if (requestParameters['normId'] == null) {
            throw new runtime.RequiredError(
                'normId',
                'Required parameter "normId" was null or undefined when calling interpretationNormControllerGetByNorm().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['normId'] != null) {
            queryParameters['normId'] = requestParameters['normId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/interpretationNorm/get/byNorm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetInterpretationNormDtoFromJSON));
    }

    /**
     */
    async interpretationNormControllerGetByNorm(normId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInterpretationNormDto>> {
        const response = await this.interpretationNormControllerGetByNormRaw({ normId: normId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async interpretationNormControllerGetByNormCountRaw(requestParameters: InterpretationNormControllerGetByNormCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['normId'] == null) {
            throw new runtime.RequiredError(
                'normId',
                'Required parameter "normId" was null or undefined when calling interpretationNormControllerGetByNormCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['normId'] != null) {
            queryParameters['normId'] = requestParameters['normId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/interpretationNorm/getByNorm/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async interpretationNormControllerGetByNormCount(normId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.interpretationNormControllerGetByNormCountRaw({ normId: normId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceIssuerControllerCreateRaw(requestParameters: InvoiceIssuerControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoiceIssuerDto>> {
        if (requestParameters['createUpdateInvoiceIssuerDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInvoiceIssuerDto',
                'Required parameter "createUpdateInvoiceIssuerDto" was null or undefined when calling invoiceIssuerControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoiceIssuer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInvoiceIssuerDtoToJSON(requestParameters['createUpdateInvoiceIssuerDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoiceIssuerDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoiceIssuerControllerCreate(createUpdateInvoiceIssuerDto: CreateUpdateInvoiceIssuerDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoiceIssuerDto> {
        const response = await this.invoiceIssuerControllerCreateRaw({ createUpdateInvoiceIssuerDto: createUpdateInvoiceIssuerDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceIssuerControllerGetRaw(requestParameters: InvoiceIssuerControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoiceIssuerDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceIssuerControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoiceIssuer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoiceIssuerDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoiceIssuerControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoiceIssuerDto> {
        const response = await this.invoiceIssuerControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceIssuerControllerGetAllActiveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInvoiceIssuerOptionDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoiceIssuer/search/active`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetInvoiceIssuerOptionDtoFromJSON));
    }

    /**
     */
    async invoiceIssuerControllerGetAllActive(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInvoiceIssuerOptionDto>> {
        const response = await this.invoiceIssuerControllerGetAllActiveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceIssuerControllerGetAllByPortionRaw(requestParameters: InvoiceIssuerControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInvoiceIssuerDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling invoiceIssuerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling invoiceIssuerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling invoiceIssuerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling invoiceIssuerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling invoiceIssuerControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoiceIssuer/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetInvoiceIssuerDtoFromJSON));
    }

    /**
     */
    async invoiceIssuerControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInvoiceIssuerDto>> {
        const response = await this.invoiceIssuerControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceIssuerControllerGetAllCountRaw(requestParameters: InvoiceIssuerControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling invoiceIssuerControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoiceIssuer/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async invoiceIssuerControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.invoiceIssuerControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoiceIssuerControllerUpdateRaw(requestParameters: InvoiceIssuerControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoiceIssuerControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateInvoiceIssuerDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInvoiceIssuerDto',
                'Required parameter "createUpdateInvoiceIssuerDto" was null or undefined when calling invoiceIssuerControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoiceIssuer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInvoiceIssuerDtoToJSON(requestParameters['createUpdateInvoiceIssuerDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async invoiceIssuerControllerUpdate(id: string, createUpdateInvoiceIssuerDto: CreateUpdateInvoiceIssuerDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoiceIssuerControllerUpdateRaw({ id: id, createUpdateInvoiceIssuerDto: createUpdateInvoiceIssuerDto }, initOverrides);
    }

    /**
     */
    async invoicePaymentControllerCreateRaw(requestParameters: InvoicePaymentControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicePaymentDto>> {
        if (requestParameters['createUpdateInvoicePaymentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInvoicePaymentDto',
                'Required parameter "createUpdateInvoicePaymentDto" was null or undefined when calling invoicePaymentControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInvoicePaymentDtoToJSON(requestParameters['createUpdateInvoicePaymentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicePaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoicePaymentControllerCreate(createUpdateInvoicePaymentDto: CreateUpdateInvoicePaymentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicePaymentDto> {
        const response = await this.invoicePaymentControllerCreateRaw({ createUpdateInvoicePaymentDto: createUpdateInvoicePaymentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerCreateLinkRaw(requestParameters: InvoicePaymentControllerCreateLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicePaymentLinkDto>> {
        if (requestParameters['createUpdateInvoicePaymentLinkDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInvoicePaymentLinkDto',
                'Required parameter "createUpdateInvoicePaymentLinkDto" was null or undefined when calling invoicePaymentControllerCreateLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInvoicePaymentLinkDtoToJSON(requestParameters['createUpdateInvoicePaymentLinkDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicePaymentLinkDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoicePaymentControllerCreateLink(createUpdateInvoicePaymentLinkDto: CreateUpdateInvoicePaymentLinkDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicePaymentLinkDto> {
        const response = await this.invoicePaymentControllerCreateLinkRaw({ createUpdateInvoicePaymentLinkDto: createUpdateInvoicePaymentLinkDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerCreateSingleRaw(requestParameters: InvoicePaymentControllerCreateSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicePaymentDto>> {
        if (requestParameters['createUpdateInvoicePaymentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInvoicePaymentDto',
                'Required parameter "createUpdateInvoicePaymentDto" was null or undefined when calling invoicePaymentControllerCreateSingle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/single`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInvoicePaymentDtoToJSON(requestParameters['createUpdateInvoicePaymentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicePaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoicePaymentControllerCreateSingle(createUpdateInvoicePaymentDto: CreateUpdateInvoicePaymentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicePaymentDto> {
        const response = await this.invoicePaymentControllerCreateSingleRaw({ createUpdateInvoicePaymentDto: createUpdateInvoicePaymentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerDeleteLinkRaw(requestParameters: InvoicePaymentControllerDeleteLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePaymentControllerDeleteLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/link/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async invoicePaymentControllerDeleteLink(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invoicePaymentControllerDeleteLinkRaw({ id: id }, initOverrides);
    }

    /**
     */
    async invoicePaymentControllerGetRaw(requestParameters: InvoicePaymentControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicePaymentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePaymentControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicePaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoicePaymentControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicePaymentDto> {
        const response = await this.invoicePaymentControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerGetAllByPortionRaw(requestParameters: InvoicePaymentControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInvoicePaymentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling invoicePaymentControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling invoicePaymentControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['collectionId'] != null) {
            queryParameters['collectionId'] = requestParameters['collectionId'];
        }

        if (requestParameters['onlyWithUnlinkedAmount'] != null) {
            queryParameters['onlyWithUnlinkedAmount'] = requestParameters['onlyWithUnlinkedAmount'];
        }

        if (requestParameters['onlyFullyLinked'] != null) {
            queryParameters['onlyFullyLinked'] = requestParameters['onlyFullyLinked'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetInvoicePaymentDtoFromJSON));
    }

    /**
     */
    async invoicePaymentControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, filterColumns?: string, collectionId?: string, onlyWithUnlinkedAmount?: string, onlyFullyLinked?: string, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInvoicePaymentDto>> {
        const response = await this.invoicePaymentControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, collectionId: collectionId, onlyWithUnlinkedAmount: onlyWithUnlinkedAmount, onlyFullyLinked: onlyFullyLinked, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerGetAllCountRaw(requestParameters: InvoicePaymentControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['collectionId'] != null) {
            queryParameters['collectionId'] = requestParameters['collectionId'];
        }

        if (requestParameters['onlyWithUnlinkedAmount'] != null) {
            queryParameters['onlyWithUnlinkedAmount'] = requestParameters['onlyWithUnlinkedAmount'];
        }

        if (requestParameters['onlyFullyLinked'] != null) {
            queryParameters['onlyFullyLinked'] = requestParameters['onlyFullyLinked'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async invoicePaymentControllerGetAllCount(filterText?: string, filterColumns?: string, collectionId?: string, onlyWithUnlinkedAmount?: string, onlyFullyLinked?: string, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.invoicePaymentControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns, collectionId: collectionId, onlyWithUnlinkedAmount: onlyWithUnlinkedAmount, onlyFullyLinked: onlyFullyLinked, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerGetLinksByInvoiceIdRaw(requestParameters: InvoicePaymentControllerGetLinksByInvoiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInvoicePaymentLinkDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePaymentControllerGetLinksByInvoiceId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/link/byInvoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetInvoicePaymentLinkDtoFromJSON));
    }

    /**
     */
    async invoicePaymentControllerGetLinksByInvoiceId(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInvoicePaymentLinkDto>> {
        const response = await this.invoicePaymentControllerGetLinksByInvoiceIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerGetLinksByPaymentIdRaw(requestParameters: InvoicePaymentControllerGetLinksByPaymentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInvoicePaymentLinkDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePaymentControllerGetLinksByPaymentId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/link/byPayment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetInvoicePaymentLinkDtoFromJSON));
    }

    /**
     */
    async invoicePaymentControllerGetLinksByPaymentId(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInvoicePaymentLinkDto>> {
        const response = await this.invoicePaymentControllerGetLinksByPaymentIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerImportCsvRaw(requestParameters: InvoicePaymentControllerImportCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoicePaymentControllerImportCsv200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['collectionName'] != null) {
            formParams.append('collectionName', requestParameters['collectionName'] as any);
        }

        const response = await this.request({
            path: `/invoicePayment/importCsv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoicePaymentControllerImportCsv200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async invoicePaymentControllerImportCsv(file?: Blob, collectionName?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoicePaymentControllerImportCsv200Response> {
        const response = await this.invoicePaymentControllerImportCsvRaw({ file: file, collectionName: collectionName }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerSaveLinksRaw(requestParameters: InvoicePaymentControllerSaveLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetInvoicePaymentLinkDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePaymentControllerSaveLinks().'
            );
        }

        if (requestParameters['saveLinksDto'] == null) {
            throw new runtime.RequiredError(
                'saveLinksDto',
                'Required parameter "saveLinksDto" was null or undefined when calling invoicePaymentControllerSaveLinks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/link/byPayment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveLinksDtoToJSON(requestParameters['saveLinksDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetInvoicePaymentLinkDtoFromJSON));
    }

    /**
     */
    async invoicePaymentControllerSaveLinks(id: string, saveLinksDto: SaveLinksDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetInvoicePaymentLinkDto>> {
        const response = await this.invoicePaymentControllerSaveLinksRaw({ id: id, saveLinksDto: saveLinksDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async invoicePaymentControllerUpdateRaw(requestParameters: InvoicePaymentControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvoicePaymentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicePaymentControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateInvoicePaymentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateInvoicePaymentDto',
                'Required parameter "createUpdateInvoicePaymentDto" was null or undefined when calling invoicePaymentControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoicePayment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateInvoicePaymentDtoToJSON(requestParameters['createUpdateInvoicePaymentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoicePaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoicePaymentControllerUpdate(id: string, createUpdateInvoicePaymentDto: CreateUpdateInvoicePaymentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvoicePaymentDto> {
        const response = await this.invoicePaymentControllerUpdateRaw({ id: id, createUpdateInvoicePaymentDto: createUpdateInvoicePaymentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobConfigControllerCreateRaw(requestParameters: JobConfigControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJobConfigDto>> {
        if (requestParameters['createUpdateJobConfigDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJobConfigDto',
                'Required parameter "createUpdateJobConfigDto" was null or undefined when calling jobConfigControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJobConfigDtoToJSON(requestParameters['createUpdateJobConfigDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobConfigDtoFromJSON(jsonValue));
    }

    /**
     */
    async jobConfigControllerCreate(createUpdateJobConfigDto: CreateUpdateJobConfigDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJobConfigDto> {
        const response = await this.jobConfigControllerCreateRaw({ createUpdateJobConfigDto: createUpdateJobConfigDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobConfigControllerGetRaw(requestParameters: JobConfigControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJobConfigDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling jobConfigControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobConfigDtoFromJSON(jsonValue));
    }

    /**
     */
    async jobConfigControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJobConfigDto> {
        const response = await this.jobConfigControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobConfigControllerGetAllByPortionRaw(requestParameters: JobConfigControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJobConfigDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling jobConfigControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling jobConfigControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling jobConfigControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling jobConfigControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling jobConfigControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJobConfigDtoFromJSON));
    }

    /**
     */
    async jobConfigControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJobConfigDto>> {
        const response = await this.jobConfigControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobConfigControllerGetAllCountRaw(requestParameters: JobConfigControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling jobConfigControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async jobConfigControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.jobConfigControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobConfigControllerGetByJobNameRaw(requestParameters: JobConfigControllerGetByJobNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJobConfigDto>> {
        if (requestParameters['jobName'] == null) {
            throw new runtime.RequiredError(
                'jobName',
                'Required parameter "jobName" was null or undefined when calling jobConfigControllerGetByJobName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config/byJobName/{jobName}`.replace(`{${"jobName"}}`, encodeURIComponent(String(requestParameters['jobName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobConfigDtoFromJSON(jsonValue));
    }

    /**
     */
    async jobConfigControllerGetByJobName(jobName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJobConfigDto> {
        const response = await this.jobConfigControllerGetByJobNameRaw({ jobName: jobName }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobConfigControllerGetLastEditorRaw(requestParameters: JobConfigControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling jobConfigControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async jobConfigControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.jobConfigControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobConfigControllerSynchronizeAllJobsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config/synchronize/allJobs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async jobConfigControllerSynchronizeAllJobs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.jobConfigControllerSynchronizeAllJobsRaw(initOverrides);
    }

    /**
     */
    async jobConfigControllerUpdateRaw(requestParameters: JobConfigControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling jobConfigControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateJobConfigDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJobConfigDto',
                'Required parameter "createUpdateJobConfigDto" was null or undefined when calling jobConfigControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/job_config/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJobConfigDtoToJSON(requestParameters['createUpdateJobConfigDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async jobConfigControllerUpdate(id: string, createUpdateJobConfigDto: CreateUpdateJobConfigDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.jobConfigControllerUpdateRaw({ id: id, createUpdateJobConfigDto: createUpdateJobConfigDto }, initOverrides);
    }

    /**
     */
    async jobPositionControllerCreateRaw(requestParameters: JobPositionControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJobPositionDto>> {
        if (requestParameters['createUpdateJobPositionDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJobPositionDto',
                'Required parameter "createUpdateJobPositionDto" was null or undefined when calling jobPositionControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobPosition`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJobPositionDtoToJSON(requestParameters['createUpdateJobPositionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobPositionDtoFromJSON(jsonValue));
    }

    /**
     */
    async jobPositionControllerCreate(createUpdateJobPositionDto: CreateUpdateJobPositionDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJobPositionDto> {
        const response = await this.jobPositionControllerCreateRaw({ createUpdateJobPositionDto: createUpdateJobPositionDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobPositionControllerGetRaw(requestParameters: JobPositionControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJobPositionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling jobPositionControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobPosition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobPositionDtoFromJSON(jsonValue));
    }

    /**
     */
    async jobPositionControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJobPositionDto> {
        const response = await this.jobPositionControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobPositionControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJobPositionDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobPosition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJobPositionDtoFromJSON));
    }

    /**
     */
    async jobPositionControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJobPositionDto>> {
        const response = await this.jobPositionControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async jobPositionControllerGetAllByNameRaw(requestParameters: JobPositionControllerGetAllByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJobPositionDto>>> {
        if (requestParameters['text'] == null) {
            throw new runtime.RequiredError(
                'text',
                'Required parameter "text" was null or undefined when calling jobPositionControllerGetAllByName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['text'] != null) {
            queryParameters['text'] = requestParameters['text'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobPosition/search/byName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJobPositionDtoFromJSON));
    }

    /**
     */
    async jobPositionControllerGetAllByName(text: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJobPositionDto>> {
        const response = await this.jobPositionControllerGetAllByNameRaw({ text: text }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobPositionControllerGetAllByPortionRaw(requestParameters: JobPositionControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJobPositionDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling jobPositionControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling jobPositionControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling jobPositionControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling jobPositionControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling jobPositionControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobPosition/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJobPositionDtoFromJSON));
    }

    /**
     */
    async jobPositionControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJobPositionDto>> {
        const response = await this.jobPositionControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobPositionControllerGetAllCountRaw(requestParameters: JobPositionControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling jobPositionControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobPosition/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async jobPositionControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.jobPositionControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async jobPositionControllerUpdateRaw(requestParameters: JobPositionControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling jobPositionControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateJobPositionDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJobPositionDto',
                'Required parameter "createUpdateJobPositionDto" was null or undefined when calling jobPositionControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobPosition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJobPositionDtoToJSON(requestParameters['createUpdateJobPositionDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async jobPositionControllerUpdate(id: string, createUpdateJobPositionDto: CreateUpdateJobPositionDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.jobPositionControllerUpdateRaw({ id: id, createUpdateJobPositionDto: createUpdateJobPositionDto }, initOverrides);
    }

    /**
     */
    async judgmentControllerChangeToInactiveRaw(requestParameters: JudgmentControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InactivateJudgmentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentControllerChangeToInactive().'
            );
        }

        if (requestParameters['cancelJudgmentDto'] == null) {
            throw new runtime.RequiredError(
                'cancelJudgmentDto',
                'Required parameter "cancelJudgmentDto" was null or undefined when calling judgmentControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CancelJudgmentDtoToJSON(requestParameters['cancelJudgmentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InactivateJudgmentDtoFromJSON(jsonValue));
    }

    /**
     */
    async judgmentControllerChangeToInactive(id: string, cancelJudgmentDto: CancelJudgmentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InactivateJudgmentDto> {
        const response = await this.judgmentControllerChangeToInactiveRaw({ id: id, cancelJudgmentDto: cancelJudgmentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerCreateRaw(requestParameters: JudgmentControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJudgmentDto>> {
        if (requestParameters['createUpdateJudgmentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJudgmentDto',
                'Required parameter "createUpdateJudgmentDto" was null or undefined when calling judgmentControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJudgmentDtoToJSON(requestParameters['createUpdateJudgmentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJudgmentDtoFromJSON(jsonValue));
    }

    /**
     */
    async judgmentControllerCreate(createUpdateJudgmentDto: CreateUpdateJudgmentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJudgmentDto> {
        const response = await this.judgmentControllerCreateRaw({ createUpdateJudgmentDto: createUpdateJudgmentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetRaw(requestParameters: JudgmentControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJudgmentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJudgmentDtoFromJSON(jsonValue));
    }

    /**
     */
    async judgmentControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJudgmentDto> {
        const response = await this.judgmentControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetAllAutomaticByPortionRaw(requestParameters: JudgmentControllerGetAllAutomaticByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentExtendedDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentControllerGetAllAutomaticByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetAllAutomaticByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchAutomatic/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentExtendedDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetAllAutomaticByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentExtendedDto>> {
        const response = await this.judgmentControllerGetAllAutomaticByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetAllAutomaticCountRaw(requestParameters: JudgmentControllerGetAllAutomaticCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetAllAutomaticCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchAutomatic/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentControllerGetAllAutomaticCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentControllerGetAllAutomaticCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetAllByPortionRaw(requestParameters: JudgmentControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentExtendedDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentExtendedDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentExtendedDto>> {
        const response = await this.judgmentControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetAllCountRaw(requestParameters: JudgmentControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentControllerGetAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetAllForUserRegisterToSignRaw(requestParameters: JudgmentControllerGetAllForUserRegisterToSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentDto>>> {
        if (requestParameters['userUid'] == null) {
            throw new runtime.RequiredError(
                'userUid',
                'Required parameter "userUid" was null or undefined when calling judgmentControllerGetAllForUserRegisterToSign().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/search/byRegisterUserToSign`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetAllForUserRegisterToSign(userUid: string, registerId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentDto>> {
        const response = await this.judgmentControllerGetAllForUserRegisterToSignRaw({ userUid: userUid, registerId: registerId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetByUserCompanyByPortionRaw(requestParameters: JudgmentControllerGetByUserCompanyByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentExtendedDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentControllerGetByUserCompanyByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentControllerGetByUserCompanyByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentControllerGetByUserCompanyByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentControllerGetByUserCompanyByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetByUserCompanyByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/search/byUserCompany/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentExtendedDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetByUserCompanyByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentExtendedDto>> {
        const response = await this.judgmentControllerGetByUserCompanyByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetByUserCompanyCountRaw(requestParameters: JudgmentControllerGetByUserCompanyCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetByUserCompanyCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/search/byUserCompany/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentControllerGetByUserCompanyCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentControllerGetByUserCompanyCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetForExamRaw(requestParameters: JudgmentControllerGetForExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentWithSignedInfoDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentControllerGetForExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/forExam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentWithSignedInfoDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetForExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentWithSignedInfoDto>> {
        const response = await this.judgmentControllerGetForExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetForRegisterByPortionRaw(requestParameters: JudgmentControllerGetForRegisterByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentExtendedDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentControllerGetForRegisterByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentControllerGetForRegisterByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentControllerGetForRegisterByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentControllerGetForRegisterByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetForRegisterByPortion().'
            );
        }

        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling judgmentControllerGetForRegisterByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchForRegister/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentExtendedDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetForRegisterByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, registerId: string, dateFrom?: Date, dateTo?: Date, userUid?: string, healthcareFacilityId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentExtendedDto>> {
        const response = await this.judgmentControllerGetForRegisterByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, registerId: registerId, dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, healthcareFacilityId: healthcareFacilityId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetForRegisterCountRaw(requestParameters: JudgmentControllerGetForRegisterCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetForRegisterCount().'
            );
        }

        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling judgmentControllerGetForRegisterCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchForRegister/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentControllerGetForRegisterCount(filterText: string, registerId: string, dateFrom?: Date, dateTo?: Date, userUid?: string, healthcareFacilityId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentControllerGetForRegisterCountRaw({ filterText: filterText, registerId: registerId, dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, healthcareFacilityId: healthcareFacilityId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetForSigningByPortionRaw(requestParameters: JudgmentControllerGetForSigningByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentExtendedDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetForSigningByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchForSigning/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentExtendedDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetForSigningByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentExtendedDto>> {
        const response = await this.judgmentControllerGetForSigningByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetForSigningCountRaw(requestParameters: JudgmentControllerGetForSigningCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetForSigningCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchForSigning/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentControllerGetForSigningCount(filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentControllerGetForSigningCountRaw({ filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetLastEditorRaw(requestParameters: JudgmentControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async judgmentControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.judgmentControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetNextExamDateRaw(requestParameters: JudgmentControllerGetNextExamDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling judgmentControllerGetNextExamDate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['articleId'] != null) {
            queryParameters['articleId'] = requestParameters['articleId'];
        }

        if (requestParameters['articleMode'] != null) {
            queryParameters['articleMode'] = requestParameters['articleMode'];
        }

        if (requestParameters['pdfTemplateType'] != null) {
            queryParameters['pdfTemplateType'] = requestParameters['pdfTemplateType'];
        }

        if (requestParameters['contactWithFood'] != null) {
            queryParameters['contactWithFood'] = requestParameters['contactWithFood'];
        }

        if (requestParameters['referenceDate'] != null) {
            queryParameters['referenceDate'] = requestParameters['referenceDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/nextExamDate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentControllerGetNextExamDate(examId: string, articleId?: string, articleMode?: string, pdfTemplateType?: string, contactWithFood?: string, referenceDate?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.judgmentControllerGetNextExamDateRaw({ examId: examId, articleId: articleId, articleMode: articleMode, pdfTemplateType: pdfTemplateType, contactWithFood: contactWithFood, referenceDate: referenceDate }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetWithoutElectronicSigningByPortionRaw(requestParameters: JudgmentControllerGetWithoutElectronicSigningByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentExtendedDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentControllerGetWithoutElectronicSigningByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentControllerGetWithoutElectronicSigningByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentControllerGetWithoutElectronicSigningByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentControllerGetWithoutElectronicSigningByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetWithoutElectronicSigningByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchWithoutElectronicSigning/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentExtendedDtoFromJSON));
    }

    /**
     */
    async judgmentControllerGetWithoutElectronicSigningByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, userUid?: string, dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentExtendedDto>> {
        const response = await this.judgmentControllerGetWithoutElectronicSigningByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, userUid: userUid, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerGetWithoutElectronicSigningCountRaw(requestParameters: JudgmentControllerGetWithoutElectronicSigningCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentControllerGetWithoutElectronicSigningCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/searchWithoutElectronicSigning/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentControllerGetWithoutElectronicSigningCount(filterText: string, filterColumns?: string, userUid?: string, dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentControllerGetWithoutElectronicSigningCountRaw({ filterText: filterText, filterColumns: filterColumns, userUid: userUid, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentControllerUpdateRaw(requestParameters: JudgmentControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateJudgmentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJudgmentDto',
                'Required parameter "createUpdateJudgmentDto" was null or undefined when calling judgmentControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJudgmentDtoToJSON(requestParameters['createUpdateJudgmentDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async judgmentControllerUpdate(id: string, createUpdateJudgmentDto: CreateUpdateJudgmentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.judgmentControllerUpdateRaw({ id: id, createUpdateJudgmentDto: createUpdateJudgmentDto }, initOverrides);
    }

    /**
     */
    async judgmentNumberingControllerCreateRaw(requestParameters: JudgmentNumberingControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJudgmentNumberingDto>> {
        if (requestParameters['createUpdateJudgmentNumberingDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJudgmentNumberingDto',
                'Required parameter "createUpdateJudgmentNumberingDto" was null or undefined when calling judgmentNumberingControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentsNumbering`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJudgmentNumberingDtoToJSON(requestParameters['createUpdateJudgmentNumberingDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJudgmentNumberingDtoFromJSON(jsonValue));
    }

    /**
     */
    async judgmentNumberingControllerCreate(createUpdateJudgmentNumberingDto: CreateUpdateJudgmentNumberingDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJudgmentNumberingDto> {
        const response = await this.judgmentNumberingControllerCreateRaw({ createUpdateJudgmentNumberingDto: createUpdateJudgmentNumberingDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentNumberingControllerGetRaw(requestParameters: JudgmentNumberingControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJudgmentNumberingDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentNumberingControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentsNumbering/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJudgmentNumberingDtoFromJSON(jsonValue));
    }

    /**
     */
    async judgmentNumberingControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJudgmentNumberingDto> {
        const response = await this.judgmentNumberingControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentNumberingControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentNumberingDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentsNumbering`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentNumberingDtoFromJSON));
    }

    /**
     */
    async judgmentNumberingControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentNumberingDto>> {
        const response = await this.judgmentNumberingControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentNumberingControllerUpdateRaw(requestParameters: JudgmentNumberingControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentNumberingControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateJudgmentNumberingDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateJudgmentNumberingDto',
                'Required parameter "createUpdateJudgmentNumberingDto" was null or undefined when calling judgmentNumberingControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentsNumbering/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateJudgmentNumberingDtoToJSON(requestParameters['createUpdateJudgmentNumberingDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async judgmentNumberingControllerUpdate(id: string, createUpdateJudgmentNumberingDto: CreateUpdateJudgmentNumberingDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.judgmentNumberingControllerUpdateRaw({ id: id, createUpdateJudgmentNumberingDto: createUpdateJudgmentNumberingDto }, initOverrides);
    }

    /**
     */
    async judgmentP1DocumentControllerGetAcceptedXmlForJudgmentRaw(requestParameters: JudgmentP1DocumentControllerGetAcceptedXmlForJudgmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['judgmentId'] == null) {
            throw new runtime.RequiredError(
                'judgmentId',
                'Required parameter "judgmentId" was null or undefined when calling judgmentP1DocumentControllerGetAcceptedXmlForJudgment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/forJudgment/{judgmentId}/xml`.replace(`{${"judgmentId"}}`, encodeURIComponent(String(requestParameters['judgmentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentP1DocumentControllerGetAcceptedXmlForJudgment(judgmentId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.judgmentP1DocumentControllerGetAcceptedXmlForJudgmentRaw({ judgmentId: judgmentId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentForJudgmentRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentForJudgmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJudgmentP1DocumentDto>> {
        if (requestParameters['judgmentId'] == null) {
            throw new runtime.RequiredError(
                'judgmentId',
                'Required parameter "judgmentId" was null or undefined when calling judgmentP1DocumentControllerGetDocumentForJudgment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/forJudgment/{judgmentId}`.replace(`{${"judgmentId"}}`, encodeURIComponent(String(requestParameters['judgmentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJudgmentP1DocumentDtoFromJSON(jsonValue));
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentForJudgment(judgmentId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJudgmentP1DocumentDto> {
        const response = await this.judgmentP1DocumentControllerGetDocumentForJudgmentRaw({ judgmentId: judgmentId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsAllByPageRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsAllByPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentP1DocumentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsAllByPage().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsAllByPage().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsAllByPage().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsAllByPage().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsAllByPage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/all/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentP1DocumentDtoFromJSON));
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsAllByPage(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentP1DocumentDto>> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsAllByPageRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsAllCountRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/all/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsIncompleteByPageRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsIncompleteByPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentP1DocumentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsIncompleteByPage().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsIncompleteByPage().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsIncompleteByPage().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsIncompleteByPage().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsIncompleteByPage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/incomplete/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentP1DocumentDtoFromJSON));
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsIncompleteByPage(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentP1DocumentDto>> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsIncompleteByPageRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsIncompleteCountRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsIncompleteCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsIncompleteCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/incomplete/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsIncompleteCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsIncompleteCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsRejectedByPageRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsRejectedByPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentP1DocumentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsRejectedByPage().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsRejectedByPage().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsRejectedByPage().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsRejectedByPage().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsRejectedByPage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/rejected/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentP1DocumentDtoFromJSON));
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsRejectedByPage(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentP1DocumentDto>> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsRejectedByPageRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsRejectedCountRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsRejectedCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsRejectedCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/rejected/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsRejectedCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsRejectedCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsToSignByPageRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsToSignByPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentP1DocumentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsToSignByPage().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsToSignByPage().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsToSignByPage().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsToSignByPage().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsToSignByPage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/toSign/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentP1DocumentDtoFromJSON));
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsToSignByPage(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentP1DocumentDto>> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsToSignByPageRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsToSignCountRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsToSignCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsToSignCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/toSign/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsToSignCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsToSignCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsWaitingByPageRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsWaitingByPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentP1DocumentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsWaitingByPage().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsWaitingByPage().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsWaitingByPage().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsWaitingByPage().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsWaitingByPage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/waiting/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentP1DocumentDtoFromJSON));
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsWaitingByPage(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentP1DocumentDto>> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsWaitingByPageRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsWaitingCountRaw(requestParameters: JudgmentP1DocumentControllerGetDocumentsWaitingCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling judgmentP1DocumentControllerGetDocumentsWaitingCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/waiting/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async judgmentP1DocumentControllerGetDocumentsWaitingCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.judgmentP1DocumentControllerGetDocumentsWaitingCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async judgmentP1DocumentControllerRetryDocumentRaw(requestParameters: JudgmentP1DocumentControllerRetryDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentP1DocumentControllerRetryDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/{id}/retry`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async judgmentP1DocumentControllerRetryDocument(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.judgmentP1DocumentControllerRetryDocumentRaw({ id: id }, initOverrides);
    }

    /**
     */
    async judgmentP1DocumentControllerSignDocumentRaw(requestParameters: JudgmentP1DocumentControllerSignDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentP1DocumentControllerSignDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/{id}/sign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async judgmentP1DocumentControllerSignDocument(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.judgmentP1DocumentControllerSignDocumentRaw({ id: id }, initOverrides);
    }

    /**
     */
    async judgmentP1DocumentControllerSignDocumentWithSzafirRaw(requestParameters: JudgmentP1DocumentControllerSignDocumentWithSzafirRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling judgmentP1DocumentControllerSignDocumentWithSzafir().'
            );
        }

        if (requestParameters['submitSzafirSignedP1Dto'] == null) {
            throw new runtime.RequiredError(
                'submitSzafirSignedP1Dto',
                'Required parameter "submitSzafirSignedP1Dto" was null or undefined when calling judgmentP1DocumentControllerSignDocumentWithSzafir().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judgmentP1Document/documents/{id}/signWithSzafir`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitSzafirSignedP1DtoToJSON(requestParameters['submitSzafirSignedP1Dto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async judgmentP1DocumentControllerSignDocumentWithSzafir(id: string, submitSzafirSignedP1Dto: SubmitSzafirSignedP1Dto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.judgmentP1DocumentControllerSignDocumentWithSzafirRaw({ id: id, submitSzafirSignedP1Dto: submitSzafirSignedP1Dto }, initOverrides);
    }

    /**
     */
    async keyTestControllerCreateRaw(requestParameters: KeyTestControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKeyTestDto>> {
        if (requestParameters['createUpdateKeyTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateKeyTestDto',
                'Required parameter "createUpdateKeyTestDto" was null or undefined when calling keyTestControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyTest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateKeyTestDtoToJSON(requestParameters['createUpdateKeyTestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKeyTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async keyTestControllerCreate(createUpdateKeyTestDto: CreateUpdateKeyTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKeyTestDto> {
        const response = await this.keyTestControllerCreateRaw({ createUpdateKeyTestDto: createUpdateKeyTestDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async keyTestControllerCreateWithValuesRaw(requestParameters: KeyTestControllerCreateWithValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKeyTestDto>> {
        if (requestParameters['createUpdateKeyTestWithKeysDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateKeyTestWithKeysDto',
                'Required parameter "createUpdateKeyTestWithKeysDto" was null or undefined when calling keyTestControllerCreateWithValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyTest/withKeys`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateKeyTestWithKeysDtoToJSON(requestParameters['createUpdateKeyTestWithKeysDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKeyTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async keyTestControllerCreateWithValues(createUpdateKeyTestWithKeysDto: CreateUpdateKeyTestWithKeysDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKeyTestDto> {
        const response = await this.keyTestControllerCreateWithValuesRaw({ createUpdateKeyTestWithKeysDto: createUpdateKeyTestWithKeysDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async keyTestControllerDeleteRaw(requestParameters: KeyTestControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling keyTestControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async keyTestControllerDelete(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.keyTestControllerDeleteRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async keyTestControllerGetRaw(requestParameters: KeyTestControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKeyTestDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling keyTestControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKeyTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async keyTestControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKeyTestDto> {
        const response = await this.keyTestControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async keyTestControllerGetAllByPortionRaw(requestParameters: KeyTestControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetKeyTestDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling keyTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling keyTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling keyTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling keyTestControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling keyTestControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyTest/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetKeyTestDtoFromJSON));
    }

    /**
     */
    async keyTestControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetKeyTestDto>> {
        const response = await this.keyTestControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async keyTestControllerGetAllCountRaw(requestParameters: KeyTestControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling keyTestControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyTest/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async keyTestControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.keyTestControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async keyTestControllerUpdateRaw(requestParameters: KeyTestControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling keyTestControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateKeyTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateKeyTestDto',
                'Required parameter "createUpdateKeyTestDto" was null or undefined when calling keyTestControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyTest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateKeyTestDtoToJSON(requestParameters['createUpdateKeyTestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async keyTestControllerUpdate(id: string, createUpdateKeyTestDto: CreateUpdateKeyTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.keyTestControllerUpdateRaw({ id: id, createUpdateKeyTestDto: createUpdateKeyTestDto }, initOverrides);
    }

    /**
     */
    async keyValueControllerGetByKeyRaw(requestParameters: KeyValueControllerGetByKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetKeyValueDto>>> {
        if (requestParameters['keyTestId'] == null) {
            throw new runtime.RequiredError(
                'keyTestId',
                'Required parameter "keyTestId" was null or undefined when calling keyValueControllerGetByKey().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['keyTestId'] != null) {
            queryParameters['keyTestId'] = requestParameters['keyTestId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyValue/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetKeyValueDtoFromJSON));
    }

    /**
     */
    async keyValueControllerGetByKey(keyTestId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetKeyValueDto>> {
        const response = await this.keyValueControllerGetByKeyRaw({ keyTestId: keyTestId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async keyValueControllerGetByKeyCountRaw(requestParameters: KeyValueControllerGetByKeyCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['keyTestId'] == null) {
            throw new runtime.RequiredError(
                'keyTestId',
                'Required parameter "keyTestId" was null or undefined when calling keyValueControllerGetByKeyCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['keyTestId'] != null) {
            queryParameters['keyTestId'] = requestParameters['keyTestId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/keyValue/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async keyValueControllerGetByKeyCount(keyTestId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.keyValueControllerGetByKeyCountRaw({ keyTestId: keyTestId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async manualControllerCreateRaw(requestParameters: ManualControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetManualDto>> {
        if (requestParameters['createUpdateManualDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateManualDto',
                'Required parameter "createUpdateManualDto" was null or undefined when calling manualControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/manual`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateManualDtoToJSON(requestParameters['createUpdateManualDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetManualDtoFromJSON(jsonValue));
    }

    /**
     */
    async manualControllerCreate(createUpdateManualDto: CreateUpdateManualDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetManualDto> {
        const response = await this.manualControllerCreateRaw({ createUpdateManualDto: createUpdateManualDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async manualControllerGetRaw(requestParameters: ManualControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetManualDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manualControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/manual/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetManualDtoFromJSON(jsonValue));
    }

    /**
     */
    async manualControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetManualDto> {
        const response = await this.manualControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async manualControllerGetAllByPortionRaw(requestParameters: ManualControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetManualDto>>> {
        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/manual/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetManualDtoFromJSON));
    }

    /**
     */
    async manualControllerGetAllByPortion(pageSize?: number, pageNumber?: number, orderBy?: string, orderDirection?: string, filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetManualDto>> {
        const response = await this.manualControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async manualControllerGetAllCountRaw(requestParameters: ManualControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/manual/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async manualControllerGetAllCount(filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.manualControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async manualControllerGetLastEditorRaw(requestParameters: ManualControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manualControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/manual/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async manualControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.manualControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async manualControllerUpdateRaw(requestParameters: ManualControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetManualDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manualControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateManualDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateManualDto',
                'Required parameter "createUpdateManualDto" was null or undefined when calling manualControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/manual/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateManualDtoToJSON(requestParameters['createUpdateManualDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetManualDtoFromJSON(jsonValue));
    }

    /**
     */
    async manualControllerUpdate(id: string, createUpdateManualDto: CreateUpdateManualDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetManualDto> {
        const response = await this.manualControllerUpdateRaw({ id: id, createUpdateManualDto: createUpdateManualDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async normControllerCreateWithValuesRaw(requestParameters: NormControllerCreateWithValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNormDto>> {
        if (requestParameters['createUpdateNormWithValuesDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateNormWithValuesDto',
                'Required parameter "createUpdateNormWithValuesDto" was null or undefined when calling normControllerCreateWithValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/norm/withValues`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateNormWithValuesDtoToJSON(requestParameters['createUpdateNormWithValuesDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNormDtoFromJSON(jsonValue));
    }

    /**
     */
    async normControllerCreateWithValues(createUpdateNormWithValuesDto: CreateUpdateNormWithValuesDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNormDto> {
        const response = await this.normControllerCreateWithValuesRaw({ createUpdateNormWithValuesDto: createUpdateNormWithValuesDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async normControllerDeleteRaw(requestParameters: NormControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling normControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/norm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async normControllerDelete(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.normControllerDeleteRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async normControllerGetRaw(requestParameters: NormControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling normControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/norm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNormDtoFromJSON(jsonValue));
    }

    /**
     */
    async normControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNormDto> {
        const response = await this.normControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async normControllerGetAllByPortionRaw(requestParameters: NormControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetNormDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling normControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling normControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling normControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling normControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling normControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/norm/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetNormDtoFromJSON));
    }

    /**
     */
    async normControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetNormDto>> {
        const response = await this.normControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async normControllerGetAllCountRaw(requestParameters: NormControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling normControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/norm/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async normControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.normControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerChangeToInactiveRaw(requestParameters: OtherPrintControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling otherPrintControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async otherPrintControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.otherPrintControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async otherPrintControllerCreateRaw(requestParameters: OtherPrintControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOtherPrintDto>> {
        if (requestParameters['createUpdateOtherPrintDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateOtherPrintDto',
                'Required parameter "createUpdateOtherPrintDto" was null or undefined when calling otherPrintControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateOtherPrintDtoToJSON(requestParameters['createUpdateOtherPrintDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOtherPrintDtoFromJSON(jsonValue));
    }

    /**
     */
    async otherPrintControllerCreate(createUpdateOtherPrintDto: CreateUpdateOtherPrintDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOtherPrintDto> {
        const response = await this.otherPrintControllerCreateRaw({ createUpdateOtherPrintDto: createUpdateOtherPrintDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerGetRaw(requestParameters: OtherPrintControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOtherPrintDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling otherPrintControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOtherPrintDtoFromJSON(jsonValue));
    }

    /**
     */
    async otherPrintControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOtherPrintDto> {
        const response = await this.otherPrintControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerGetAllByPortionRaw(requestParameters: OtherPrintControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOtherPrintDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling otherPrintControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling otherPrintControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling otherPrintControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling otherPrintControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling otherPrintControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOtherPrintDtoFromJSON));
    }

    /**
     */
    async otherPrintControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOtherPrintDto>> {
        const response = await this.otherPrintControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerGetAllCountRaw(requestParameters: OtherPrintControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling otherPrintControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async otherPrintControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.otherPrintControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerGetForExamRaw(requestParameters: OtherPrintControllerGetForExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOtherPrintDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling otherPrintControllerGetForExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/forExam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOtherPrintDtoFromJSON));
    }

    /**
     */
    async otherPrintControllerGetForExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOtherPrintDto>> {
        const response = await this.otherPrintControllerGetForExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerGetForSigningByPortionRaw(requestParameters: OtherPrintControllerGetForSigningByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOtherPrintDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling otherPrintControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling otherPrintControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling otherPrintControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling otherPrintControllerGetForSigningByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling otherPrintControllerGetForSigningByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/searchForSigning/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOtherPrintDtoFromJSON));
    }

    /**
     */
    async otherPrintControllerGetForSigningByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOtherPrintDto>> {
        const response = await this.otherPrintControllerGetForSigningByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerGetForSigningCountRaw(requestParameters: OtherPrintControllerGetForSigningCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling otherPrintControllerGetForSigningCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/searchForSigning/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async otherPrintControllerGetForSigningCount(filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.otherPrintControllerGetForSigningCountRaw({ filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintControllerUpdateRaw(requestParameters: OtherPrintControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling otherPrintControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateOtherPrintDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateOtherPrintDto',
                'Required parameter "createUpdateOtherPrintDto" was null or undefined when calling otherPrintControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/OtherPrint/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateOtherPrintDtoToJSON(requestParameters['createUpdateOtherPrintDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async otherPrintControllerUpdate(id: string, createUpdateOtherPrintDto: CreateUpdateOtherPrintDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.otherPrintControllerUpdateRaw({ id: id, createUpdateOtherPrintDto: createUpdateOtherPrintDto }, initOverrides);
    }

    /**
     */
    async otherPrintDefControllerChangeToInactiveRaw(requestParameters: OtherPrintDefControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling otherPrintDefControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/otherPrintDef/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async otherPrintDefControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.otherPrintDefControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async otherPrintDefControllerCreateRaw(requestParameters: OtherPrintDefControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOtherPrintDefDto>> {
        if (requestParameters['createUpdateOtherPrintDefDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateOtherPrintDefDto',
                'Required parameter "createUpdateOtherPrintDefDto" was null or undefined when calling otherPrintDefControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/otherPrintDef`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateOtherPrintDefDtoToJSON(requestParameters['createUpdateOtherPrintDefDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOtherPrintDefDtoFromJSON(jsonValue));
    }

    /**
     */
    async otherPrintDefControllerCreate(createUpdateOtherPrintDefDto: CreateUpdateOtherPrintDefDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOtherPrintDefDto> {
        const response = await this.otherPrintDefControllerCreateRaw({ createUpdateOtherPrintDefDto: createUpdateOtherPrintDefDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintDefControllerGetRaw(requestParameters: OtherPrintDefControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOtherPrintDefDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling otherPrintDefControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/otherPrintDef/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOtherPrintDefDtoFromJSON(jsonValue));
    }

    /**
     */
    async otherPrintDefControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOtherPrintDefDto> {
        const response = await this.otherPrintDefControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintDefControllerGetAllRaw(requestParameters: OtherPrintDefControllerGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOtherPrintDefDto>>> {
        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/otherPrintDef`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOtherPrintDefDtoFromJSON));
    }

    /**
     */
    async otherPrintDefControllerGetAll(mode?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOtherPrintDefDto>> {
        const response = await this.otherPrintDefControllerGetAllRaw({ mode: mode }, initOverrides);
        return await response.value();
    }

    /**
     */
    async otherPrintDefControllerUpdateRaw(requestParameters: OtherPrintDefControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling otherPrintDefControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateOtherPrintDefDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateOtherPrintDefDto',
                'Required parameter "createUpdateOtherPrintDefDto" was null or undefined when calling otherPrintDefControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/otherPrintDef/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateOtherPrintDefDtoToJSON(requestParameters['createUpdateOtherPrintDefDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async otherPrintDefControllerUpdate(id: string, createUpdateOtherPrintDefDto: CreateUpdateOtherPrintDefDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.otherPrintDefControllerUpdateRaw({ id: id, createUpdateOtherPrintDefDto: createUpdateOtherPrintDefDto }, initOverrides);
    }

    /**
     */
    async paramsControllerGetAllByPortionRaw(requestParameters: ParamsControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetParamsDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling paramsControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling paramsControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling paramsControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling paramsControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling paramsControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/params/getAllByPortion`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetParamsDtoFromJSON));
    }

    /**
     */
    async paramsControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetParamsDto>> {
        const response = await this.paramsControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paramsControllerGetAllCountRaw(requestParameters: ParamsControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling paramsControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/params/getAllCount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async paramsControllerGetAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.paramsControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paramsControllerGetByIdRaw(requestParameters: ParamsControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetParamsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling paramsControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/params/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetParamsDtoFromJSON(jsonValue));
    }

    /**
     */
    async paramsControllerGetById(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetParamsDto> {
        const response = await this.paramsControllerGetByIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paramsControllerGetLastEditorRaw(requestParameters: ParamsControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling paramsControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/params/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async paramsControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.paramsControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paramsControllerGetReportLastDaysNumberRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/params/reportLastDaysNumber`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async paramsControllerGetReportLastDaysNumber(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.paramsControllerGetReportLastDaysNumberRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async paramsControllerUpdateRaw(requestParameters: ParamsControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling paramsControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateParamsDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateParamsDto',
                'Required parameter "createUpdateParamsDto" was null or undefined when calling paramsControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/params/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateParamsDtoToJSON(requestParameters['createUpdateParamsDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async paramsControllerUpdate(id: string, createUpdateParamsDto: CreateUpdateParamsDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.paramsControllerUpdateRaw({ id: id, createUpdateParamsDto: createUpdateParamsDto }, initOverrides);
    }

    /**
     */
    async paymentCollectionControllerCreateRaw(requestParameters: PaymentCollectionControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentCollectionDto>> {
        if (requestParameters['createUpdatePaymentCollectionDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePaymentCollectionDto',
                'Required parameter "createUpdatePaymentCollectionDto" was null or undefined when calling paymentCollectionControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/paymentCollection`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePaymentCollectionDtoToJSON(requestParameters['createUpdatePaymentCollectionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentCollectionDtoFromJSON(jsonValue));
    }

    /**
     */
    async paymentCollectionControllerCreate(createUpdatePaymentCollectionDto: CreateUpdatePaymentCollectionDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentCollectionDto> {
        const response = await this.paymentCollectionControllerCreateRaw({ createUpdatePaymentCollectionDto: createUpdatePaymentCollectionDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentCollectionControllerGetRaw(requestParameters: PaymentCollectionControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentCollectionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling paymentCollectionControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/paymentCollection/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentCollectionDtoFromJSON(jsonValue));
    }

    /**
     */
    async paymentCollectionControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentCollectionDto> {
        const response = await this.paymentCollectionControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentCollectionControllerGetAllByPortionRaw(requestParameters: PaymentCollectionControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPaymentCollectionDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling paymentCollectionControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling paymentCollectionControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/paymentCollection/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPaymentCollectionDtoFromJSON));
    }

    /**
     */
    async paymentCollectionControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPaymentCollectionDto>> {
        const response = await this.paymentCollectionControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentCollectionControllerGetAllCountRaw(requestParameters: PaymentCollectionControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/paymentCollection/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async paymentCollectionControllerGetAllCount(filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.paymentCollectionControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerCountRaw(requestParameters: PaymentControllerCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async paymentControllerCount(filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.paymentControllerCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerCreateRaw(requestParameters: PaymentControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentDto>> {
        if (requestParameters['createUpdatePaymentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePaymentDto',
                'Required parameter "createUpdatePaymentDto" was null or undefined when calling paymentControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePaymentDtoToJSON(requestParameters['createUpdatePaymentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async paymentControllerCreate(createUpdatePaymentDto: CreateUpdatePaymentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentDto> {
        const response = await this.paymentControllerCreateRaw({ createUpdatePaymentDto: createUpdatePaymentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerFindOneRaw(requestParameters: PaymentControllerFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling paymentControllerFindOne().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async paymentControllerFindOne(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentDto> {
        const response = await this.paymentControllerFindOneRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerGetAllByPortionRaw(requestParameters: PaymentControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPaymentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling paymentControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling paymentControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPaymentDtoFromJSON));
    }

    /**
     */
    async paymentControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPaymentDto>> {
        const response = await this.paymentControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerGetByExamRaw(requestParameters: PaymentControllerGetByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPaymentDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling paymentControllerGetByExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/byExam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPaymentDtoFromJSON));
    }

    /**
     */
    async paymentControllerGetByExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPaymentDto>> {
        const response = await this.paymentControllerGetByExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerGetSellDocumentNotIssuedByPortionRaw(requestParameters: PaymentControllerGetSellDocumentNotIssuedByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPaymentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling paymentControllerGetSellDocumentNotIssuedByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling paymentControllerGetSellDocumentNotIssuedByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/search/sellDocumentNotIssued/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPaymentDtoFromJSON));
    }

    /**
     */
    async paymentControllerGetSellDocumentNotIssuedByPortion(pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPaymentDto>> {
        const response = await this.paymentControllerGetSellDocumentNotIssuedByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerGetSellDocumentNotIssuedCountRaw(requestParameters: PaymentControllerGetSellDocumentNotIssuedCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/search/sellDocumentNotIssued/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async paymentControllerGetSellDocumentNotIssuedCount(filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.paymentControllerGetSellDocumentNotIssuedCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async paymentControllerUpdateRaw(requestParameters: PaymentControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling paymentControllerUpdate().'
            );
        }

        if (requestParameters['createUpdatePaymentDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePaymentDto',
                'Required parameter "createUpdatePaymentDto" was null or undefined when calling paymentControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePaymentDtoToJSON(requestParameters['createUpdatePaymentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async paymentControllerUpdate(id: string, createUpdatePaymentDto: CreateUpdatePaymentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentDto> {
        const response = await this.paymentControllerUpdateRaw({ id: id, createUpdatePaymentDto: createUpdatePaymentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pdfPrinterControllerChangeAllCardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/changeAllCards`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerChangeAllCards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerChangeAllCardsRaw(initOverrides);
    }

    /**
     */
    async pdfPrinterControllerCreateSomeCardsToJudgmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/createSomeCardsToJudgments`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerCreateSomeCardsToJudgments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerCreateSomeCardsToJudgmentsRaw(initOverrides);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintCardRaw(requestParameters: PdfPrinterControllerLoadAndPrintCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerLoadAndPrintCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/loadAndPrintCard/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintCard(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerLoadAndPrintCardRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintConsultationRaw(requestParameters: PdfPrinterControllerLoadAndPrintConsultationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerLoadAndPrintConsultation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/loadAndPrintConsultation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintConsultation(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerLoadAndPrintConsultationRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintExternalReferralRaw(requestParameters: PdfPrinterControllerLoadAndPrintExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling pdfPrinterControllerLoadAndPrintExternalReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/loadAndPrintExternalReferral/{examId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintExternalReferral(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerLoadAndPrintExternalReferralRaw({ examId: examId }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintJudgmentRaw(requestParameters: PdfPrinterControllerLoadAndPrintJudgmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerLoadAndPrintJudgment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/loadAndPrintJudgment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintJudgment(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerLoadAndPrintJudgmentRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintJudgmentInEnglishRaw(requestParameters: PdfPrinterControllerLoadAndPrintJudgmentInEnglishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerLoadAndPrintJudgmentInEnglish().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/loadAndPrintJudgmentInEnglish/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintJudgmentInEnglish(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerLoadAndPrintJudgmentInEnglishRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintJudgmentWithStampAndSignatureRaw(requestParameters: PdfPrinterControllerLoadAndPrintJudgmentWithStampAndSignatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerLoadAndPrintJudgmentWithStampAndSignature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/loadAndPrintJudgmentWithStampAndSignature/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintJudgmentWithStampAndSignature(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerLoadAndPrintJudgmentWithStampAndSignatureRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintSupportingExaminationRaw(requestParameters: PdfPrinterControllerLoadAndPrintSupportingExaminationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerLoadAndPrintSupportingExamination().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/loadAndPrintSupportingExamination/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerLoadAndPrintSupportingExamination(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerLoadAndPrintSupportingExaminationRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPreviewInvoiceRaw(requestParameters: PdfPrinterControllerPreviewInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerPreviewInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/previewInvoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPreviewInvoice(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPreviewInvoiceRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPrintAnswersRaw(requestParameters: PdfPrinterControllerPrintAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling pdfPrinterControllerPrintAnswers().'
            );
        }

        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling pdfPrinterControllerPrintAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/printAnswers/{examId}/{testId}`.replace(`{${"testId"}}`, encodeURIComponent(String(requestParameters['testId']))).replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPrintAnswers(testId: string, examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPrintAnswersRaw({ testId: testId, examId: examId }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPrintCompaniesRaw(requestParameters: PdfPrinterControllerPrintCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['monthlySettlement'] == null) {
            throw new runtime.RequiredError(
                'monthlySettlement',
                'Required parameter "monthlySettlement" was null or undefined when calling pdfPrinterControllerPrintCompanies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/printCompanies/{monthlySettlement}`.replace(`{${"monthlySettlement"}}`, encodeURIComponent(String(requestParameters['monthlySettlement']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPrintCompanies(monthlySettlement: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPrintCompaniesRaw({ monthlySettlement: monthlySettlement }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPrintInvoiceRaw(requestParameters: PdfPrinterControllerPrintInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerPrintInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/printInvoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPrintInvoice(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPrintInvoiceRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPrintMissingCardsToJudgmentsRaw(requestParameters: PdfPrinterControllerPrintMissingCardsToJudgmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling pdfPrinterControllerPrintMissingCardsToJudgments().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling pdfPrinterControllerPrintMissingCardsToJudgments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/printMissingCardsToJudgments`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPrintMissingCardsToJudgments(startDate: string, endDate: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPrintMissingCardsToJudgmentsRaw({ startDate: startDate, endDate: endDate }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPrintMultiplePdfRaw(requestParameters: PdfPrinterControllerPrintMultiplePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/printMultiple/pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPrintMultiplePdf(userUid?: string, dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPrintMultiplePdfRaw({ userUid: userUid, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPrintRegisterJudgmentRaw(requestParameters: PdfPrinterControllerPrintRegisterJudgmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling pdfPrinterControllerPrintRegisterJudgment().'
            );
        }

        if (requestParameters['dateFrom'] == null) {
            throw new runtime.RequiredError(
                'dateFrom',
                'Required parameter "dateFrom" was null or undefined when calling pdfPrinterControllerPrintRegisterJudgment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/printRegisterJudgment/byParams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPrintRegisterJudgment(registerId: string, dateFrom: Date, dateTo?: Date, userUid?: string, healthcareFacilityId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPrintRegisterJudgmentRaw({ registerId: registerId, dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, healthcareFacilityId: healthcareFacilityId }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerPrintReportJudgmentsRaw(requestParameters: PdfPrinterControllerPrintReportJudgmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling pdfPrinterControllerPrintReportJudgments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['psychologistId'] != null) {
            queryParameters['psychologistId'] = requestParameters['psychologistId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['onlyMonthlySettlement'] != null) {
            queryParameters['onlyMonthlySettlement'] = requestParameters['onlyMonthlySettlement'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/printReportJudgments/byParams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerPrintReportJudgments(filterText: string, psychologistId?: string, companyId?: string, registerId?: string, healthcareFacilityId?: string, dateFrom?: Date, dateTo?: Date, onlyMonthlySettlement?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerPrintReportJudgmentsRaw({ filterText: filterText, psychologistId: psychologistId, companyId: companyId, registerId: registerId, healthcareFacilityId: healthcareFacilityId, dateFrom: dateFrom, dateTo: dateTo, onlyMonthlySettlement: onlyMonthlySettlement, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintCardRaw(requestParameters: PdfPrinterControllerSaveAndPrintCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerSaveAndPrintCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/saveAndPrintCard/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintCard(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerSaveAndPrintCardRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintConsultationRaw(requestParameters: PdfPrinterControllerSaveAndPrintConsultationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling pdfPrinterControllerSaveAndPrintConsultation().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerSaveAndPrintConsultation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/saveAndPrintConsultation/{type}/{id}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintConsultation(type: string, id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerSaveAndPrintConsultationRaw({ type: type, id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintJudgmentRaw(requestParameters: PdfPrinterControllerSaveAndPrintJudgmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerSaveAndPrintJudgment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/saveAndPrintJudgment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintJudgment(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerSaveAndPrintJudgmentRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintSupportingExaminationRaw(requestParameters: PdfPrinterControllerSaveAndPrintSupportingExaminationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfPrinterControllerSaveAndPrintSupportingExamination().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/saveAndPrintSupportingExamination/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerSaveAndPrintSupportingExamination(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerSaveAndPrintSupportingExaminationRaw({ id: id }, initOverrides);
    }

    /**
     */
    async pdfPrinterControllerUpdateSomeCardsToJudgmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdf/updateSomeCardsToJudgments`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfPrinterControllerUpdateSomeCardsToJudgments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfPrinterControllerUpdateSomeCardsToJudgmentsRaw(initOverrides);
    }

    /**
     */
    async pdfTemplateControllerGetRaw(requestParameters: PdfTemplateControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPdfTemplateDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfTemplateControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdfTemplate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPdfTemplateDtoFromJSON(jsonValue));
    }

    /**
     */
    async pdfTemplateControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPdfTemplateDto> {
        const response = await this.pdfTemplateControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pdfTemplateControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPdfTemplateDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdfTemplate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPdfTemplateDtoFromJSON));
    }

    /**
     */
    async pdfTemplateControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPdfTemplateDto>> {
        const response = await this.pdfTemplateControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async pdfTemplateControllerGetStampPositionRaw(requestParameters: PdfTemplateControllerGetStampPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['judgmentId'] == null) {
            throw new runtime.RequiredError(
                'judgmentId',
                'Required parameter "judgmentId" was null or undefined when calling pdfTemplateControllerGetStampPosition().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['judgmentId'] != null) {
            queryParameters['judgmentId'] = requestParameters['judgmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdfTemplate/get/stampPosition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async pdfTemplateControllerGetStampPosition(judgmentId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.pdfTemplateControllerGetStampPositionRaw({ judgmentId: judgmentId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pdfTemplateControllerUpdateRaw(requestParameters: PdfTemplateControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pdfTemplateControllerUpdate().'
            );
        }

        if (requestParameters['createUpdatePdfTemplateDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePdfTemplateDto',
                'Required parameter "createUpdatePdfTemplateDto" was null or undefined when calling pdfTemplateControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pdfTemplate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePdfTemplateDtoToJSON(requestParameters['createUpdatePdfTemplateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pdfTemplateControllerUpdate(id: string, createUpdatePdfTemplateDto: CreateUpdatePdfTemplateDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pdfTemplateControllerUpdateRaw({ id: id, createUpdatePdfTemplateDto: createUpdatePdfTemplateDto }, initOverrides);
    }

    /**
     */
    async positionNormControllerGetByNormRaw(requestParameters: PositionNormControllerGetByNormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPositionNormDto>>> {
        if (requestParameters['normId'] == null) {
            throw new runtime.RequiredError(
                'normId',
                'Required parameter "normId" was null or undefined when calling positionNormControllerGetByNorm().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['normId'] != null) {
            queryParameters['normId'] = requestParameters['normId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/positionNorm/get/byNorm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPositionNormDtoFromJSON));
    }

    /**
     */
    async positionNormControllerGetByNorm(normId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPositionNormDto>> {
        const response = await this.positionNormControllerGetByNormRaw({ normId: normId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async positionNormControllerGetByNormCountRaw(requestParameters: PositionNormControllerGetByNormCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['normId'] == null) {
            throw new runtime.RequiredError(
                'normId',
                'Required parameter "normId" was null or undefined when calling positionNormControllerGetByNormCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['normId'] != null) {
            queryParameters['normId'] = requestParameters['normId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/positionNorm/getByNorm/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async positionNormControllerGetByNormCount(normId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.positionNormControllerGetByNormCountRaw({ normId: normId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingControllerCreateWithPricelistRaw(requestParameters: PricingControllerCreateWithPricelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPricingDto>> {
        if (requestParameters['createUpdatePricingDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePricingDto',
                'Required parameter "createUpdatePricingDto" was null or undefined when calling pricingControllerCreateWithPricelist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePricingDtoToJSON(requestParameters['createUpdatePricingDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPricingDtoFromJSON(jsonValue));
    }

    /**
     */
    async pricingControllerCreateWithPricelist(createUpdatePricingDto: CreateUpdatePricingDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPricingDto> {
        const response = await this.pricingControllerCreateWithPricelistRaw({ createUpdatePricingDto: createUpdatePricingDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingControllerGetAllByPortionRaw(requestParameters: PricingControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPricingDto>>> {
        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricing/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPricingDtoFromJSON));
    }

    /**
     */
    async pricingControllerGetAllByPortion(pageSize?: number, pageNumber?: number, orderBy?: string, orderDirection?: string, filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPricingDto>> {
        const response = await this.pricingControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingControllerGetAllCombinationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPriceTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricing/combinations/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPriceTypeDtoFromJSON));
    }

    /**
     */
    async pricingControllerGetAllCombinations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPriceTypeDto>> {
        const response = await this.pricingControllerGetAllCombinationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingControllerGetAllCountRaw(requestParameters: PricingControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricing/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async pricingControllerGetAllCount(filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.pricingControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingControllerGetByIdRaw(requestParameters: PricingControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPricingDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pricingControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricing/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPricingDtoFromJSON(jsonValue));
    }

    /**
     */
    async pricingControllerGetById(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPricingDto> {
        const response = await this.pricingControllerGetByIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingControllerUpdateWithPricelistRaw(requestParameters: PricingControllerUpdateWithPricelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPricingDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pricingControllerUpdateWithPricelist().'
            );
        }

        if (requestParameters['createUpdatePricingDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePricingDto',
                'Required parameter "createUpdatePricingDto" was null or undefined when calling pricingControllerUpdateWithPricelist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricing/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePricingDtoToJSON(requestParameters['createUpdatePricingDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPricingDtoFromJSON(jsonValue));
    }

    /**
     */
    async pricingControllerUpdateWithPricelist(id: string, createUpdatePricingDto: CreateUpdatePricingDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPricingDto> {
        const response = await this.pricingControllerUpdateWithPricelistRaw({ id: id, createUpdatePricingDto: createUpdatePricingDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingGroupControllerCreateRaw(requestParameters: PricingGroupControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPricingGroupDto>> {
        if (requestParameters['createUpdatePricingGroupDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePricingGroupDto',
                'Required parameter "createUpdatePricingGroupDto" was null or undefined when calling pricingGroupControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricingGroup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePricingGroupDtoToJSON(requestParameters['createUpdatePricingGroupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPricingGroupDtoFromJSON(jsonValue));
    }

    /**
     */
    async pricingGroupControllerCreate(createUpdatePricingGroupDto: CreateUpdatePricingGroupDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPricingGroupDto> {
        const response = await this.pricingGroupControllerCreateRaw({ createUpdatePricingGroupDto: createUpdatePricingGroupDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingGroupControllerGetRaw(requestParameters: PricingGroupControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPricingGroupDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pricingGroupControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricingGroup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPricingGroupDtoFromJSON(jsonValue));
    }

    /**
     */
    async pricingGroupControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPricingGroupDto> {
        const response = await this.pricingGroupControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingGroupControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPricingGroupDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricingGroup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPricingGroupDtoFromJSON));
    }

    /**
     */
    async pricingGroupControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPricingGroupDto>> {
        const response = await this.pricingGroupControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingGroupControllerGetAllByPortionRaw(requestParameters: PricingGroupControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPricingGroupDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling pricingGroupControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling pricingGroupControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling pricingGroupControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling pricingGroupControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling pricingGroupControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricingGroup/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPricingGroupDtoFromJSON));
    }

    /**
     */
    async pricingGroupControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPricingGroupDto>> {
        const response = await this.pricingGroupControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingGroupControllerGetAllCountRaw(requestParameters: PricingGroupControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling pricingGroupControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricingGroup/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async pricingGroupControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.pricingGroupControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async pricingGroupControllerUpdateRaw(requestParameters: PricingGroupControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling pricingGroupControllerUpdate().'
            );
        }

        if (requestParameters['createUpdatePricingGroupDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdatePricingGroupDto',
                'Required parameter "createUpdatePricingGroupDto" was null or undefined when calling pricingGroupControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pricingGroup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdatePricingGroupDtoToJSON(requestParameters['createUpdatePricingGroupDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async pricingGroupControllerUpdate(id: string, createUpdatePricingGroupDto: CreateUpdatePricingGroupDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pricingGroupControllerUpdateRaw({ id: id, createUpdatePricingGroupDto: createUpdatePricingGroupDto }, initOverrides);
    }

    /**
     */
    async printerJpkDocumentControllerCreateRaw(requestParameters: PrinterJpkDocumentControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['createPrinterJpkDocumentDto'] == null) {
            throw new runtime.RequiredError(
                'createPrinterJpkDocumentDto',
                'Required parameter "createPrinterJpkDocumentDto" was null or undefined when calling printerJpkDocumentControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/printer-jpk-document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePrinterJpkDocumentDtoToJSON(requestParameters['createPrinterJpkDocumentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async printerJpkDocumentControllerCreate(createPrinterJpkDocumentDto: CreatePrinterJpkDocumentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.printerJpkDocumentControllerCreateRaw({ createPrinterJpkDocumentDto: createPrinterJpkDocumentDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async printerJpkDocumentControllerGetAllByPortionRaw(requestParameters: PrinterJpkDocumentControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetPrinterJpkDocumentDto>>> {
        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/printer-jpk-document/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetPrinterJpkDocumentDtoFromJSON));
    }

    /**
     */
    async printerJpkDocumentControllerGetAllByPortion(pageSize?: number, pageNumber?: number, orderBy?: string, orderDirection?: string, filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetPrinterJpkDocumentDto>> {
        const response = await this.printerJpkDocumentControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async printerJpkDocumentControllerGetAllCountRaw(requestParameters: PrinterJpkDocumentControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/printer-jpk-document/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async printerJpkDocumentControllerGetAllCount(filterText?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.printerJpkDocumentControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async printerJpkDocumentControllerGetByIdRaw(requestParameters: PrinterJpkDocumentControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrinterJpkDocumentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling printerJpkDocumentControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/printer-jpk-document/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrinterJpkDocumentDtoFromJSON(jsonValue));
    }

    /**
     */
    async printerJpkDocumentControllerGetById(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrinterJpkDocumentDto> {
        const response = await this.printerJpkDocumentControllerGetByIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async printerJpkDocumentControllerGetHighestJpkIdRaw(requestParameters: PrinterJpkDocumentControllerGetHighestJpkIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HighestJpkIdDto>> {
        if (requestParameters['printerUid'] == null) {
            throw new runtime.RequiredError(
                'printerUid',
                'Required parameter "printerUid" was null or undefined when calling printerJpkDocumentControllerGetHighestJpkId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['printerUid'] != null) {
            queryParameters['printerUid'] = requestParameters['printerUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/printer-jpk-document/highest-jpk-id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HighestJpkIdDtoFromJSON(jsonValue));
    }

    /**
     */
    async printerJpkDocumentControllerGetHighestJpkId(printerUid: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HighestJpkIdDto> {
        const response = await this.printerJpkDocumentControllerGetHighestJpkIdRaw({ printerUid: printerUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async printerJpkDocumentControllerGetMissingJpkIdsRaw(requestParameters: PrinterJpkDocumentControllerGetMissingJpkIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MissingJpkIdsDto>> {
        if (requestParameters['printerUid'] == null) {
            throw new runtime.RequiredError(
                'printerUid',
                'Required parameter "printerUid" was null or undefined when calling printerJpkDocumentControllerGetMissingJpkIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['printerUid'] != null) {
            queryParameters['printerUid'] = requestParameters['printerUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/printer-jpk-document/missing-jpk-ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MissingJpkIdsDtoFromJSON(jsonValue));
    }

    /**
     */
    async printerJpkDocumentControllerGetMissingJpkIds(printerUid: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MissingJpkIdsDto> {
        const response = await this.printerJpkDocumentControllerGetMissingJpkIdsRaw({ printerUid: printerUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async receiptControllerCreateRaw(requestParameters: ReceiptControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReceiptDto>> {
        if (requestParameters['createUpdateReceiptDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateReceiptDto',
                'Required parameter "createUpdateReceiptDto" was null or undefined when calling receiptControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateReceiptDtoToJSON(requestParameters['createUpdateReceiptDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReceiptDtoFromJSON(jsonValue));
    }

    /**
     */
    async receiptControllerCreate(createUpdateReceiptDto: CreateUpdateReceiptDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReceiptDto> {
        const response = await this.receiptControllerCreateRaw({ createUpdateReceiptDto: createUpdateReceiptDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async receiptControllerEdocumentRaw(requestParameters: ReceiptControllerEdocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['eFiscalDocumentDto'] == null) {
            throw new runtime.RequiredError(
                'eFiscalDocumentDto',
                'Required parameter "eFiscalDocumentDto" was null or undefined when calling receiptControllerEdocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/receipt/edocument`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EFiscalDocumentDtoToJSON(requestParameters['eFiscalDocumentDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async receiptControllerEdocument(eFiscalDocumentDto: EFiscalDocumentDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.receiptControllerEdocumentRaw({ eFiscalDocumentDto: eFiscalDocumentDto }, initOverrides);
    }

    /**
     */
    async receiptControllerGetRaw(requestParameters: ReceiptControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReceiptDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling receiptControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReceiptDtoFromJSON(jsonValue));
    }

    /**
     */
    async receiptControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReceiptDto> {
        const response = await this.receiptControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async receiptControllerGetAllByPortionRaw(requestParameters: ReceiptControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReceiptDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling receiptControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling receiptControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling receiptControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling receiptControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling receiptControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReceiptDtoFromJSON));
    }

    /**
     */
    async receiptControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReceiptDto>> {
        const response = await this.receiptControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async receiptControllerGetAllCountRaw(requestParameters: ReceiptControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling receiptControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async receiptControllerGetAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.receiptControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async receiptControllerGetByExamRaw(requestParameters: ReceiptControllerGetByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReceiptDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling receiptControllerGetByExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/byExam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReceiptDtoFromJSON));
    }

    /**
     */
    async receiptControllerGetByExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReceiptDto>> {
        const response = await this.receiptControllerGetByExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async receiptControllerUpdateRaw(requestParameters: ReceiptControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReceiptDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling receiptControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateReceiptDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateReceiptDto',
                'Required parameter "createUpdateReceiptDto" was null or undefined when calling receiptControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receipt/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateReceiptDtoToJSON(requestParameters['createUpdateReceiptDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReceiptDtoFromJSON(jsonValue));
    }

    /**
     */
    async receiptControllerUpdate(id: string, createUpdateReceiptDto: CreateUpdateReceiptDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReceiptDto> {
        const response = await this.receiptControllerUpdateRaw({ id: id, createUpdateReceiptDto: createUpdateReceiptDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerControllerGetRaw(requestParameters: RegisterControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRegisterDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling registerControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/register/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRegisterDtoFromJSON(jsonValue));
    }

    /**
     */
    async registerControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRegisterDto> {
        const response = await this.registerControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetRegisterDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/register`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetRegisterDtoFromJSON));
    }

    /**
     */
    async registerControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetRegisterDto>> {
        const response = await this.registerControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async registerControllerGetAllByPortionRaw(requestParameters: RegisterControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetRegisterDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling registerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling registerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling registerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling registerControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling registerControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/register/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetRegisterDtoFromJSON));
    }

    /**
     */
    async registerControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetRegisterDto>> {
        const response = await this.registerControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerControllerGetAllCountRaw(requestParameters: RegisterControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling registerControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/register/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async registerControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.registerControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerControllerGetByModeRaw(requestParameters: RegisterControllerGetByModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetRegisterDto>>> {
        if (requestParameters['mode'] == null) {
            throw new runtime.RequiredError(
                'mode',
                'Required parameter "mode" was null or undefined when calling registerControllerGetByMode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/register/get/byMode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetRegisterDtoFromJSON));
    }

    /**
     */
    async registerControllerGetByMode(mode: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetRegisterDto>> {
        const response = await this.registerControllerGetByModeRaw({ mode: mode }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerNumberingControllerCreateRaw(requestParameters: RegisterNumberingControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetRegisterNumberingDto>>> {
        if (requestParameters['createUpdateRegisterNumberingDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateRegisterNumberingDto',
                'Required parameter "createUpdateRegisterNumberingDto" was null or undefined when calling registerNumberingControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/registerNumbering`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateRegisterNumberingDtoToJSON(requestParameters['createUpdateRegisterNumberingDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetRegisterNumberingDtoFromJSON));
    }

    /**
     */
    async registerNumberingControllerCreate(createUpdateRegisterNumberingDto: CreateUpdateRegisterNumberingDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetRegisterNumberingDto>> {
        const response = await this.registerNumberingControllerCreateRaw({ createUpdateRegisterNumberingDto: createUpdateRegisterNumberingDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerNumberingControllerFindByHealthcareFacilityIdRaw(requestParameters: RegisterNumberingControllerFindByHealthcareFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetRegisterNumberingDto>>> {
        if (requestParameters['healthcareFacilityId'] == null) {
            throw new runtime.RequiredError(
                'healthcareFacilityId',
                'Required parameter "healthcareFacilityId" was null or undefined when calling registerNumberingControllerFindByHealthcareFacilityId().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling registerNumberingControllerFindByHealthcareFacilityId().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling registerNumberingControllerFindByHealthcareFacilityId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/registerNumbering/byHealthcareFacility/{healthcareFacilityId}`.replace(`{${"healthcareFacilityId"}}`, encodeURIComponent(String(requestParameters['healthcareFacilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetRegisterNumberingDtoFromJSON));
    }

    /**
     */
    async registerNumberingControllerFindByHealthcareFacilityId(healthcareFacilityId: string, pageSize: number, pageNumber: number, orderBy?: string, orderDirection?: string, filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetRegisterNumberingDto>> {
        const response = await this.registerNumberingControllerFindByHealthcareFacilityIdRaw({ healthcareFacilityId: healthcareFacilityId, pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerNumberingControllerGetRaw(requestParameters: RegisterNumberingControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRegisterNumberingDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling registerNumberingControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/registerNumbering/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRegisterNumberingDtoFromJSON(jsonValue));
    }

    /**
     */
    async registerNumberingControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRegisterNumberingDto> {
        const response = await this.registerNumberingControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerNumberingControllerGetByHealthcareFacilityIdCountRaw(requestParameters: RegisterNumberingControllerGetByHealthcareFacilityIdCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['healthcareFacilityId'] == null) {
            throw new runtime.RequiredError(
                'healthcareFacilityId',
                'Required parameter "healthcareFacilityId" was null or undefined when calling registerNumberingControllerGetByHealthcareFacilityIdCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/registerNumbering/byHealthcareFacility/{healthcareFacilityId}/count`.replace(`{${"healthcareFacilityId"}}`, encodeURIComponent(String(requestParameters['healthcareFacilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async registerNumberingControllerGetByHealthcareFacilityIdCount(healthcareFacilityId: string, filterText?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.registerNumberingControllerGetByHealthcareFacilityIdCountRaw({ healthcareFacilityId: healthcareFacilityId, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetCompaniesByPortionRaw(requestParameters: ReportControllerGetCompaniesByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReportCompanyDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling reportControllerGetCompaniesByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling reportControllerGetCompaniesByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling reportControllerGetCompaniesByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling reportControllerGetCompaniesByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetCompaniesByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['onlyMonthlySettlement'] != null) {
            queryParameters['onlyMonthlySettlement'] = requestParameters['onlyMonthlySettlement'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchCompanies/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReportCompanyDtoFromJSON));
    }

    /**
     */
    async reportControllerGetCompaniesByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, dateFrom?: Date, dateTo?: Date, onlyMonthlySettlement?: boolean, companyId?: string, healthcareFacilityId?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReportCompanyDto>> {
        const response = await this.reportControllerGetCompaniesByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, onlyMonthlySettlement: onlyMonthlySettlement, companyId: companyId, healthcareFacilityId: healthcareFacilityId, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetCompaniesCountRaw(requestParameters: ReportControllerGetCompaniesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetCompaniesCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['onlyMonthlySettlement'] != null) {
            queryParameters['onlyMonthlySettlement'] = requestParameters['onlyMonthlySettlement'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchCompanies/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async reportControllerGetCompaniesCount(filterText: string, dateFrom?: Date, dateTo?: Date, onlyMonthlySettlement?: boolean, companyId?: string, healthcareFacilityId?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.reportControllerGetCompaniesCountRaw({ filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, onlyMonthlySettlement: onlyMonthlySettlement, companyId: companyId, healthcareFacilityId: healthcareFacilityId, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetCompaniesDetailsByPortionRaw(requestParameters: ReportControllerGetCompaniesDetailsByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJudgmentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling reportControllerGetCompaniesDetailsByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling reportControllerGetCompaniesDetailsByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling reportControllerGetCompaniesDetailsByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling reportControllerGetCompaniesDetailsByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetCompaniesDetailsByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['psychologistId'] != null) {
            queryParameters['psychologistId'] = requestParameters['psychologistId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['onlyMonthlySettlement'] != null) {
            queryParameters['onlyMonthlySettlement'] = requestParameters['onlyMonthlySettlement'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchCompaniesDetails/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJudgmentDtoFromJSON));
    }

    /**
     */
    async reportControllerGetCompaniesDetailsByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, psychologistId?: string, companyId?: string, registerId?: string, healthcareFacilityId?: string, dateFrom?: Date, dateTo?: Date, onlyMonthlySettlement?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJudgmentDto>> {
        const response = await this.reportControllerGetCompaniesDetailsByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, psychologistId: psychologistId, companyId: companyId, registerId: registerId, healthcareFacilityId: healthcareFacilityId, dateFrom: dateFrom, dateTo: dateTo, onlyMonthlySettlement: onlyMonthlySettlement, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetCompaniesDetailsCountRaw(requestParameters: ReportControllerGetCompaniesDetailsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetCompaniesDetailsCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['psychologistId'] != null) {
            queryParameters['psychologistId'] = requestParameters['psychologistId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['onlyMonthlySettlement'] != null) {
            queryParameters['onlyMonthlySettlement'] = requestParameters['onlyMonthlySettlement'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchCompaniesDetails/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async reportControllerGetCompaniesDetailsCount(filterText: string, psychologistId?: string, companyId?: string, registerId?: string, healthcareFacilityId?: string, dateFrom?: Date, dateTo?: Date, onlyMonthlySettlement?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.reportControllerGetCompaniesDetailsCountRaw({ filterText: filterText, psychologistId: psychologistId, companyId: companyId, registerId: registerId, healthcareFacilityId: healthcareFacilityId, dateFrom: dateFrom, dateTo: dateTo, onlyMonthlySettlement: onlyMonthlySettlement, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetConsultationsByPortionRaw(requestParameters: ReportControllerGetConsultationsByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReportConsultationDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling reportControllerGetConsultationsByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling reportControllerGetConsultationsByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling reportControllerGetConsultationsByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling reportControllerGetConsultationsByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetConsultationsByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withType'] != null) {
            queryParameters['withType'] = requestParameters['withType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchConsultations/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReportConsultationDtoFromJSON));
    }

    /**
     */
    async reportControllerGetConsultationsByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, dateFrom?: Date, dateTo?: Date, userUid?: string, companyId?: string, healthcareFacilityId?: string, withHealthcareFacility?: boolean, withType?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReportConsultationDto>> {
        const response = await this.reportControllerGetConsultationsByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, companyId: companyId, healthcareFacilityId: healthcareFacilityId, withHealthcareFacility: withHealthcareFacility, withType: withType }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetConsultationsCountRaw(requestParameters: ReportControllerGetConsultationsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetConsultationsCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withType'] != null) {
            queryParameters['withType'] = requestParameters['withType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchConsultations/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async reportControllerGetConsultationsCount(filterText: string, dateFrom?: Date, dateTo?: Date, userUid?: string, companyId?: string, healthcareFacilityId?: string, withHealthcareFacility?: boolean, withType?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.reportControllerGetConsultationsCountRaw({ filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, companyId: companyId, healthcareFacilityId: healthcareFacilityId, withHealthcareFacility: withHealthcareFacility, withType: withType }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetJudgmentsByCreatorByPortionRaw(requestParameters: ReportControllerGetJudgmentsByCreatorByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReportJudgmentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling reportControllerGetJudgmentsByCreatorByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling reportControllerGetJudgmentsByCreatorByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling reportControllerGetJudgmentsByCreatorByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling reportControllerGetJudgmentsByCreatorByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetJudgmentsByCreatorByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchJudgmentsByCreator/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReportJudgmentDtoFromJSON));
    }

    /**
     */
    async reportControllerGetJudgmentsByCreatorByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReportJudgmentDto>> {
        const response = await this.reportControllerGetJudgmentsByCreatorByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetJudgmentsByCreatorCountRaw(requestParameters: ReportControllerGetJudgmentsByCreatorCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetJudgmentsByCreatorCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchJudgmentsByCreator/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async reportControllerGetJudgmentsByCreatorCount(filterText: string, dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.reportControllerGetJudgmentsByCreatorCountRaw({ filterText: filterText, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetJudgmentsByPortionRaw(requestParameters: ReportControllerGetJudgmentsByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReportJudgmentDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling reportControllerGetJudgmentsByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling reportControllerGetJudgmentsByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling reportControllerGetJudgmentsByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling reportControllerGetJudgmentsByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetJudgmentsByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchJudgments/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReportJudgmentDtoFromJSON));
    }

    /**
     */
    async reportControllerGetJudgmentsByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, dateFrom?: Date, dateTo?: Date, userUid?: string, companyId?: string, healthcareFacilityId?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReportJudgmentDto>> {
        const response = await this.reportControllerGetJudgmentsByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, companyId: companyId, healthcareFacilityId: healthcareFacilityId, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetJudgmentsCountRaw(requestParameters: ReportControllerGetJudgmentsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetJudgmentsCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchJudgments/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async reportControllerGetJudgmentsCount(filterText: string, dateFrom?: Date, dateTo?: Date, userUid?: string, companyId?: string, healthcareFacilityId?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.reportControllerGetJudgmentsCountRaw({ filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, companyId: companyId, healthcareFacilityId: healthcareFacilityId, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetSynevoCompaniesByPortionRaw(requestParameters: ReportControllerGetSynevoCompaniesByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSynevoReportCompanyDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling reportControllerGetSynevoCompaniesByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling reportControllerGetSynevoCompaniesByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling reportControllerGetSynevoCompaniesByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling reportControllerGetSynevoCompaniesByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetSynevoCompaniesByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchSynevoCompanies/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSynevoReportCompanyDtoFromJSON));
    }

    /**
     */
    async reportControllerGetSynevoCompaniesByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, dateFrom?: Date, dateTo?: Date, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSynevoReportCompanyDto>> {
        const response = await this.reportControllerGetSynevoCompaniesByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerGetSynevoCompaniesCountRaw(requestParameters: ReportControllerGetSynevoCompaniesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportControllerGetSynevoCompaniesCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/searchSynevoCompanies/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async reportControllerGetSynevoCompaniesCount(filterText: string, dateFrom?: Date, dateTo?: Date, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.reportControllerGetSynevoCompaniesCountRaw({ filterText: filterText, dateFrom: dateFrom, dateTo: dateTo, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportByTypeExamsRaw(requestParameters: ReportControllerReportByTypeExamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelWith4CountsValue>>> {
        const queryParameters: any = {};

        if (requestParameters['currentMonthOnly'] != null) {
            queryParameters['currentMonthOnly'] = requestParameters['currentMonthOnly'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/byTypeExams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelWith4CountsValueFromJSON));
    }

    /**
     */
    async reportControllerReportByTypeExams(currentMonthOnly?: boolean, dateFrom?: Date, dateTo?: Date, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelWith4CountsValue>> {
        const response = await this.reportControllerReportByTypeExamsRaw({ currentMonthOnly: currentMonthOnly, dateFrom: dateFrom, dateTo: dateTo, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportCloseExamsRaw(requestParameters: ReportControllerReportCloseExamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelValue>>> {
        const queryParameters: any = {};

        if (requestParameters['currentMonthOnly'] != null) {
            queryParameters['currentMonthOnly'] = requestParameters['currentMonthOnly'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/closeExams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelValueFromJSON));
    }

    /**
     */
    async reportControllerReportCloseExams(currentMonthOnly?: boolean, dateFrom?: Date, dateTo?: Date, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelValue>> {
        const response = await this.reportControllerReportCloseExamsRaw({ currentMonthOnly: currentMonthOnly, dateFrom: dateFrom, dateTo: dateTo, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportInvoicesReceiptsRaw(requestParameters: ReportControllerReportInvoicesReceiptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelWith2ValuesValue>>> {
        const queryParameters: any = {};

        if (requestParameters['currentMonthOnly'] != null) {
            queryParameters['currentMonthOnly'] = requestParameters['currentMonthOnly'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/invoicesReceipts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelWith2ValuesValueFromJSON));
    }

    /**
     */
    async reportControllerReportInvoicesReceipts(currentMonthOnly?: boolean, dateFrom?: Date, dateTo?: Date, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelWith2ValuesValue>> {
        const response = await this.reportControllerReportInvoicesReceiptsRaw({ currentMonthOnly: currentMonthOnly, dateFrom: dateFrom, dateTo: dateTo, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportInvoicesReceiptsByPaymentRaw(requestParameters: ReportControllerReportInvoicesReceiptsByPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelWith2ValuesValue>>> {
        const queryParameters: any = {};

        if (requestParameters['currentMonthOnly'] != null) {
            queryParameters['currentMonthOnly'] = requestParameters['currentMonthOnly'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/invoicesReceiptsByPayment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelWith2ValuesValueFromJSON));
    }

    /**
     */
    async reportControllerReportInvoicesReceiptsByPayment(currentMonthOnly?: boolean, dateFrom?: Date, dateTo?: Date, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelWith2ValuesValue>> {
        const response = await this.reportControllerReportInvoicesReceiptsByPaymentRaw({ currentMonthOnly: currentMonthOnly, dateFrom: dateFrom, dateTo: dateTo, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportJudgmentsRaw(requestParameters: ReportControllerReportJudgmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelValue>>> {
        const queryParameters: any = {};

        if (requestParameters['currentMonthOnly'] != null) {
            queryParameters['currentMonthOnly'] = requestParameters['currentMonthOnly'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/judgments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelValueFromJSON));
    }

    /**
     */
    async reportControllerReportJudgments(currentMonthOnly?: boolean, dateFrom?: Date, dateTo?: Date, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelValue>> {
        const response = await this.reportControllerReportJudgmentsRaw({ currentMonthOnly: currentMonthOnly, dateFrom: dateFrom, dateTo: dateTo, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportOverdueInvoicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OverdueInvoiceDebtDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/overdueInvoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OverdueInvoiceDebtDtoFromJSON));
    }

    /**
     */
    async reportControllerReportOverdueInvoices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OverdueInvoiceDebtDto>> {
        const response = await this.reportControllerReportOverdueInvoicesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportPaymentsByDateRaw(requestParameters: ReportControllerReportPaymentsByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LabelWith3ValuesValue>>> {
        const queryParameters: any = {};

        if (requestParameters['currentMonthOnly'] != null) {
            queryParameters['currentMonthOnly'] = requestParameters['currentMonthOnly'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/paymentsByDate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelWith3ValuesValueFromJSON));
    }

    /**
     */
    async reportControllerReportPaymentsByDate(currentMonthOnly?: boolean, dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LabelWith3ValuesValue>> {
        const response = await this.reportControllerReportPaymentsByDateRaw({ currentMonthOnly: currentMonthOnly, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportRegisterStatisticsSPDByMonthsCountsRaw(requestParameters: ReportControllerReportRegisterStatisticsSPDByMonthsCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterStatistics>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/registerStatisticsSPDByMonthsCounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterStatisticsFromJSON(jsonValue));
    }

    /**
     */
    async reportControllerReportRegisterStatisticsSPDByMonthsCounts(dateFrom?: Date, dateTo?: Date, userUid?: string, companyId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterStatistics> {
        const response = await this.reportControllerReportRegisterStatisticsSPDByMonthsCountsRaw({ dateFrom: dateFrom, dateTo: dateTo, userUid: userUid, companyId: companyId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportStatisticsSPDCountsRaw(requestParameters: ReportControllerReportStatisticsSPDCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsSPD>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/statisticsSPDCounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsSPDFromJSON(jsonValue));
    }

    /**
     */
    async reportControllerReportStatisticsSPDCounts(dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsSPD> {
        const response = await this.reportControllerReportStatisticsSPDCountsRaw({ dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportTopCompaniesByInvoicesRaw(requestParameters: ReportControllerReportTopCompaniesByInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TopCompanyInvoicesDto>>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/topCompaniesByInvoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TopCompanyInvoicesDtoFromJSON));
    }

    /**
     */
    async reportControllerReportTopCompaniesByInvoices(dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TopCompanyInvoicesDto>> {
        const response = await this.reportControllerReportTopCompaniesByInvoicesRaw({ dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportTopCompaniesByJudgmentsRaw(requestParameters: ReportControllerReportTopCompaniesByJudgmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TopCompanyJudgmentsDto>>> {
        const queryParameters: any = {};

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/topCompaniesByJudgments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TopCompanyJudgmentsDtoFromJSON));
    }

    /**
     */
    async reportControllerReportTopCompaniesByJudgments(dateFrom?: Date, dateTo?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TopCompanyJudgmentsDto>> {
        const response = await this.reportControllerReportTopCompaniesByJudgmentsRaw({ dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportControllerReportUnlinkedPaymentsTotalRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnlinkedPaymentsTotalDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/report/report/unlinkedPaymentsTotal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnlinkedPaymentsTotalDtoFromJSON(jsonValue));
    }

    /**
     */
    async reportControllerReportUnlinkedPaymentsTotal(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnlinkedPaymentsTotalDto> {
        const response = await this.reportControllerReportUnlinkedPaymentsTotalRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async reportExcelControllerDownloadReportJudgmentsRaw(requestParameters: ReportExcelControllerDownloadReportJudgmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling reportExcelControllerDownloadReportJudgments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['psychologistId'] != null) {
            queryParameters['psychologistId'] = requestParameters['psychologistId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['registerId'] != null) {
            queryParameters['registerId'] = requestParameters['registerId'];
        }

        if (requestParameters['healthcareFacilityId'] != null) {
            queryParameters['healthcareFacilityId'] = requestParameters['healthcareFacilityId'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = (requestParameters['dateFrom'] as any).toISOString();
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = (requestParameters['dateTo'] as any).toISOString();
        }

        if (requestParameters['onlyMonthlySettlement'] != null) {
            queryParameters['onlyMonthlySettlement'] = requestParameters['onlyMonthlySettlement'];
        }

        if (requestParameters['withHealthcareFacility'] != null) {
            queryParameters['withHealthcareFacility'] = requestParameters['withHealthcareFacility'];
        }

        if (requestParameters['withRegister'] != null) {
            queryParameters['withRegister'] = requestParameters['withRegister'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reportExcel/get/reportJudgments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async reportExcelControllerDownloadReportJudgments(filterText: string, psychologistId?: string, companyId?: string, registerId?: string, healthcareFacilityId?: string, dateFrom?: Date, dateTo?: Date, onlyMonthlySettlement?: string, withHealthcareFacility?: boolean, withRegister?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.reportExcelControllerDownloadReportJudgmentsRaw({ filterText: filterText, psychologistId: psychologistId, companyId: companyId, registerId: registerId, healthcareFacilityId: healthcareFacilityId, dateFrom: dateFrom, dateTo: dateTo, onlyMonthlySettlement: onlyMonthlySettlement, withHealthcareFacility: withHealthcareFacility, withRegister: withRegister }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportExcelControllerReportBillingSummaryRaw(requestParameters: ReportExcelControllerReportBillingSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['filterData'] == null) {
            throw new runtime.RequiredError(
                'filterData',
                'Required parameter "filterData" was null or undefined when calling reportExcelControllerReportBillingSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reportExcel/get/billingSummaryCompany`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterDataToJSON(requestParameters['filterData']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async reportExcelControllerReportBillingSummary(filterData: FilterData, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.reportExcelControllerReportBillingSummaryRaw({ filterData: filterData }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportExcelControllerReportCompanySummaryRaw(requestParameters: ReportExcelControllerReportCompanySummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['filterData'] == null) {
            throw new runtime.RequiredError(
                'filterData',
                'Required parameter "filterData" was null or undefined when calling reportExcelControllerReportCompanySummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reportExcel/get/byCompanySummary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterDataToJSON(requestParameters['filterData']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async reportExcelControllerReportCompanySummary(filterData: FilterData, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.reportExcelControllerReportCompanySummaryRaw({ filterData: filterData }, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportExcelControllerReportSalesInvoicesRaw(requestParameters: ReportExcelControllerReportSalesInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['filterData'] == null) {
            throw new runtime.RequiredError(
                'filterData',
                'Required parameter "filterData" was null or undefined when calling reportExcelControllerReportSalesInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reportExcel/get/reportSalesInvoices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterDataToJSON(requestParameters['filterData']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async reportExcelControllerReportSalesInvoices(filterData: FilterData, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.reportExcelControllerReportSalesInvoicesRaw({ filterData: filterData }, initOverrides);
        return await response.value();
    }

    /**
     */
    async resultControllerGetByExamTestRaw(requestParameters: ResultControllerGetByExamTestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetResultForTestsDto>>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling resultControllerGetByExamTest().'
            );
        }

        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling resultControllerGetByExamTest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['testId'] != null) {
            queryParameters['testId'] = requestParameters['testId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/result/get/byExamTest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetResultForTestsDtoFromJSON));
    }

    /**
     */
    async resultControllerGetByExamTest(examId: string, testId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetResultForTestsDto>> {
        const response = await this.resultControllerGetByExamTestRaw({ examId: examId, testId: testId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async resultControllerGetByExamTestIdRaw(requestParameters: ResultControllerGetByExamTestIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetResultDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resultControllerGetByExamTestId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/result/get/byExamTestId/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetResultDtoFromJSON));
    }

    /**
     */
    async resultControllerGetByExamTestId(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetResultDto>> {
        const response = await this.resultControllerGetByExamTestIdRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async resultControllerSaveResultRaw(requestParameters: ResultControllerSaveResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling resultControllerSaveResult().'
            );
        }

        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling resultControllerSaveResult().'
            );
        }

        if (requestParameters['createUpdateResultDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateResultDto',
                'Required parameter "createUpdateResultDto" was null or undefined when calling resultControllerSaveResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/result/saveResult/{examId}/{testId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))).replace(`{${"testId"}}`, encodeURIComponent(String(requestParameters['testId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateResultDtoToJSON(requestParameters['createUpdateResultDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resultControllerSaveResult(examId: string, testId: string, createUpdateResultDto: CreateUpdateResultDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resultControllerSaveResultRaw({ examId: examId, testId: testId, createUpdateResultDto: createUpdateResultDto }, initOverrides);
    }

    /**
     */
    async resultControllerSaveResultsRaw(requestParameters: ResultControllerSaveResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling resultControllerSaveResults().'
            );
        }

        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling resultControllerSaveResults().'
            );
        }

        if (requestParameters['createUpdateResultsDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateResultsDto',
                'Required parameter "createUpdateResultsDto" was null or undefined when calling resultControllerSaveResults().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/result/saveResults/{examId}/{testId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))).replace(`{${"testId"}}`, encodeURIComponent(String(requestParameters['testId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateResultsDtoToJSON(requestParameters['createUpdateResultsDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resultControllerSaveResults(examId: string, testId: string, createUpdateResultsDto: CreateUpdateResultsDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resultControllerSaveResultsRaw({ examId: examId, testId: testId, createUpdateResultsDto: createUpdateResultsDto }, initOverrides);
    }

    /**
     */
    async salesInvoiceControllerAddExamsRaw(requestParameters: SalesInvoiceControllerAddExamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerAddExams().'
            );
        }

        if (requestParameters['addExamsSalesInvoiceDto'] == null) {
            throw new runtime.RequiredError(
                'addExamsSalesInvoiceDto',
                'Required parameter "addExamsSalesInvoiceDto" was null or undefined when calling salesInvoiceControllerAddExams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/addExams/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddExamsSalesInvoiceDtoToJSON(requestParameters['addExamsSalesInvoiceDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async salesInvoiceControllerAddExams(id: string, addExamsSalesInvoiceDto: AddExamsSalesInvoiceDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.salesInvoiceControllerAddExamsRaw({ id: id, addExamsSalesInvoiceDto: addExamsSalesInvoiceDto }, initOverrides);
    }

    /**
     */
    async salesInvoiceControllerCalculatePositionsRaw(requestParameters: SalesInvoiceControllerCalculatePositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculatePositionsResultDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerCalculatePositions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/calculatePositions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculatePositionsResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerCalculatePositions(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculatePositionsResultDto> {
        const response = await this.salesInvoiceControllerCalculatePositionsRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerCreateRaw(requestParameters: SalesInvoiceControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSalesInvoiceDto>> {
        if (requestParameters['createUpdateSalesInvoiceDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSalesInvoiceDto',
                'Required parameter "createUpdateSalesInvoiceDto" was null or undefined when calling salesInvoiceControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSalesInvoiceDtoToJSON(requestParameters['createUpdateSalesInvoiceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSalesInvoiceDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerCreate(createUpdateSalesInvoiceDto: CreateUpdateSalesInvoiceDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSalesInvoiceDto> {
        const response = await this.salesInvoiceControllerCreateRaw({ createUpdateSalesInvoiceDto: createUpdateSalesInvoiceDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerCreateCorrectionRaw(requestParameters: SalesInvoiceControllerCreateCorrectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSalesInvoiceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerCreateCorrection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/correction/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSalesInvoiceDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerCreateCorrection(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSalesInvoiceDto> {
        const response = await this.salesInvoiceControllerCreateCorrectionRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerCreateFromExamRaw(requestParameters: SalesInvoiceControllerCreateFromExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSalesInvoiceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerCreateFromExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/fromExam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSalesInvoiceDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerCreateFromExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSalesInvoiceDto> {
        const response = await this.salesInvoiceControllerCreateFromExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerCreateFromPaymentRaw(requestParameters: SalesInvoiceControllerCreateFromPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSalesInvoiceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerCreateFromPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/fromPayment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSalesInvoiceDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerCreateFromPayment(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSalesInvoiceDto> {
        const response = await this.salesInvoiceControllerCreateFromPaymentRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerDeactivateRaw(requestParameters: SalesInvoiceControllerDeactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerDeactivate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/deactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async salesInvoiceControllerDeactivate(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.salesInvoiceControllerDeactivateRaw({ id: id }, initOverrides);
    }

    /**
     */
    async salesInvoiceControllerGenerateAutoInvoiceRaw(requestParameters: SalesInvoiceControllerGenerateAutoInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateAutoSalesInvoiceResultDto>> {
        if (requestParameters['generateAutoSalesInvoiceDto'] == null) {
            throw new runtime.RequiredError(
                'generateAutoSalesInvoiceDto',
                'Required parameter "generateAutoSalesInvoiceDto" was null or undefined when calling salesInvoiceControllerGenerateAutoInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/generateAutoInvoice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateAutoSalesInvoiceDtoToJSON(requestParameters['generateAutoSalesInvoiceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateAutoSalesInvoiceResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerGenerateAutoInvoice(generateAutoSalesInvoiceDto: GenerateAutoSalesInvoiceDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateAutoSalesInvoiceResultDto> {
        const response = await this.salesInvoiceControllerGenerateAutoInvoiceRaw({ generateAutoSalesInvoiceDto: generateAutoSalesInvoiceDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerGetRaw(requestParameters: SalesInvoiceControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSalesInvoiceDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSalesInvoiceDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSalesInvoiceDto> {
        const response = await this.salesInvoiceControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerGetAllByPortionRaw(requestParameters: SalesInvoiceControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSalesInvoiceDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling salesInvoiceControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling salesInvoiceControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling salesInvoiceControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling salesInvoiceControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling salesInvoiceControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['ksefStatuses'] != null) {
            queryParameters['ksefStatuses'] = requestParameters['ksefStatuses'];
        }

        if (requestParameters['onlyWithUnlinkedAmount'] != null) {
            queryParameters['onlyWithUnlinkedAmount'] = requestParameters['onlyWithUnlinkedAmount'];
        }

        if (requestParameters['onlyLinkable'] != null) {
            queryParameters['onlyLinkable'] = requestParameters['onlyLinkable'];
        }

        if (requestParameters['paymentId'] != null) {
            queryParameters['paymentId'] = requestParameters['paymentId'];
        }

        if (requestParameters['onlyOverpaid'] != null) {
            queryParameters['onlyOverpaid'] = requestParameters['onlyOverpaid'];
        }

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['onlyOverdue'] != null) {
            queryParameters['onlyOverdue'] = requestParameters['onlyOverdue'];
        }

        if (requestParameters['onlyAutoGenerated'] != null) {
            queryParameters['onlyAutoGenerated'] = requestParameters['onlyAutoGenerated'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSalesInvoiceDtoFromJSON));
    }

    /**
     */
    async salesInvoiceControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, status?: string, statuses?: string, ksefStatuses?: string, onlyWithUnlinkedAmount?: string, onlyLinkable?: string, paymentId?: string, onlyOverpaid?: string, examId?: string, companyId?: string, onlyOverdue?: string, onlyAutoGenerated?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSalesInvoiceDto>> {
        const response = await this.salesInvoiceControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns, status: status, statuses: statuses, ksefStatuses: ksefStatuses, onlyWithUnlinkedAmount: onlyWithUnlinkedAmount, onlyLinkable: onlyLinkable, paymentId: paymentId, onlyOverpaid: onlyOverpaid, examId: examId, companyId: companyId, onlyOverdue: onlyOverdue, onlyAutoGenerated: onlyAutoGenerated }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerGetAllCountRaw(requestParameters: SalesInvoiceControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling salesInvoiceControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['ksefStatuses'] != null) {
            queryParameters['ksefStatuses'] = requestParameters['ksefStatuses'];
        }

        if (requestParameters['onlyWithUnlinkedAmount'] != null) {
            queryParameters['onlyWithUnlinkedAmount'] = requestParameters['onlyWithUnlinkedAmount'];
        }

        if (requestParameters['onlyLinkable'] != null) {
            queryParameters['onlyLinkable'] = requestParameters['onlyLinkable'];
        }

        if (requestParameters['paymentId'] != null) {
            queryParameters['paymentId'] = requestParameters['paymentId'];
        }

        if (requestParameters['onlyOverpaid'] != null) {
            queryParameters['onlyOverpaid'] = requestParameters['onlyOverpaid'];
        }

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['onlyOverdue'] != null) {
            queryParameters['onlyOverdue'] = requestParameters['onlyOverdue'];
        }

        if (requestParameters['onlyAutoGenerated'] != null) {
            queryParameters['onlyAutoGenerated'] = requestParameters['onlyAutoGenerated'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async salesInvoiceControllerGetAllCount(filterText: string, filterColumns?: string, status?: string, statuses?: string, ksefStatuses?: string, onlyWithUnlinkedAmount?: string, onlyLinkable?: string, paymentId?: string, onlyOverpaid?: string, examId?: string, companyId?: string, onlyOverdue?: string, onlyAutoGenerated?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.salesInvoiceControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns, status: status, statuses: statuses, ksefStatuses: ksefStatuses, onlyWithUnlinkedAmount: onlyWithUnlinkedAmount, onlyLinkable: onlyLinkable, paymentId: paymentId, onlyOverpaid: onlyOverpaid, examId: examId, companyId: companyId, onlyOverdue: onlyOverdue, onlyAutoGenerated: onlyAutoGenerated }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerGetByExamRaw(requestParameters: SalesInvoiceControllerGetByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSalesInvoiceDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerGetByExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/byExam/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSalesInvoiceDtoFromJSON));
    }

    /**
     */
    async salesInvoiceControllerGetByExam(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSalesInvoiceDto>> {
        const response = await this.salesInvoiceControllerGetByExamRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerGetLastEditorRaw(requestParameters: SalesInvoiceControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async salesInvoiceControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.salesInvoiceControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerGetNumberToCorrectRaw(requestParameters: SalesInvoiceControllerGetNumberToCorrectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerGetNumberToCorrect().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/numberToCorrect/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async salesInvoiceControllerGetNumberToCorrect(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.salesInvoiceControllerGetNumberToCorrectRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async salesInvoiceControllerRemoveExamRaw(requestParameters: SalesInvoiceControllerRemoveExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling salesInvoiceControllerRemoveExam().'
            );
        }

        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling salesInvoiceControllerRemoveExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/removeExam/{invoiceId}/{examId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId']))).replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async salesInvoiceControllerRemoveExam(invoiceId: string, examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.salesInvoiceControllerRemoveExamRaw({ invoiceId: invoiceId, examId: examId }, initOverrides);
    }

    /**
     */
    async salesInvoiceControllerRetryKsefRaw(requestParameters: SalesInvoiceControllerRetryKsefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerRetryKsef().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/retryKsef/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async salesInvoiceControllerRetryKsef(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.salesInvoiceControllerRetryKsefRaw({ id: id }, initOverrides);
    }

    /**
     */
    async salesInvoiceControllerRevertToDraftRaw(requestParameters: SalesInvoiceControllerRevertToDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerRevertToDraft().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/revertToDraft/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async salesInvoiceControllerRevertToDraft(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.salesInvoiceControllerRevertToDraftRaw({ id: id }, initOverrides);
    }

    /**
     */
    async salesInvoiceControllerUpdateRaw(requestParameters: SalesInvoiceControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling salesInvoiceControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateSalesInvoiceDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSalesInvoiceDto',
                'Required parameter "createUpdateSalesInvoiceDto" was null or undefined when calling salesInvoiceControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSalesInvoiceDtoToJSON(requestParameters['createUpdateSalesInvoiceDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async salesInvoiceControllerUpdate(id: string, createUpdateSalesInvoiceDto: CreateUpdateSalesInvoiceDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.salesInvoiceControllerUpdateRaw({ id: id, createUpdateSalesInvoiceDto: createUpdateSalesInvoiceDto }, initOverrides);
    }

    /**
     */
    async salesInvoicePositionControllerCreateManyRaw(requestParameters: SalesInvoicePositionControllerCreateManyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSalesInvoicePositionDto>>> {
        if (requestParameters['createUpdateSalesInvoicePositionsDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSalesInvoicePositionsDto',
                'Required parameter "createUpdateSalesInvoicePositionsDto" was null or undefined when calling salesInvoicePositionControllerCreateMany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/salesInvoicePosition/createPositions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSalesInvoicePositionsDtoToJSON(requestParameters['createUpdateSalesInvoicePositionsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSalesInvoicePositionDtoFromJSON));
    }

    /**
     */
    async salesInvoicePositionControllerCreateMany(createUpdateSalesInvoicePositionsDto: CreateUpdateSalesInvoicePositionsDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSalesInvoicePositionDto>> {
        const response = await this.salesInvoicePositionControllerCreateManyRaw({ createUpdateSalesInvoicePositionsDto: createUpdateSalesInvoicePositionsDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async savedPdfControllerGetCardSignatureStatusRaw(requestParameters: SavedPdfControllerGetCardSignatureStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSavedPdfSignatureStatusDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling savedPdfControllerGetCardSignatureStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/cardSignatureStatus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSavedPdfSignatureStatusDtoFromJSON(jsonValue));
    }

    /**
     */
    async savedPdfControllerGetCardSignatureStatus(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSavedPdfSignatureStatusDto> {
        const response = await this.savedPdfControllerGetCardSignatureStatusRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async savedPdfControllerGetExternalReferralForExaminedRaw(requestParameters: SavedPdfControllerGetExternalReferralForExaminedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSavedPdfExternalReferralDto>>> {
        if (requestParameters['examinedId'] == null) {
            throw new runtime.RequiredError(
                'examinedId',
                'Required parameter "examinedId" was null or undefined when calling savedPdfControllerGetExternalReferralForExamined().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examinedId'] != null) {
            queryParameters['examinedId'] = requestParameters['examinedId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/externalReferral/forObject`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSavedPdfExternalReferralDtoFromJSON));
    }

    /**
     */
    async savedPdfControllerGetExternalReferralForExamined(examinedId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSavedPdfExternalReferralDto>> {
        const response = await this.savedPdfControllerGetExternalReferralForExaminedRaw({ examinedId: examinedId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async savedPdfControllerGetFileDownloadRaw(requestParameters: SavedPdfControllerGetFileDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling savedPdfControllerGetFileDownload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/fileDownloas/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async savedPdfControllerGetFileDownload(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.savedPdfControllerGetFileDownloadRaw({ id: id }, initOverrides);
    }

    /**
     */
    async savedPdfControllerGetJudgmentSignatureStatusRaw(requestParameters: SavedPdfControllerGetJudgmentSignatureStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSavedPdfSignatureStatusDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling savedPdfControllerGetJudgmentSignatureStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/judgmentSignatureStatus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSavedPdfSignatureStatusDtoFromJSON(jsonValue));
    }

    /**
     */
    async savedPdfControllerGetJudgmentSignatureStatus(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSavedPdfSignatureStatusDto> {
        const response = await this.savedPdfControllerGetJudgmentSignatureStatusRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async savedPdfControllerGetReferralSignatureStatusRaw(requestParameters: SavedPdfControllerGetReferralSignatureStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSavedPdfSignatureStatusDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling savedPdfControllerGetReferralSignatureStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/referralSignatureStatus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSavedPdfSignatureStatusDtoFromJSON(jsonValue));
    }

    /**
     */
    async savedPdfControllerGetReferralSignatureStatus(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSavedPdfSignatureStatusDto> {
        const response = await this.savedPdfControllerGetReferralSignatureStatusRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async savedPdfControllerSavePdfFileForCardRaw(requestParameters: SavedPdfControllerSavePdfFileForCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createUpdateSavedPdfDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSavedPdfDto',
                'Required parameter "createUpdateSavedPdfDto" was null or undefined when calling savedPdfControllerSavePdfFileForCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/savePdfFileForCard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSavedPdfDtoToJSON(requestParameters['createUpdateSavedPdfDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async savedPdfControllerSavePdfFileForCard(createUpdateSavedPdfDto: CreateUpdateSavedPdfDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.savedPdfControllerSavePdfFileForCardRaw({ createUpdateSavedPdfDto: createUpdateSavedPdfDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async savedPdfControllerSavePdfFileForJudgmentRaw(requestParameters: SavedPdfControllerSavePdfFileForJudgmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createUpdateSavedPdfDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSavedPdfDto',
                'Required parameter "createUpdateSavedPdfDto" was null or undefined when calling savedPdfControllerSavePdfFileForJudgment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/savePdfFileForJudgment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSavedPdfDtoToJSON(requestParameters['createUpdateSavedPdfDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async savedPdfControllerSavePdfFileForJudgment(createUpdateSavedPdfDto: CreateUpdateSavedPdfDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.savedPdfControllerSavePdfFileForJudgmentRaw({ createUpdateSavedPdfDto: createUpdateSavedPdfDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async savedPdfControllerSavePdfFileForReferralRaw(requestParameters: SavedPdfControllerSavePdfFileForReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createUpdateSavedPdfDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSavedPdfDto',
                'Required parameter "createUpdateSavedPdfDto" was null or undefined when calling savedPdfControllerSavePdfFileForReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/savedPdf/savePdfFileForReferral`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSavedPdfDtoToJSON(requestParameters['createUpdateSavedPdfDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async savedPdfControllerSavePdfFileForReferral(createUpdateSavedPdfDto: CreateUpdateSavedPdfDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.savedPdfControllerSavePdfFileForReferralRaw({ createUpdateSavedPdfDto: createUpdateSavedPdfDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async stampControllerGetStampsByUserRaw(requestParameters: StampControllerGetStampsByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetStampDto>>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stamp/byUser`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStampDtoFromJSON));
    }

    /**
     */
    async stampControllerGetStampsByUser(userId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetStampDto>> {
        const response = await this.stampControllerGetStampsByUserRaw({ userId: userId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async stampControllerUploadStampsRaw(requestParameters: StampControllerUploadStampsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetStampDto>>> {
        if (requestParameters['uploadStampsDto'] == null) {
            throw new runtime.RequiredError(
                'uploadStampsDto',
                'Required parameter "uploadStampsDto" was null or undefined when calling stampControllerUploadStamps().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stamp/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadStampsDtoToJSON(requestParameters['uploadStampsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStampDtoFromJSON));
    }

    /**
     */
    async stampControllerUploadStamps(uploadStampsDto: UploadStampsDto, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetStampDto>> {
        const response = await this.stampControllerUploadStampsRaw({ uploadStampsDto: uploadStampsDto, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async stethoControllerGetCardioResultRaw(requestParameters: StethoControllerGetCardioResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling stethoControllerGetCardioResult().'
            );
        }

        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling stethoControllerGetCardioResult().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['testId'] != null) {
            queryParameters['testId'] = requestParameters['testId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stetho/get/cardioResult`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async stethoControllerGetCardioResult(examId: string, testId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.stethoControllerGetCardioResultRaw({ examId: examId, testId: testId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async stethoControllerGetClientMediaTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientToken>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stetho/get/clientMediaToken`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientTokenFromJSON(jsonValue));
    }

    /**
     */
    async stethoControllerGetClientMediaToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientToken> {
        const response = await this.stethoControllerGetClientMediaTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async stethoControllerGetClientTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientToken>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stetho/get/clientToken`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientTokenFromJSON(jsonValue));
    }

    /**
     */
    async stethoControllerGetClientToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientToken> {
        const response = await this.stethoControllerGetClientTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async stethoControllerGetPulmonaryResultRaw(requestParameters: StethoControllerGetPulmonaryResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling stethoControllerGetPulmonaryResult().'
            );
        }

        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling stethoControllerGetPulmonaryResult().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['testId'] != null) {
            queryParameters['testId'] = requestParameters['testId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stetho/get/pulmonaryResult`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async stethoControllerGetPulmonaryResult(examId: string, testId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.stethoControllerGetPulmonaryResultRaw({ examId: examId, testId: testId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async stethoControllerGetSrcFrameRaw(requestParameters: StethoControllerGetSrcFrameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['visitId'] == null) {
            throw new runtime.RequiredError(
                'visitId',
                'Required parameter "visitId" was null or undefined when calling stethoControllerGetSrcFrame().'
            );
        }

        if (requestParameters['point'] == null) {
            throw new runtime.RequiredError(
                'point',
                'Required parameter "point" was null or undefined when calling stethoControllerGetSrcFrame().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['visitId'] != null) {
            queryParameters['visitId'] = requestParameters['visitId'];
        }

        if (requestParameters['point'] != null) {
            queryParameters['point'] = requestParameters['point'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stetho/get/srcFrame`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async stethoControllerGetSrcFrame(visitId: string, point: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.stethoControllerGetSrcFrameRaw({ visitId: visitId, point: point }, initOverrides);
        return await response.value();
    }

    /**
     */
    async stethoControllerGetViewStethoTestRaw(requestParameters: StethoControllerGetViewStethoTestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling stethoControllerGetViewStethoTest().'
            );
        }

        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError(
                'testId',
                'Required parameter "testId" was null or undefined when calling stethoControllerGetViewStethoTest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['testId'] != null) {
            queryParameters['testId'] = requestParameters['testId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stetho/get/viewStethoTest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async stethoControllerGetViewStethoTest(examId: string, testId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.stethoControllerGetViewStethoTestRaw({ examId: examId, testId: testId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerCreateRaw(requestParameters: SupportingExaminationControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupportingExaminationDto>> {
        if (requestParameters['createUpdateSupportingExaminationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSupportingExaminationDto',
                'Required parameter "createUpdateSupportingExaminationDto" was null or undefined when calling supportingExaminationControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSupportingExaminationDtoToJSON(requestParameters['createUpdateSupportingExaminationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupportingExaminationDtoFromJSON(jsonValue));
    }

    /**
     */
    async supportingExaminationControllerCreate(createUpdateSupportingExaminationDto: CreateUpdateSupportingExaminationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupportingExaminationDto> {
        const response = await this.supportingExaminationControllerCreateRaw({ createUpdateSupportingExaminationDto: createUpdateSupportingExaminationDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerDeleteRaw(requestParameters: SupportingExaminationControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling supportingExaminationControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async supportingExaminationControllerDelete(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.supportingExaminationControllerDeleteRaw({ id: id }, initOverrides);
    }

    /**
     */
    async supportingExaminationControllerGetRaw(requestParameters: SupportingExaminationControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupportingExaminationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling supportingExaminationControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupportingExaminationDtoFromJSON(jsonValue));
    }

    /**
     */
    async supportingExaminationControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupportingExaminationDto> {
        const response = await this.supportingExaminationControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerGetAllByExamRaw(requestParameters: SupportingExaminationControllerGetAllByExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSupportingExaminationDto>>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling supportingExaminationControllerGetAllByExam().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/all/byExam`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSupportingExaminationDtoFromJSON));
    }

    /**
     */
    async supportingExaminationControllerGetAllByExam(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSupportingExaminationDto>> {
        const response = await this.supportingExaminationControllerGetAllByExamRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerGetAllForUserToSignRaw(requestParameters: SupportingExaminationControllerGetAllForUserToSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSupportingExaminationDto>>> {
        const queryParameters: any = {};

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/getAll/forUserToSign`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSupportingExaminationDtoFromJSON));
    }

    /**
     */
    async supportingExaminationControllerGetAllForUserToSign(userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSupportingExaminationDto>> {
        const response = await this.supportingExaminationControllerGetAllForUserToSignRaw({ userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsByPortionRaw(requestParameters: SupportingExaminationControllerGetWithPrintsByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSupportingExaminationDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling supportingExaminationControllerGetWithPrintsByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling supportingExaminationControllerGetWithPrintsByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling supportingExaminationControllerGetWithPrintsByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling supportingExaminationControllerGetWithPrintsByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling supportingExaminationControllerGetWithPrintsByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/searchWithPrints/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSupportingExaminationDtoFromJSON));
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSupportingExaminationDto>> {
        const response = await this.supportingExaminationControllerGetWithPrintsByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsCountRaw(requestParameters: SupportingExaminationControllerGetWithPrintsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling supportingExaminationControllerGetWithPrintsCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/searchWithPrints/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.supportingExaminationControllerGetWithPrintsCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsForSigningByPortionRaw(requestParameters: SupportingExaminationControllerGetWithPrintsForSigningByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSupportingExaminationDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling supportingExaminationControllerGetWithPrintsForSigningByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling supportingExaminationControllerGetWithPrintsForSigningByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling supportingExaminationControllerGetWithPrintsForSigningByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling supportingExaminationControllerGetWithPrintsForSigningByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling supportingExaminationControllerGetWithPrintsForSigningByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/searchWithPrintsForSigning/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSupportingExaminationDtoFromJSON));
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsForSigningByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSupportingExaminationDto>> {
        const response = await this.supportingExaminationControllerGetWithPrintsForSigningByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsForSigningCountRaw(requestParameters: SupportingExaminationControllerGetWithPrintsForSigningCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling supportingExaminationControllerGetWithPrintsForSigningCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['userUid'] != null) {
            queryParameters['userUid'] = requestParameters['userUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/searchWithPrintsForSigning/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async supportingExaminationControllerGetWithPrintsForSigningCount(filterText: string, userUid?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.supportingExaminationControllerGetWithPrintsForSigningCountRaw({ filterText: filterText, userUid: userUid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationControllerUpdateRaw(requestParameters: SupportingExaminationControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling supportingExaminationControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateSupportingExaminationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSupportingExaminationDto',
                'Required parameter "createUpdateSupportingExaminationDto" was null or undefined when calling supportingExaminationControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExamination/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSupportingExaminationDtoToJSON(requestParameters['createUpdateSupportingExaminationDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async supportingExaminationControllerUpdate(id: string, createUpdateSupportingExaminationDto: CreateUpdateSupportingExaminationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.supportingExaminationControllerUpdateRaw({ id: id, createUpdateSupportingExaminationDto: createUpdateSupportingExaminationDto }, initOverrides);
    }

    /**
     */
    async supportingExaminationDictControllerCreateRaw(requestParameters: SupportingExaminationDictControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupportingExaminationDictDto>> {
        if (requestParameters['createUpdateSupportingExaminationDictDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSupportingExaminationDictDto',
                'Required parameter "createUpdateSupportingExaminationDictDto" was null or undefined when calling supportingExaminationDictControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExaminationDict`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSupportingExaminationDictDtoToJSON(requestParameters['createUpdateSupportingExaminationDictDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupportingExaminationDictDtoFromJSON(jsonValue));
    }

    /**
     */
    async supportingExaminationDictControllerCreate(createUpdateSupportingExaminationDictDto: CreateUpdateSupportingExaminationDictDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupportingExaminationDictDto> {
        const response = await this.supportingExaminationDictControllerCreateRaw({ createUpdateSupportingExaminationDictDto: createUpdateSupportingExaminationDictDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationDictControllerGetRaw(requestParameters: SupportingExaminationDictControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSupportingExaminationDictDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling supportingExaminationDictControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExaminationDict/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSupportingExaminationDictDtoFromJSON(jsonValue));
    }

    /**
     */
    async supportingExaminationDictControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSupportingExaminationDictDto> {
        const response = await this.supportingExaminationDictControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationDictControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSupportingExaminationDictDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExaminationDict`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSupportingExaminationDictDtoFromJSON));
    }

    /**
     */
    async supportingExaminationDictControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSupportingExaminationDictDto>> {
        const response = await this.supportingExaminationDictControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationDictControllerGetAllByPortionRaw(requestParameters: SupportingExaminationDictControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSupportingExaminationDictDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling supportingExaminationDictControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling supportingExaminationDictControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling supportingExaminationDictControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling supportingExaminationDictControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling supportingExaminationDictControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExaminationDict/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSupportingExaminationDictDtoFromJSON));
    }

    /**
     */
    async supportingExaminationDictControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSupportingExaminationDictDto>> {
        const response = await this.supportingExaminationDictControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationDictControllerGetAllCountRaw(requestParameters: SupportingExaminationDictControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling supportingExaminationDictControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExaminationDict/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async supportingExaminationDictControllerGetAllCount(filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.supportingExaminationDictControllerGetAllCountRaw({ filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async supportingExaminationDictControllerUpdateRaw(requestParameters: SupportingExaminationDictControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling supportingExaminationDictControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateSupportingExaminationDictDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateSupportingExaminationDictDto',
                'Required parameter "createUpdateSupportingExaminationDictDto" was null or undefined when calling supportingExaminationDictControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supportingExaminationDict/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateSupportingExaminationDictDtoToJSON(requestParameters['createUpdateSupportingExaminationDictDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async supportingExaminationDictControllerUpdate(id: string, createUpdateSupportingExaminationDictDto: CreateUpdateSupportingExaminationDictDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.supportingExaminationDictControllerUpdateRaw({ id: id, createUpdateSupportingExaminationDictDto: createUpdateSupportingExaminationDictDto }, initOverrides);
    }

    /**
     */
    async synevoControllerCancelOrderRaw(requestParameters: SynevoControllerCancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['synevoId'] == null) {
            throw new runtime.RequiredError(
                'synevoId',
                'Required parameter "synevoId" was null or undefined when calling synevoControllerCancelOrder().'
            );
        }

        if (requestParameters['sentOrderId'] == null) {
            throw new runtime.RequiredError(
                'sentOrderId',
                'Required parameter "sentOrderId" was null or undefined when calling synevoControllerCancelOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/cancelOrder/{synevoId}/sentOrderId/{sentOrderId}`.replace(`{${"synevoId"}}`, encodeURIComponent(String(requestParameters['synevoId']))).replace(`{${"sentOrderId"}}`, encodeURIComponent(String(requestParameters['sentOrderId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async synevoControllerCancelOrder(synevoId: string, sentOrderId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.synevoControllerCancelOrderRaw({ synevoId: synevoId, sentOrderId: sentOrderId }, initOverrides);
    }

    /**
     */
    async synevoControllerCreateForExamRaw(requestParameters: SynevoControllerCreateForExamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling synevoControllerCreateForExam().'
            );
        }

        if (requestParameters['createForExamSynevoDto'] == null) {
            throw new runtime.RequiredError(
                'createForExamSynevoDto',
                'Required parameter "createForExamSynevoDto" was null or undefined when calling synevoControllerCreateForExam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/createForExam/{examId}`.replace(`{${"examId"}}`, encodeURIComponent(String(requestParameters['examId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateForExamSynevoDtoToJSON(requestParameters['createForExamSynevoDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async synevoControllerCreateForExam(examId: string, createForExamSynevoDto: CreateForExamSynevoDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.synevoControllerCreateForExamRaw({ examId: examId, createForExamSynevoDto: createForExamSynevoDto }, initOverrides);
    }

    /**
     */
    async synevoControllerGetRaw(requestParameters: SynevoControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSynevoDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling synevoControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSynevoDtoFromJSON(jsonValue));
    }

    /**
     */
    async synevoControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSynevoDto> {
        const response = await this.synevoControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSynevoDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSynevoDtoFromJSON));
    }

    /**
     */
    async synevoControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSynevoDto>> {
        const response = await this.synevoControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetAllByPortionRaw(requestParameters: SynevoControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSynevoDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling synevoControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling synevoControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling synevoControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling synevoControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSynevoDtoFromJSON));
    }

    /**
     */
    async synevoControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSynevoDto>> {
        const response = await this.synevoControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetAllCountRaw(requestParameters: SynevoControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async synevoControllerGetAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.synevoControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetDictCostRaw(requestParameters: SynevoControllerGetDictCostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSynevoSelectedCostDto>> {
        if (requestParameters['dictIds'] == null) {
            throw new runtime.RequiredError(
                'dictIds',
                'Required parameter "dictIds" was null or undefined when calling synevoControllerGetDictCost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dictIds'] != null) {
            queryParameters['dictIds'] = requestParameters['dictIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/dictCost`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSynevoSelectedCostDtoFromJSON(jsonValue));
    }

    /**
     */
    async synevoControllerGetDictCost(dictIds: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSynevoSelectedCostDto> {
        const response = await this.synevoControllerGetDictCostRaw({ dictIds: dictIds }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetForExamByPortionRaw(requestParameters: SynevoControllerGetForExamByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSynevoDto>>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling synevoControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling synevoControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling synevoControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling synevoControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling synevoControllerGetForExamByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetForExamByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/forExam/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSynevoDtoFromJSON));
    }

    /**
     */
    async synevoControllerGetForExamByPortion(examId: string, pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSynevoDto>> {
        const response = await this.synevoControllerGetForExamByPortionRaw({ examId: examId, pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetForExamCountRaw(requestParameters: SynevoControllerGetForExamCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling synevoControllerGetForExamCount().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetForExamCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/forExam/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async synevoControllerGetForExamCount(examId: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.synevoControllerGetForExamCountRaw({ examId: examId, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetForExamSummaryRaw(requestParameters: SynevoControllerGetForExamSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSynevoExamCostSummaryDto>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling synevoControllerGetForExamSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/forExam/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSynevoExamCostSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async synevoControllerGetForExamSummary(examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSynevoExamCostSummaryDto> {
        const response = await this.synevoControllerGetForExamSummaryRaw({ examId: examId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetReadyByPortionRaw(requestParameters: SynevoControllerGetReadyByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSynevoDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling synevoControllerGetReadyByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling synevoControllerGetReadyByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling synevoControllerGetReadyByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling synevoControllerGetReadyByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetReadyByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/ready/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSynevoDtoFromJSON));
    }

    /**
     */
    async synevoControllerGetReadyByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSynevoDto>> {
        const response = await this.synevoControllerGetReadyByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetReadyCountRaw(requestParameters: SynevoControllerGetReadyCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetReadyCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/ready/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async synevoControllerGetReadyCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.synevoControllerGetReadyCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetWaitingByPortionRaw(requestParameters: SynevoControllerGetWaitingByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSynevoDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling synevoControllerGetWaitingByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling synevoControllerGetWaitingByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling synevoControllerGetWaitingByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling synevoControllerGetWaitingByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetWaitingByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/waiting/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSynevoDtoFromJSON));
    }

    /**
     */
    async synevoControllerGetWaitingByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSynevoDto>> {
        const response = await this.synevoControllerGetWaitingByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async synevoControllerGetWaitingCountRaw(requestParameters: SynevoControllerGetWaitingCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling synevoControllerGetWaitingCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/synevo/search/waiting/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async synevoControllerGetWaitingCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.synevoControllerGetWaitingCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async szafirControllerGetTaskListForCardRaw(requestParameters: SzafirControllerGetTaskListForCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling szafirControllerGetTaskListForCard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['documentId'] = requestParameters['documentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/szafir/get/taskListForCard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async szafirControllerGetTaskListForCard(documentId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.szafirControllerGetTaskListForCardRaw({ documentId: documentId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async szafirControllerGetTaskListForJudgmentRaw(requestParameters: SzafirControllerGetTaskListForJudgmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling szafirControllerGetTaskListForJudgment().'
            );
        }

        if (requestParameters['english'] == null) {
            throw new runtime.RequiredError(
                'english',
                'Required parameter "english" was null or undefined when calling szafirControllerGetTaskListForJudgment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['documentId'] = requestParameters['documentId'];
        }

        if (requestParameters['english'] != null) {
            queryParameters['english'] = requestParameters['english'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/szafir/get/taskList`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async szafirControllerGetTaskListForJudgment(documentId: string, english: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.szafirControllerGetTaskListForJudgmentRaw({ documentId: documentId, english: english }, initOverrides);
        return await response.value();
    }

    /**
     */
    async szafirControllerGetTaskListForJudgmentP1Raw(requestParameters: SzafirControllerGetTaskListForJudgmentP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling szafirControllerGetTaskListForJudgmentP1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['documentId'] = requestParameters['documentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/szafir/get/taskListForJudgmentP1`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async szafirControllerGetTaskListForJudgmentP1(documentId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.szafirControllerGetTaskListForJudgmentP1Raw({ documentId: documentId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async szafirControllerGetTaskListForSupportingExaminationRaw(requestParameters: SzafirControllerGetTaskListForSupportingExaminationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling szafirControllerGetTaskListForSupportingExamination().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['documentId'] = requestParameters['documentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/szafir/get/taskListForSupportingExamination`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async szafirControllerGetTaskListForSupportingExamination(documentId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.szafirControllerGetTaskListForSupportingExaminationRaw({ documentId: documentId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerCreateRaw(requestParameters: TestControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTestDto>> {
        if (requestParameters['createUpdateTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateTestDto',
                'Required parameter "createUpdateTestDto" was null or undefined when calling testControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateTestDtoToJSON(requestParameters['createUpdateTestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async testControllerCreate(createUpdateTestDto: CreateUpdateTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTestDto> {
        const response = await this.testControllerCreateRaw({ createUpdateTestDto: createUpdateTestDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerGetRaw(requestParameters: TestControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTestDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling testControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async testControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTestDto> {
        const response = await this.testControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTestDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTestDtoFromJSON));
    }

    /**
     */
    async testControllerGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTestDto>> {
        const response = await this.testControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerGetAllByNameRaw(requestParameters: TestControllerGetAllByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTestDto>>> {
        if (requestParameters['text'] == null) {
            throw new runtime.RequiredError(
                'text',
                'Required parameter "text" was null or undefined when calling testControllerGetAllByName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['text'] != null) {
            queryParameters['text'] = requestParameters['text'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test/search/byName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTestDtoFromJSON));
    }

    /**
     */
    async testControllerGetAllByName(text: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTestDto>> {
        const response = await this.testControllerGetAllByNameRaw({ text: text }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerGetAllByPortionRaw(requestParameters: TestControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTestDto>>> {
        if (requestParameters['withNotActive'] == null) {
            throw new runtime.RequiredError(
                'withNotActive',
                'Required parameter "withNotActive" was null or undefined when calling testControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling testControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling testControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling testControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling testControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling testControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['withNotActive'] != null) {
            queryParameters['withNotActive'] = requestParameters['withNotActive'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTestDtoFromJSON));
    }

    /**
     */
    async testControllerGetAllByPortion(withNotActive: boolean, pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTestDto>> {
        const response = await this.testControllerGetAllByPortionRaw({ withNotActive: withNotActive, pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerGetAllCountRaw(requestParameters: TestControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['withNotActive'] == null) {
            throw new runtime.RequiredError(
                'withNotActive',
                'Required parameter "withNotActive" was null or undefined when calling testControllerGetAllCount().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling testControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['withNotActive'] != null) {
            queryParameters['withNotActive'] = requestParameters['withNotActive'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async testControllerGetAllCount(withNotActive: boolean, filterText: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.testControllerGetAllCountRaw({ withNotActive: withNotActive, filterText: filterText }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerGetByBatteryRaw(requestParameters: TestControllerGetByBatteryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['batteryId'] == null) {
            throw new runtime.RequiredError(
                'batteryId',
                'Required parameter "batteryId" was null or undefined when calling testControllerGetByBattery().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['batteryId'] != null) {
            queryParameters['batteryId'] = requestParameters['batteryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test/get/byBattery`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async testControllerGetByBattery(batteryId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.testControllerGetByBatteryRaw({ batteryId: batteryId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerGetByIdentifierRaw(requestParameters: TestControllerGetByIdentifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTestDto>> {
        if (requestParameters['identifier'] == null) {
            throw new runtime.RequiredError(
                'identifier',
                'Required parameter "identifier" was null or undefined when calling testControllerGetByIdentifier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['identifier'] != null) {
            queryParameters['identifier'] = requestParameters['identifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test/get/byIdentifier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTestDtoFromJSON(jsonValue));
    }

    /**
     */
    async testControllerGetByIdentifier(identifier: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTestDto> {
        const response = await this.testControllerGetByIdentifierRaw({ identifier: identifier }, initOverrides);
        return await response.value();
    }

    /**
     */
    async testControllerUpdateRaw(requestParameters: TestControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling testControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateTestDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateTestDto',
                'Required parameter "createUpdateTestDto" was null or undefined when calling testControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateTestDtoToJSON(requestParameters['createUpdateTestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async testControllerUpdate(id: string, createUpdateTestDto: CreateUpdateTestDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testControllerUpdateRaw({ id: id, createUpdateTestDto: createUpdateTestDto }, initOverrides);
    }

    /**
     */
    async testGivingControllerGetExamByIdRaw(requestParameters: TestGivingControllerGetExamByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling testGivingControllerGetExamById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/testGiving/examById/byId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async testGivingControllerGetExamById(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testGivingControllerGetExamByIdRaw({ id: id }, initOverrides);
    }

    /**
     */
    async testGivingControllerGetExamByPinRaw(requestParameters: TestGivingControllerGetExamByPinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['pin'] == null) {
            throw new runtime.RequiredError(
                'pin',
                'Required parameter "pin" was null or undefined when calling testGivingControllerGetExamByPin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pin'] != null) {
            queryParameters['pin'] = requestParameters['pin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/testGiving/examByPin/byPin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async testGivingControllerGetExamByPin(pin: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testGivingControllerGetExamByPinRaw({ pin: pin }, initOverrides);
    }

    /**
     */
    async testGivingControllerGetExamByPinExamIdExternalRaw(requestParameters: TestGivingControllerGetExamByPinExamIdExternalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['pin'] == null) {
            throw new runtime.RequiredError(
                'pin',
                'Required parameter "pin" was null or undefined when calling testGivingControllerGetExamByPinExamIdExternal().'
            );
        }

        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError(
                'examId',
                'Required parameter "examId" was null or undefined when calling testGivingControllerGetExamByPinExamIdExternal().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pin'] != null) {
            queryParameters['pin'] = requestParameters['pin'];
        }

        if (requestParameters['examId'] != null) {
            queryParameters['examId'] = requestParameters['examId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/testGiving/examByPinExternal/byPinExamId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async testGivingControllerGetExamByPinExamIdExternal(pin: string, examId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testGivingControllerGetExamByPinExamIdExternalRaw({ pin: pin, examId: examId }, initOverrides);
    }

    /**
     */
    async testGivingControllerGetExamByTokenRaw(requestParameters: TestGivingControllerGetExamByTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling testGivingControllerGetExamByToken().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/testGiving/examByToken/byToken`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async testGivingControllerGetExamByToken(token: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testGivingControllerGetExamByTokenRaw({ token: token }, initOverrides);
    }

    /**
     */
    async userControllerChangeEmailRaw(requestParameters: UserControllerChangeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerChangeEmail().'
            );
        }

        if (requestParameters['createUpdateUserDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateUserDto',
                'Required parameter "createUpdateUserDto" was null or undefined when calling userControllerChangeEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/changeEmail/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateUserDtoToJSON(requestParameters['createUpdateUserDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerChangeEmail(id: string, createUpdateUserDto: CreateUpdateUserDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerChangeEmailRaw({ id: id, createUpdateUserDto: createUpdateUserDto }, initOverrides);
    }

    /**
     */
    async userControllerChangePinRaw(requestParameters: UserControllerChangePinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerChangePin().'
            );
        }

        if (requestParameters['createUpdateUserDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateUserDto',
                'Required parameter "createUpdateUserDto" was null or undefined when calling userControllerChangePin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/changePin/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateUserDtoToJSON(requestParameters['createUpdateUserDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerChangePin(id: string, createUpdateUserDto: CreateUpdateUserDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerChangePinRaw({ id: id, createUpdateUserDto: createUpdateUserDto }, initOverrides);
    }

    /**
     */
    async userControllerChangeSignP1WithSzafirRaw(requestParameters: UserControllerChangeSignP1WithSzafirRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerChangeSignP1WithSzafir().'
            );
        }

        if (requestParameters['createUpdateUserDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateUserDto',
                'Required parameter "createUpdateUserDto" was null or undefined when calling userControllerChangeSignP1WithSzafir().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/changeSignP1WithSzafir/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateUserDtoToJSON(requestParameters['createUpdateUserDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerChangeSignP1WithSzafir(id: string, createUpdateUserDto: CreateUpdateUserDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerChangeSignP1WithSzafirRaw({ id: id, createUpdateUserDto: createUpdateUserDto }, initOverrides);
    }

    /**
     */
    async userControllerCreateRaw(requestParameters: UserControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserDto>> {
        if (requestParameters['createUpdateUserDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateUserDto',
                'Required parameter "createUpdateUserDto" was null or undefined when calling userControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateUserDtoToJSON(requestParameters['createUpdateUserDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserDtoFromJSON(jsonValue));
    }

    /**
     */
    async userControllerCreate(createUpdateUserDto: CreateUpdateUserDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserDto> {
        const response = await this.userControllerCreateRaw({ createUpdateUserDto: createUpdateUserDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetRaw(requestParameters: UserControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserDtoFromJSON(jsonValue));
    }

    /**
     */
    async userControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserDto> {
        const response = await this.userControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetAllByPortionRaw(requestParameters: UserControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUserDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling userControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling userControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling userControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling userControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUserDtoFromJSON));
    }

    /**
     */
    async userControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, mode?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUserDto>> {
        const response = await this.userControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, mode: mode, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetAllByRolesRaw(requestParameters: UserControllerGetAllByRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUserDto>>> {
        if (requestParameters['roles'] == null) {
            throw new runtime.RequiredError(
                'roles',
                'Required parameter "roles" was null or undefined when calling userControllerGetAllByRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['roles'] != null) {
            queryParameters['roles'] = requestParameters['roles'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/search/byRoles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUserDtoFromJSON));
    }

    /**
     */
    async userControllerGetAllByRoles(roles: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUserDto>> {
        const response = await this.userControllerGetAllByRolesRaw({ roles: roles }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetAllCountRaw(requestParameters: UserControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling userControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async userControllerGetAllCount(filterText: string, mode?: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.userControllerGetAllCountRaw({ filterText: filterText, mode: mode, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetByEmailRaw(requestParameters: UserControllerGetByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUserPublicDto>>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling userControllerGetByEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        const response = await this.request({
            path: `/user/get/byEmail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUserPublicDtoFromJSON));
    }

    /**
     */
    async userControllerGetByEmail(email: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUserPublicDto>> {
        const response = await this.userControllerGetByEmailRaw({ email: email }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetByUidRaw(requestParameters: UserControllerGetByUidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUserDto>>> {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError(
                'uid',
                'Required parameter "uid" was null or undefined when calling userControllerGetByUid().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/get/byUid`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUserDtoFromJSON));
    }

    /**
     */
    async userControllerGetByUid(uid: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUserDto>> {
        const response = await this.userControllerGetByUidRaw({ uid: uid }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetLastEditorRaw(requestParameters: UserControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async userControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.userControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserDtoFromJSON(jsonValue));
    }

    /**
     */
    async userControllerGetMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserDto> {
        const response = await this.userControllerGetMeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerRegisterRaw(requestParameters: UserControllerRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerRegister().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/register/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerRegister(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerRegisterRaw({ id: id }, initOverrides);
    }

    /**
     */
    async userControllerSyncFirebaseClaimsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/sync-firebase-claims`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerSyncFirebaseClaims(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerSyncFirebaseClaimsRaw(initOverrides);
    }

    /**
     */
    async userControllerUpdateRaw(requestParameters: UserControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateUserDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateUserDto',
                'Required parameter "createUpdateUserDto" was null or undefined when calling userControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateUserDtoToJSON(requestParameters['createUpdateUserDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerUpdate(id: string, createUpdateUserDto: CreateUpdateUserDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerUpdateRaw({ id: id, createUpdateUserDto: createUpdateUserDto }, initOverrides);
    }

    /**
     */
    async userControllerUploadCertificateRaw(requestParameters: UserControllerUploadCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userControllerUploadCertificate().'
            );
        }

        if (requestParameters['uploadCertificateUserDto'] == null) {
            throw new runtime.RequiredError(
                'uploadCertificateUserDto',
                'Required parameter "uploadCertificateUserDto" was null or undefined when calling userControllerUploadCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/certificate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadCertificateUserDtoToJSON(requestParameters['uploadCertificateUserDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerUploadCertificate(id: string, uploadCertificateUserDto: UploadCertificateUserDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerUploadCertificateRaw({ id: id, uploadCertificateUserDto: uploadCertificateUserDto }, initOverrides);
    }

    /**
     */
    async userInHealthcareFacilityControllerCreateRaw(requestParameters: UserInHealthcareFacilityControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserInHealthcareFacilityDto>> {
        if (requestParameters['createUpdateUserInHealthcareFacilityDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateUserInHealthcareFacilityDto',
                'Required parameter "createUpdateUserInHealthcareFacilityDto" was null or undefined when calling userInHealthcareFacilityControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/userInHealthcareFacility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateUserInHealthcareFacilityDtoToJSON(requestParameters['createUpdateUserInHealthcareFacilityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserInHealthcareFacilityDtoFromJSON(jsonValue));
    }

    /**
     */
    async userInHealthcareFacilityControllerCreate(createUpdateUserInHealthcareFacilityDto: CreateUpdateUserInHealthcareFacilityDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserInHealthcareFacilityDto> {
        const response = await this.userInHealthcareFacilityControllerCreateRaw({ createUpdateUserInHealthcareFacilityDto: createUpdateUserInHealthcareFacilityDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userInHealthcareFacilityControllerGetAllRaw(requestParameters: UserInHealthcareFacilityControllerGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUserInHealthcareFacilityDto>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userInHealthcareFacilityControllerGetAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/userInHealthcareFacility/getAll/forUser`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUserInHealthcareFacilityDtoFromJSON));
    }

    /**
     */
    async userInHealthcareFacilityControllerGetAll(userId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUserInHealthcareFacilityDto>> {
        const response = await this.userInHealthcareFacilityControllerGetAllRaw({ userId: userId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async userInHealthcareFacilityControllerUpdateRaw(requestParameters: UserInHealthcareFacilityControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userInHealthcareFacilityControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateUserInHealthcareFacilityDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateUserInHealthcareFacilityDto',
                'Required parameter "createUpdateUserInHealthcareFacilityDto" was null or undefined when calling userInHealthcareFacilityControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/userInHealthcareFacility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateUserInHealthcareFacilityDtoToJSON(requestParameters['createUpdateUserInHealthcareFacilityDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userInHealthcareFacilityControllerUpdate(id: string, createUpdateUserInHealthcareFacilityDto: CreateUpdateUserInHealthcareFacilityDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userInHealthcareFacilityControllerUpdateRaw({ id: id, createUpdateUserInHealthcareFacilityDto: createUpdateUserInHealthcareFacilityDto }, initOverrides);
    }

    /**
     */
    async visitRegistrationControllerChangeToInactiveRaw(requestParameters: VisitRegistrationControllerChangeToInactiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling visitRegistrationControllerChangeToInactive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/inactivate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async visitRegistrationControllerChangeToInactive(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.visitRegistrationControllerChangeToInactiveRaw({ id: id }, initOverrides);
    }

    /**
     */
    async visitRegistrationControllerCreateRaw(requestParameters: VisitRegistrationControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVisitRegistrationDto>> {
        if (requestParameters['createUpdateVisitRegistrationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateVisitRegistrationDto',
                'Required parameter "createUpdateVisitRegistrationDto" was null or undefined when calling visitRegistrationControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateVisitRegistrationDtoToJSON(requestParameters['createUpdateVisitRegistrationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVisitRegistrationDtoFromJSON(jsonValue));
    }

    /**
     */
    async visitRegistrationControllerCreate(createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVisitRegistrationDto> {
        const response = await this.visitRegistrationControllerCreateRaw({ createUpdateVisitRegistrationDto: createUpdateVisitRegistrationDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerCreateExternalBookingRaw(requestParameters: VisitRegistrationControllerCreateExternalBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVisitRegistrationDto>> {
        if (requestParameters['createUpdateVisitRegistrationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateVisitRegistrationDto',
                'Required parameter "createUpdateVisitRegistrationDto" was null or undefined when calling visitRegistrationControllerCreateExternalBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/externalBooking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateVisitRegistrationDtoToJSON(requestParameters['createUpdateVisitRegistrationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVisitRegistrationDtoFromJSON(jsonValue));
    }

    /**
     */
    async visitRegistrationControllerCreateExternalBooking(createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVisitRegistrationDto> {
        const response = await this.visitRegistrationControllerCreateExternalBookingRaw({ createUpdateVisitRegistrationDto: createUpdateVisitRegistrationDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetRaw(requestParameters: VisitRegistrationControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVisitRegistrationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling visitRegistrationControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVisitRegistrationDtoFromJSON(jsonValue));
    }

    /**
     */
    async visitRegistrationControllerGet(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVisitRegistrationDto> {
        const response = await this.visitRegistrationControllerGetRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetAllRaw(requestParameters: VisitRegistrationControllerGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetVisitRegistrationDto>>> {
        const queryParameters: any = {};

        if (requestParameters['healthcareId'] != null) {
            queryParameters['healthcareId'] = requestParameters['healthcareId'];
        }

        if (requestParameters['dateStart'] != null) {
            queryParameters['dateStart'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['dateEnd'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetVisitRegistrationDtoFromJSON));
    }

    /**
     */
    async visitRegistrationControllerGetAll(healthcareId?: string, dateStart?: Date, dateEnd?: Date, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetVisitRegistrationDto>> {
        const response = await this.visitRegistrationControllerGetAllRaw({ healthcareId: healthcareId, dateStart: dateStart, dateEnd: dateEnd }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetAllByPortionRaw(requestParameters: VisitRegistrationControllerGetAllByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetVisitRegistrationDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling visitRegistrationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling visitRegistrationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling visitRegistrationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling visitRegistrationControllerGetAllByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling visitRegistrationControllerGetAllByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetVisitRegistrationDtoFromJSON));
    }

    /**
     */
    async visitRegistrationControllerGetAllByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetVisitRegistrationDto>> {
        const response = await this.visitRegistrationControllerGetAllByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetAllCountRaw(requestParameters: VisitRegistrationControllerGetAllCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling visitRegistrationControllerGetAllCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async visitRegistrationControllerGetAllCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.visitRegistrationControllerGetAllCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetByAppointmentChannelRaw(requestParameters: VisitRegistrationControllerGetByAppointmentChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetVisitRegistrationDto>>> {
        if (requestParameters['appointmentChannel'] == null) {
            throw new runtime.RequiredError(
                'appointmentChannel',
                'Required parameter "appointmentChannel" was null or undefined when calling visitRegistrationControllerGetByAppointmentChannel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['appointmentChannel'] != null) {
            queryParameters['appointmentChannel'] = requestParameters['appointmentChannel'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/get/byAppointmentChannel`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetVisitRegistrationDtoFromJSON));
    }

    /**
     */
    async visitRegistrationControllerGetByAppointmentChannel(appointmentChannel: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetVisitRegistrationDto>> {
        const response = await this.visitRegistrationControllerGetByAppointmentChannelRaw({ appointmentChannel: appointmentChannel }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetByHealthcareFacilityRaw(requestParameters: VisitRegistrationControllerGetByHealthcareFacilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetVisitRegistrationDto>>> {
        if (requestParameters['healthcareFacility'] == null) {
            throw new runtime.RequiredError(
                'healthcareFacility',
                'Required parameter "healthcareFacility" was null or undefined when calling visitRegistrationControllerGetByHealthcareFacility().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['healthcareFacility'] != null) {
            queryParameters['healthcareFacility'] = requestParameters['healthcareFacility'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/get/byHealthcareFacility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetVisitRegistrationDtoFromJSON));
    }

    /**
     */
    async visitRegistrationControllerGetByHealthcareFacility(healthcareFacility: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetVisitRegistrationDto>> {
        const response = await this.visitRegistrationControllerGetByHealthcareFacilityRaw({ healthcareFacility: healthcareFacility }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetExternalBookingRaw(requestParameters: VisitRegistrationControllerGetExternalBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVisitRegistrationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling visitRegistrationControllerGetExternalBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/externalBooking/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVisitRegistrationDtoFromJSON(jsonValue));
    }

    /**
     */
    async visitRegistrationControllerGetExternalBooking(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVisitRegistrationDto> {
        const response = await this.visitRegistrationControllerGetExternalBookingRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetExternalBookingByPortionRaw(requestParameters: VisitRegistrationControllerGetExternalBookingByPortionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetVisitRegistrationDto>>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling visitRegistrationControllerGetExternalBookingByPortion().'
            );
        }

        if (requestParameters['pageNumber'] == null) {
            throw new runtime.RequiredError(
                'pageNumber',
                'Required parameter "pageNumber" was null or undefined when calling visitRegistrationControllerGetExternalBookingByPortion().'
            );
        }

        if (requestParameters['orderBy'] == null) {
            throw new runtime.RequiredError(
                'orderBy',
                'Required parameter "orderBy" was null or undefined when calling visitRegistrationControllerGetExternalBookingByPortion().'
            );
        }

        if (requestParameters['orderDirection'] == null) {
            throw new runtime.RequiredError(
                'orderDirection',
                'Required parameter "orderDirection" was null or undefined when calling visitRegistrationControllerGetExternalBookingByPortion().'
            );
        }

        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling visitRegistrationControllerGetExternalBookingByPortion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDirection'] != null) {
            queryParameters['orderDirection'] = requestParameters['orderDirection'];
        }

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/externalBooking/search/byPage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetVisitRegistrationDtoFromJSON));
    }

    /**
     */
    async visitRegistrationControllerGetExternalBookingByPortion(pageSize: number, pageNumber: number, orderBy: string, orderDirection: string, filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetVisitRegistrationDto>> {
        const response = await this.visitRegistrationControllerGetExternalBookingByPortionRaw({ pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, orderDirection: orderDirection, filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetExternalBookingCalendarRaw(requestParameters: VisitRegistrationControllerGetExternalBookingCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetVisitRegistrationCalendarSlotDto>>> {
        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['dateStart'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['dateEnd'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['healthcareId'] != null) {
            queryParameters['healthcareId'] = requestParameters['healthcareId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/externalBooking/calendar`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetVisitRegistrationCalendarSlotDtoFromJSON));
    }

    /**
     */
    async visitRegistrationControllerGetExternalBookingCalendar(dateStart?: Date, dateEnd?: Date, healthcareId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetVisitRegistrationCalendarSlotDto>> {
        const response = await this.visitRegistrationControllerGetExternalBookingCalendarRaw({ dateStart: dateStart, dateEnd: dateEnd, healthcareId: healthcareId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetExternalBookingCountRaw(requestParameters: VisitRegistrationControllerGetExternalBookingCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['filterText'] == null) {
            throw new runtime.RequiredError(
                'filterText',
                'Required parameter "filterText" was null or undefined when calling visitRegistrationControllerGetExternalBookingCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterText'] != null) {
            queryParameters['filterText'] = requestParameters['filterText'];
        }

        if (requestParameters['filterColumns'] != null) {
            queryParameters['filterColumns'] = requestParameters['filterColumns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/externalBooking/search/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async visitRegistrationControllerGetExternalBookingCount(filterText: string, filterColumns?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.visitRegistrationControllerGetExternalBookingCountRaw({ filterText: filterText, filterColumns: filterColumns }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetLastEditorRaw(requestParameters: VisitRegistrationControllerGetLastEditorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastEditorDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling visitRegistrationControllerGetLastEditor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/lastEditorInfo/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastEditorDtoFromJSON(jsonValue));
    }

    /**
     */
    async visitRegistrationControllerGetLastEditor(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastEditorDto> {
        const response = await this.visitRegistrationControllerGetLastEditorRaw({ id: id }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerGetMyAppointmentChannelsRaw(requestParameters: VisitRegistrationControllerGetMyAppointmentChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAppointmentChannelDto>>> {
        const queryParameters: any = {};

        if (requestParameters['healthcareId'] != null) {
            queryParameters['healthcareId'] = requestParameters['healthcareId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/externalBooking/appointmentChannels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAppointmentChannelDtoFromJSON));
    }

    /**
     */
    async visitRegistrationControllerGetMyAppointmentChannels(healthcareId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAppointmentChannelDto>> {
        const response = await this.visitRegistrationControllerGetMyAppointmentChannelsRaw({ healthcareId: healthcareId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async visitRegistrationControllerUpdateRaw(requestParameters: VisitRegistrationControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling visitRegistrationControllerUpdate().'
            );
        }

        if (requestParameters['createUpdateVisitRegistrationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateVisitRegistrationDto',
                'Required parameter "createUpdateVisitRegistrationDto" was null or undefined when calling visitRegistrationControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateVisitRegistrationDtoToJSON(requestParameters['createUpdateVisitRegistrationDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async visitRegistrationControllerUpdate(id: string, createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.visitRegistrationControllerUpdateRaw({ id: id, createUpdateVisitRegistrationDto: createUpdateVisitRegistrationDto }, initOverrides);
    }

    /**
     */
    async visitRegistrationControllerUpdateExternalBookingRaw(requestParameters: VisitRegistrationControllerUpdateExternalBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVisitRegistrationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling visitRegistrationControllerUpdateExternalBooking().'
            );
        }

        if (requestParameters['createUpdateVisitRegistrationDto'] == null) {
            throw new runtime.RequiredError(
                'createUpdateVisitRegistrationDto',
                'Required parameter "createUpdateVisitRegistrationDto" was null or undefined when calling visitRegistrationControllerUpdateExternalBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-2FA-Session"] = await this.configuration.apiKey("X-2FA-Session"); // 2fa-session authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/visitRegistration/externalBooking/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateVisitRegistrationDtoToJSON(requestParameters['createUpdateVisitRegistrationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVisitRegistrationDtoFromJSON(jsonValue));
    }

    /**
     */
    async visitRegistrationControllerUpdateExternalBooking(id: string, createUpdateVisitRegistrationDto: CreateUpdateVisitRegistrationDto, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVisitRegistrationDto> {
        const response = await this.visitRegistrationControllerUpdateExternalBookingRaw({ id: id, createUpdateVisitRegistrationDto: createUpdateVisitRegistrationDto }, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const AttachmentControllerRunAttachmentMigrationFilterTypeEnum = {
    file: 'file',
    scan: 'scan',
    both: 'both'
} as const;
export type AttachmentControllerRunAttachmentMigrationFilterTypeEnum = typeof AttachmentControllerRunAttachmentMigrationFilterTypeEnum[keyof typeof AttachmentControllerRunAttachmentMigrationFilterTypeEnum];
/**
 * @export
 */
export const ExamControllerGetBlockedByPortionTypeEnum = {
    Doctor: 'Doctor',
    Psychologist: 'Psychologist',
    Ophthalmologist: 'Ophthalmologist',
    Neurologist: 'Neurologist',
    Psychiatrist: 'Psychiatrist',
    Laryngologist: 'Laryngologist'
} as const;
export type ExamControllerGetBlockedByPortionTypeEnum = typeof ExamControllerGetBlockedByPortionTypeEnum[keyof typeof ExamControllerGetBlockedByPortionTypeEnum];
/**
 * @export
 */
export const ExamControllerGetBlockedCountTypeEnum = {
    Doctor: 'Doctor',
    Psychologist: 'Psychologist',
    Ophthalmologist: 'Ophthalmologist',
    Neurologist: 'Neurologist',
    Psychiatrist: 'Psychiatrist',
    Laryngologist: 'Laryngologist'
} as const;
export type ExamControllerGetBlockedCountTypeEnum = typeof ExamControllerGetBlockedCountTypeEnum[keyof typeof ExamControllerGetBlockedCountTypeEnum];
